var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _polygon, _path196;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf",
    "data-name": "Unbenannter Verlauf",
    cx: -3698.34,
    cy: 3330.255,
    fx: -3698.34,
    fy: 3330.255,
    r: 0.334,
    gradientTransform: "translate(577.805 -489.374) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_2",
    "data-name": "Unbenannter Verlauf 2",
    cx: -3697.647,
    cy: 3332.378,
    fx: -3697.647,
    fy: 3332.378,
    r: 0.225,
    gradientTransform: "translate(577.805 -489.346) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_3",
    "data-name": "Unbenannter Verlauf 3",
    cx: -3698.339,
    cy: 3270.955,
    fx: -3698.339,
    fy: 3270.955,
    r: 0.223,
    gradientTransform: "translate(577.805 -490.227) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_4",
    "data-name": "Unbenannter Verlauf 4",
    cx: -3699.036,
    cy: 3322.538,
    fx: -3699.036,
    fy: 3322.538,
    r: 0.225,
    gradientTransform: "translate(577.805 -489.492) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_5",
    "data-name": "Unbenannter Verlauf 5",
    cx: -3698.344,
    cy: 3276.783,
    fx: -3698.344,
    fy: 3276.783,
    r: 0.223,
    gradientTransform: "translate(577.805 -490.071) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_6",
    "data-name": "Unbenannter Verlauf 6",
    cx: 5350.06,
    cy: 3307.955,
    fx: 5350.06,
    fy: 3307.955,
    r: 0.361,
    gradientTransform: "translate(830.254 -489.958) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_7",
    "data-name": "Unbenannter Verlauf 7",
    cx: 5349.198,
    cy: 3309.336,
    fx: 5349.198,
    fy: 3309.336,
    r: 0.361,
    gradientTransform: "translate(830.254 -490.175) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_8",
    "data-name": "Unbenannter Verlauf 8",
    cx: 5348.347,
    cy: 3307.955,
    fx: 5348.347,
    fy: 3307.955,
    r: 0.361,
    gradientTransform: "translate(830.254 -489.958) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_9",
    "data-name": "Unbenannter Verlauf 9",
    cx: 5350.374,
    cy: 3315.293,
    fx: 5350.374,
    fy: 3315.293,
    r: 0.361,
    gradientTransform: "translate(830.254 -489.948) rotate(-180) scale(.154 -.152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_10",
    "data-name": "Unbenannter Verlauf 10",
    cx: 5349.524,
    cy: 3315.293,
    fx: 5349.524,
    fy: 3315.293,
    r: 0.361,
    gradientTransform: "translate(830.254 -489.948) rotate(-180) scale(.154 -.152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_11",
    "data-name": "Unbenannter Verlauf 11",
    cx: 5348.667,
    cy: 3315.293,
    fx: 5348.667,
    fy: 3315.293,
    r: 0.361,
    gradientTransform: "translate(830.254 -489.948) rotate(-180) scale(.154 -.152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_12",
    "data-name": "Unbenannter Verlauf 12",
    cx: 5350.409,
    cy: 3309.163,
    fx: 5350.409,
    fy: 3309.163,
    r: 0.361,
    gradientTransform: "translate(830.254 -489.902) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_13",
    "data-name": "Unbenannter Verlauf 13",
    cx: 5349.605,
    cy: 3309.14,
    fx: 5349.605,
    fy: 3309.14,
    r: 0.361,
    gradientTransform: "translate(830.254 -489.903) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_14",
    "data-name": "Unbenannter Verlauf 14",
    cx: 5348.749,
    cy: 3309.14,
    fx: 5348.749,
    fy: 3309.14,
    r: 0.361,
    gradientTransform: "translate(830.254 -489.903) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_15",
    "data-name": "Unbenannter Verlauf 15",
    cx: 5350.284,
    cy: 3322.59,
    fx: 5350.284,
    fy: 3322.59,
    r: 0.341,
    gradientTransform: "translate(830.254 -489.874) rotate(-180) scale(.154 -.152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_16",
    "data-name": "Unbenannter Verlauf 16",
    cx: 5349.481,
    cy: 3312.075,
    fx: 5349.481,
    fy: 3312.075,
    r: 0.341,
    gradientTransform: "translate(830.254 -489.875) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_17",
    "data-name": "Unbenannter Verlauf 17",
    cx: 5348.671,
    cy: 3323.126,
    fx: 5348.671,
    fy: 3323.126,
    r: 0.342,
    gradientTransform: "translate(830.254 -489.882) rotate(-180) scale(.154 -.152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_18",
    "data-name": "Unbenannter Verlauf 18",
    cx: 5350.101,
    cy: 3311.39,
    fx: 5350.101,
    fy: 3311.39,
    r: 0.326,
    gradientTransform: "translate(830.254 -489.847) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_19",
    "data-name": "Unbenannter Verlauf 19",
    cx: 5349.369,
    cy: 3313.4,
    fx: 5349.369,
    fy: 3313.4,
    r: 0.326,
    gradientTransform: "translate(830.254 -489.854) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_20",
    "data-name": "Unbenannter Verlauf 20",
    cx: 5348.595,
    cy: 3311.299,
    fx: 5348.595,
    fy: 3311.299,
    r: 0.326,
    gradientTransform: "translate(830.254 -489.851) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_21",
    "data-name": "Unbenannter Verlauf 21",
    cx: 5349.801,
    cy: 3323.598,
    fx: 5349.801,
    fy: 3323.598,
    r: 0.314,
    gradientTransform: "translate(830.254 -489.79) rotate(-180) scale(.154 -.152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_22",
    "data-name": "Unbenannter Verlauf 22",
    cx: 5349.133,
    cy: 3290.536,
    fx: 5349.133,
    fy: 3290.536,
    r: 0.298,
    gradientTransform: "translate(830.254 -489.86) rotate(-180) scale(.154 -.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_23",
    "data-name": "Unbenannter Verlauf 23",
    cx: 5348.426,
    cy: 3296.407,
    fx: 5348.426,
    fy: 3296.407,
    r: 0.243,
    gradientTransform: "translate(830.254 -489.841) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_24",
    "data-name": "Unbenannter Verlauf 24",
    cx: 5349.501,
    cy: 3291.26,
    fx: 5349.501,
    fy: 3291.26,
    r: 0.298,
    gradientTransform: "translate(830.254 -489.856) rotate(-180) scale(.154 -.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_25",
    "data-name": "Unbenannter Verlauf 25",
    cx: 5348.857,
    cy: 3265.927,
    fx: 5348.857,
    fy: 3265.927,
    r: 0.25,
    gradientTransform: "translate(830.254 -489.912) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_26",
    "data-name": "Unbenannter Verlauf 26",
    cx: 5348.26,
    cy: 3300.186,
    fx: 5348.26,
    fy: 3300.186,
    r: 0.211,
    gradientTransform: "translate(830.254 -489.827) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_27",
    "data-name": "Unbenannter Verlauf 27",
    cx: 5349.193,
    cy: 3294.779,
    fx: 5349.193,
    fy: 3294.779,
    r: 0.28,
    gradientTransform: "translate(830.254 -489.833) rotate(-180) scale(.154 -.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_28",
    "data-name": "Unbenannter Verlauf 28",
    cx: 5348.633,
    cy: 3269.678,
    fx: 5348.633,
    fy: 3269.678,
    r: 0.234,
    gradientTransform: "translate(830.254 -489.908) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_29",
    "data-name": "Unbenannter Verlauf 29",
    cx: 5348.098,
    cy: 3296.279,
    fx: 5348.098,
    fy: 3296.279,
    r: 0.199,
    gradientTransform: "translate(830.254 -489.824) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_30",
    "data-name": "Unbenannter Verlauf 30",
    cx: 5348.796,
    cy: 3281.538,
    fx: 5348.796,
    fy: 3281.538,
    r: 0.259,
    gradientTransform: "translate(830.254 -489.893) rotate(-180) scale(.154 -.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_31",
    "data-name": "Unbenannter Verlauf 31",
    cx: 5348.31,
    cy: 3292.721,
    fx: 5348.31,
    fy: 3292.721,
    r: 0.219,
    gradientTransform: "translate(830.254 -489.835) rotate(-180) scale(.154 -.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_32",
    "data-name": "Unbenannter Verlauf 32",
    cx: 5347.845,
    cy: 3266.796,
    fx: 5347.845,
    fy: 3266.796,
    r: 0.183,
    gradientTransform: "translate(830.254 -489.937) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_33",
    "data-name": "Unbenannter Verlauf 33",
    cx: 5348.465,
    cy: 3317.757,
    fx: 5348.465,
    fy: 3317.757,
    r: 0.238,
    gradientTransform: "translate(830.254 -489.72) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_34",
    "data-name": "Unbenannter Verlauf 34",
    cx: 5348.051,
    cy: 3248.678,
    fx: 5348.051,
    fy: 3248.678,
    r: 0.198,
    gradientTransform: "translate(830.254 -490.045) rotate(-180) scale(.154 -.156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_35",
    "data-name": "Unbenannter Verlauf 35",
    cx: 5347.649,
    cy: 3272.629,
    fx: 5347.649,
    fy: 3272.629,
    r: 0.169,
    gradientTransform: "translate(830.254 -489.925) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_36",
    "data-name": "Unbenannter Verlauf 36",
    cx: 5348.071,
    cy: 3259.31,
    fx: 5348.071,
    fy: 3259.31,
    r: 0.202,
    gradientTransform: "translate(830.254 -490.023) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_37",
    "data-name": "Unbenannter Verlauf 37",
    cx: 5347.731,
    cy: 3271.664,
    fx: 5347.731,
    fy: 3271.664,
    r: 0.171,
    gradientTransform: "translate(830.254 -489.952) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_38",
    "data-name": "Unbenannter Verlauf 38",
    cx: 5347.398,
    cy: 3213.589,
    fx: 5347.398,
    fy: 3213.589,
    r: 0.143,
    gradientTransform: "translate(830.254 -490.234) rotate(-180) scale(.154 -.158)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_39",
    "data-name": "Unbenannter Verlauf 39",
    cx: 5347.725,
    cy: 3265.696,
    fx: 5347.725,
    fy: 3265.696,
    r: 0.188,
    gradientTransform: "translate(830.254 -490.007) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_40",
    "data-name": "Unbenannter Verlauf 40",
    cx: 5347.443,
    cy: 3237.331,
    fx: 5347.443,
    fy: 3237.331,
    r: 0.159,
    gradientTransform: "translate(830.254 -490.15) rotate(-180) scale(.154 -.156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_41",
    "data-name": "Unbenannter Verlauf 41",
    cx: 5347.16,
    cy: 3263.098,
    fx: 5347.16,
    fy: 3263.098,
    r: 0.135,
    gradientTransform: "translate(830.254 -489.996) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_42",
    "data-name": "Unbenannter Verlauf 42",
    cx: 5347.391,
    cy: 3272.444,
    fx: 5347.391,
    fy: 3272.444,
    r: 0.189,
    gradientTransform: "translate(830.254 -489.976) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_43",
    "data-name": "Unbenannter Verlauf 43",
    cx: 5347.109,
    cy: 3257.55,
    fx: 5347.109,
    fy: 3257.55,
    r: 0.159,
    gradientTransform: "translate(830.254 -490.049) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_44",
    "data-name": "Unbenannter Verlauf 44",
    cx: 5346.881,
    cy: 3238.112,
    fx: 5346.881,
    fy: 3238.112,
    r: 0.135,
    gradientTransform: "translate(830.254 -490.162) rotate(-180) scale(.154 -.156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_45",
    "data-name": "Unbenannter Verlauf 45",
    cx: 5346.624,
    cy: 3218.103,
    fx: 5346.624,
    fy: 3218.103,
    r: 0.124,
    gradientTransform: "translate(830.254 -490.314) rotate(-180) scale(.154 -.157)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_46",
    "data-name": "Unbenannter Verlauf 46",
    cx: 5346.834,
    cy: 3273.88,
    fx: 5346.834,
    fy: 3273.88,
    r: 0.135,
    gradientTransform: "translate(830.254 -489.964) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_47",
    "data-name": "Unbenannter Verlauf 47",
    cx: 5347.061,
    cy: 3238.377,
    fx: 5347.061,
    fy: 3238.377,
    r: 0.145,
    gradientTransform: "translate(830.254 -490.227) rotate(-180) scale(.154 -.156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_48",
    "data-name": "Unbenannter Verlauf 48",
    cx: 5346.354,
    cy: 3256.51,
    fx: 5346.354,
    fy: 3256.51,
    r: 0.116,
    gradientTransform: "translate(830.254 -490.077) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_49",
    "data-name": "Unbenannter Verlauf 49",
    cx: 5346.522,
    cy: 3248.427,
    fx: 5346.522,
    fy: 3248.427,
    r: 0.124,
    gradientTransform: "translate(830.254 -490.158) rotate(-180) scale(.154 -.156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_50",
    "data-name": "Unbenannter Verlauf 50",
    cx: 5346.726,
    cy: 3268.7,
    fx: 5346.726,
    fy: 3268.7,
    r: 0.132,
    gradientTransform: "translate(830.254 -490.018) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_51",
    "data-name": "Unbenannter Verlauf 51",
    cx: 5346.094,
    cy: 3208.992,
    fx: 5346.094,
    fy: 3208.992,
    r: 0.105,
    gradientTransform: "translate(830.254 -490.431) rotate(-180) scale(.154 -.158)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_52",
    "data-name": "Unbenannter Verlauf 52",
    cx: 5346.244,
    cy: 3226.614,
    fx: 5346.244,
    fy: 3226.614,
    r: 0.116,
    gradientTransform: "translate(830.254 -490.333) rotate(-180) scale(.154 -.157)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_53",
    "data-name": "Unbenannter Verlauf 53",
    cx: 5346.431,
    cy: 3195.117,
    fx: 5346.431,
    fy: 3195.117,
    r: 0.121,
    gradientTransform: "translate(830.254 -490.625) rotate(-180) scale(.154 -.159)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_54",
    "data-name": "Unbenannter Verlauf 54",
    cx: 5345.874,
    cy: 3241.127,
    fx: 5345.874,
    fy: 3241.127,
    r: 0.102,
    gradientTransform: "translate(830.254 -490.225) rotate(-180) scale(.154 -.156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_55",
    "data-name": "Unbenannter Verlauf 55",
    cx: 5346.011,
    cy: 3233.003,
    fx: 5346.011,
    fy: 3233.003,
    r: 0.109,
    gradientTransform: "translate(830.254 -490.29) rotate(-180) scale(.154 -.157)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_56",
    "data-name": "Unbenannter Verlauf 56",
    cx: 5346.141,
    cy: 3190.639,
    fx: 5346.141,
    fy: 3190.639,
    r: 0.117,
    gradientTransform: "translate(830.254 -490.673) rotate(-180) scale(.154 -.159)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_57",
    "data-name": "Unbenannter Verlauf 57",
    cx: 5345.665,
    cy: 3260.973,
    fx: 5345.665,
    fy: 3260.973,
    r: 0.092,
    gradientTransform: "translate(830.254 -490.084) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_58",
    "data-name": "Unbenannter Verlauf 58",
    cx: 5345.774,
    cy: 3242.767,
    fx: 5345.774,
    fy: 3242.767,
    r: 0.098,
    gradientTransform: "translate(830.254 -490.233) rotate(-180) scale(.154 -.156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_59",
    "data-name": "Unbenannter Verlauf 59",
    cx: 5345.881,
    cy: 3275.384,
    fx: 5345.881,
    fy: 3275.384,
    r: 0.104,
    gradientTransform: "translate(830.254 -489.988) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_60",
    "data-name": "Unbenannter Verlauf 60",
    cx: 5345.444,
    cy: 3275.968,
    fx: 5345.444,
    fy: 3275.968,
    r: 0.088,
    gradientTransform: "translate(830.254 -489.977) rotate(-180) scale(.154 -.155)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_61",
    "data-name": "Unbenannter Verlauf 61",
    cx: 5345.522,
    cy: 3234.31,
    fx: 5345.522,
    fy: 3234.31,
    r: 0.094,
    gradientTransform: "translate(830.254 -490.319) rotate(-180) scale(.154 -.157)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_62",
    "data-name": "Unbenannter Verlauf 62",
    cx: 5345.632,
    cy: 3243.902,
    fx: 5345.632,
    fy: 3243.902,
    r: 0.101,
    gradientTransform: "translate(830.254 -490.259) rotate(-180) scale(.154 -.156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_63",
    "data-name": "Unbenannter Verlauf 63",
    cx: 5345.244,
    cy: 3210.626,
    fx: 5345.244,
    fy: 3210.626,
    r: 0.075,
    gradientTransform: "translate(830.254 -490.504) rotate(-180) scale(.154 -.158)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_64",
    "data-name": "Unbenannter Verlauf 64",
    cx: 5345.303,
    cy: 3327.106,
    fx: 5345.303,
    fy: 3327.106,
    r: 0.082,
    gradientTransform: "translate(830.254 -489.576) rotate(-180) scale(.154 -.152)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_65",
    "data-name": "Unbenannter Verlauf 65",
    cx: 5345.386,
    cy: 3283.59,
    fx: 5345.386,
    fy: 3283.59,
    r: 0.087,
    gradientTransform: "translate(830.254 -489.917) rotate(-180) scale(.154 -.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_66",
    "data-name": "Unbenannter Verlauf 66",
    cx: 5346.102,
    cy: 3293.445,
    fx: 5346.102,
    fy: 3293.445,
    r: 0.243,
    gradientTransform: "translate(829.982 -489.7) rotate(-180) scale(.154 -.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_67",
    "data-name": "Unbenannter Verlauf 67",
    cx: -3687.572,
    cy: 3307.955,
    fx: -3687.572,
    fy: 3307.955,
    r: 0.361,
    gradientTransform: "translate(577.734 -489.958) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_68",
    "data-name": "Unbenannter Verlauf 68",
    cx: -3688.433,
    cy: 3309.336,
    fx: -3688.433,
    fy: 3309.336,
    r: 0.361,
    gradientTransform: "translate(577.734 -490.175) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_69",
    "data-name": "Unbenannter Verlauf 69",
    cx: -3689.284,
    cy: 3307.955,
    fx: -3689.284,
    fy: 3307.955,
    r: 0.361,
    gradientTransform: "translate(577.734 -489.958) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_70",
    "data-name": "Unbenannter Verlauf 70",
    cx: -3687.257,
    cy: 3315.293,
    fx: -3687.257,
    fy: 3315.293,
    r: 0.361,
    gradientTransform: "translate(577.734 -489.948) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_71",
    "data-name": "Unbenannter Verlauf 71",
    cx: -3688.107,
    cy: 3315.293,
    fx: -3688.107,
    fy: 3315.293,
    r: 0.361,
    gradientTransform: "translate(577.734 -489.948) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_72",
    "data-name": "Unbenannter Verlauf 72",
    cx: -3688.963,
    cy: 3315.293,
    fx: -3688.963,
    fy: 3315.293,
    r: 0.361,
    gradientTransform: "translate(577.734 -489.948) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_73",
    "data-name": "Unbenannter Verlauf 73",
    cx: -3687.222,
    cy: 3309.163,
    fx: -3687.222,
    fy: 3309.163,
    r: 0.361,
    gradientTransform: "translate(577.734 -489.902) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_74",
    "data-name": "Unbenannter Verlauf 74",
    cx: -3688.026,
    cy: 3309.14,
    fx: -3688.026,
    fy: 3309.14,
    r: 0.361,
    gradientTransform: "translate(577.734 -489.903) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_75",
    "data-name": "Unbenannter Verlauf 75",
    cx: -3688.882,
    cy: 3309.14,
    fx: -3688.882,
    fy: 3309.14,
    r: 0.361,
    gradientTransform: "translate(577.734 -489.903) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_76",
    "data-name": "Unbenannter Verlauf 76",
    cx: -3687.346,
    cy: 3322.59,
    fx: -3687.346,
    fy: 3322.59,
    r: 0.341,
    gradientTransform: "translate(577.734 -489.874) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_77",
    "data-name": "Unbenannter Verlauf 77",
    cx: -3688.149,
    cy: 3312.075,
    fx: -3688.149,
    fy: 3312.075,
    r: 0.341,
    gradientTransform: "translate(577.734 -489.875) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_78",
    "data-name": "Unbenannter Verlauf 78",
    cx: -3688.96,
    cy: 3323.126,
    fx: -3688.96,
    fy: 3323.126,
    r: 0.342,
    gradientTransform: "translate(577.734 -489.882) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_79",
    "data-name": "Unbenannter Verlauf 79",
    cx: -3687.53,
    cy: 3311.39,
    fx: -3687.53,
    fy: 3311.39,
    r: 0.326,
    gradientTransform: "translate(577.734 -489.847) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_80",
    "data-name": "Unbenannter Verlauf 80",
    cx: -3688.262,
    cy: 3313.4,
    fx: -3688.262,
    fy: 3313.4,
    r: 0.326,
    gradientTransform: "translate(577.734 -489.854) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_81",
    "data-name": "Unbenannter Verlauf 81",
    cx: -3689.036,
    cy: 3311.299,
    fx: -3689.036,
    fy: 3311.299,
    r: 0.326,
    gradientTransform: "translate(577.734 -489.851) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_82",
    "data-name": "Unbenannter Verlauf 82",
    cx: -3687.831,
    cy: 3323.598,
    fx: -3687.831,
    fy: 3323.598,
    r: 0.314,
    gradientTransform: "translate(577.734 -489.79) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_83",
    "data-name": "Unbenannter Verlauf 83",
    cx: -3688.497,
    cy: 3290.536,
    fx: -3688.497,
    fy: 3290.536,
    r: 0.298,
    gradientTransform: "translate(577.734 -489.86) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_84",
    "data-name": "Unbenannter Verlauf 84",
    cx: -3689.205,
    cy: 3296.407,
    fx: -3689.205,
    fy: 3296.407,
    r: 0.243,
    gradientTransform: "translate(577.734 -489.841) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_85",
    "data-name": "Unbenannter Verlauf 85",
    cx: -3688.13,
    cy: 3291.26,
    fx: -3688.13,
    fy: 3291.26,
    r: 0.298,
    gradientTransform: "translate(577.734 -489.856) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_86",
    "data-name": "Unbenannter Verlauf 86",
    cx: -3688.774,
    cy: 3265.927,
    fx: -3688.774,
    fy: 3265.927,
    r: 0.25,
    gradientTransform: "translate(577.734 -489.912) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_87",
    "data-name": "Unbenannter Verlauf 87",
    cx: -3689.371,
    cy: 3300.186,
    fx: -3689.371,
    fy: 3300.186,
    r: 0.211,
    gradientTransform: "translate(577.734 -489.827) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_88",
    "data-name": "Unbenannter Verlauf 88",
    cx: -3688.438,
    cy: 3294.779,
    fx: -3688.438,
    fy: 3294.779,
    r: 0.28,
    gradientTransform: "translate(577.734 -489.833) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_89",
    "data-name": "Unbenannter Verlauf 89",
    cx: -3688.998,
    cy: 3269.678,
    fx: -3688.998,
    fy: 3269.678,
    r: 0.234,
    gradientTransform: "translate(577.734 -489.908) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_90",
    "data-name": "Unbenannter Verlauf 90",
    cx: -3689.533,
    cy: 3296.279,
    fx: -3689.533,
    fy: 3296.279,
    r: 0.199,
    gradientTransform: "translate(577.734 -489.824) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_91",
    "data-name": "Unbenannter Verlauf 91",
    cx: -3688.835,
    cy: 3281.538,
    fx: -3688.835,
    fy: 3281.538,
    r: 0.259,
    gradientTransform: "translate(577.734 -489.893) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_92",
    "data-name": "Unbenannter Verlauf 92",
    cx: -3689.321,
    cy: 3292.721,
    fx: -3689.321,
    fy: 3292.721,
    r: 0.219,
    gradientTransform: "translate(577.734 -489.835) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_93",
    "data-name": "Unbenannter Verlauf 93",
    cx: -3689.786,
    cy: 3266.796,
    fx: -3689.786,
    fy: 3266.796,
    r: 0.183,
    gradientTransform: "translate(577.734 -489.937) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_94",
    "data-name": "Unbenannter Verlauf 94",
    cx: -3689.166,
    cy: 3317.757,
    fx: -3689.166,
    fy: 3317.757,
    r: 0.238,
    gradientTransform: "translate(577.734 -489.72) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_95",
    "data-name": "Unbenannter Verlauf 95",
    cx: -3689.58,
    cy: 3248.678,
    fx: -3689.58,
    fy: 3248.678,
    r: 0.198,
    gradientTransform: "translate(577.734 -490.045) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_96",
    "data-name": "Unbenannter Verlauf 96",
    cx: -3689.982,
    cy: 3272.629,
    fx: -3689.982,
    fy: 3272.629,
    r: 0.169,
    gradientTransform: "translate(577.734 -489.925) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_97",
    "data-name": "Unbenannter Verlauf 97",
    cx: -3689.56,
    cy: 3259.31,
    fx: -3689.56,
    fy: 3259.31,
    r: 0.202,
    gradientTransform: "translate(577.734 -490.023) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_98",
    "data-name": "Unbenannter Verlauf 98",
    cx: -3689.9,
    cy: 3271.664,
    fx: -3689.9,
    fy: 3271.664,
    r: 0.171,
    gradientTransform: "translate(577.734 -489.952) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_99",
    "data-name": "Unbenannter Verlauf 99",
    cx: -3690.233,
    cy: 3213.589,
    fx: -3690.233,
    fy: 3213.589,
    r: 0.143,
    gradientTransform: "translate(577.734 -490.234) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_100",
    "data-name": "Unbenannter Verlauf 100",
    cx: -3689.906,
    cy: 3265.696,
    fx: -3689.906,
    fy: 3265.696,
    r: 0.188,
    gradientTransform: "translate(577.734 -490.007) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_101",
    "data-name": "Unbenannter Verlauf 101",
    cx: -3690.188,
    cy: 3237.331,
    fx: -3690.188,
    fy: 3237.331,
    r: 0.159,
    gradientTransform: "translate(577.734 -490.15) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_102",
    "data-name": "Unbenannter Verlauf 102",
    cx: -3690.471,
    cy: 3263.098,
    fx: -3690.471,
    fy: 3263.098,
    r: 0.135,
    gradientTransform: "translate(577.734 -489.996) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_103",
    "data-name": "Unbenannter Verlauf 103",
    cx: -3690.24,
    cy: 3272.444,
    fx: -3690.24,
    fy: 3272.444,
    r: 0.189,
    gradientTransform: "translate(577.734 -489.976) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_104",
    "data-name": "Unbenannter Verlauf 104",
    cx: -3690.522,
    cy: 3257.55,
    fx: -3690.522,
    fy: 3257.55,
    r: 0.159,
    gradientTransform: "translate(577.734 -490.049) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_105",
    "data-name": "Unbenannter Verlauf 105",
    cx: -3690.75,
    cy: 3238.112,
    fx: -3690.75,
    fy: 3238.112,
    r: 0.135,
    gradientTransform: "translate(577.734 -490.162) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_106",
    "data-name": "Unbenannter Verlauf 106",
    cx: -3691.007,
    cy: 3218.103,
    fx: -3691.007,
    fy: 3218.103,
    r: 0.124,
    gradientTransform: "translate(577.734 -490.314) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_107",
    "data-name": "Unbenannter Verlauf 107",
    cx: -3690.797,
    cy: 3273.88,
    fx: -3690.797,
    fy: 3273.88,
    r: 0.135,
    gradientTransform: "translate(577.734 -489.964) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_108",
    "data-name": "Unbenannter Verlauf 108",
    cx: -3690.57,
    cy: 3238.377,
    fx: -3690.57,
    fy: 3238.377,
    r: 0.145,
    gradientTransform: "translate(577.734 -490.227) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_109",
    "data-name": "Unbenannter Verlauf 109",
    cx: -3691.277,
    cy: 3256.51,
    fx: -3691.277,
    fy: 3256.51,
    r: 0.116,
    gradientTransform: "translate(577.734 -490.077) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_110",
    "data-name": "Unbenannter Verlauf 110",
    cx: -3691.109,
    cy: 3248.427,
    fx: -3691.109,
    fy: 3248.427,
    r: 0.124,
    gradientTransform: "translate(577.734 -490.158) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_111",
    "data-name": "Unbenannter Verlauf 111",
    cx: -3690.905,
    cy: 3268.7,
    fx: -3690.905,
    fy: 3268.7,
    r: 0.132,
    gradientTransform: "translate(577.734 -490.018) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_112",
    "data-name": "Unbenannter Verlauf 112",
    cx: -3691.537,
    cy: 3208.992,
    fx: -3691.537,
    fy: 3208.992,
    r: 0.105,
    gradientTransform: "translate(577.734 -490.431) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_113",
    "data-name": "Unbenannter Verlauf 113",
    cx: -3691.386,
    cy: 3226.614,
    fx: -3691.386,
    fy: 3226.614,
    r: 0.116,
    gradientTransform: "translate(577.734 -490.333) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_114",
    "data-name": "Unbenannter Verlauf 114",
    cx: -3691.2,
    cy: 3195.117,
    fx: -3691.2,
    fy: 3195.117,
    r: 0.121,
    gradientTransform: "translate(577.734 -490.625) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_115",
    "data-name": "Unbenannter Verlauf 115",
    cx: -3691.757,
    cy: 3241.127,
    fx: -3691.757,
    fy: 3241.127,
    r: 0.102,
    gradientTransform: "translate(577.734 -490.225) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_116",
    "data-name": "Unbenannter Verlauf 116",
    cx: -3691.62,
    cy: 3233.003,
    fx: -3691.62,
    fy: 3233.003,
    r: 0.109,
    gradientTransform: "translate(577.734 -490.29) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_117",
    "data-name": "Unbenannter Verlauf 117",
    cx: -3691.49,
    cy: 3190.639,
    fx: -3691.49,
    fy: 3190.639,
    r: 0.117,
    gradientTransform: "translate(577.734 -490.673) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_118",
    "data-name": "Unbenannter Verlauf 118",
    cx: -3691.966,
    cy: 3260.973,
    fx: -3691.966,
    fy: 3260.973,
    r: 0.092,
    gradientTransform: "translate(577.734 -490.084) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_119",
    "data-name": "Unbenannter Verlauf 119",
    cx: -3691.857,
    cy: 3242.767,
    fx: -3691.857,
    fy: 3242.767,
    r: 0.098,
    gradientTransform: "translate(577.734 -490.233) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_120",
    "data-name": "Unbenannter Verlauf 120",
    cx: -3691.75,
    cy: 3275.384,
    fx: -3691.75,
    fy: 3275.384,
    r: 0.104,
    gradientTransform: "translate(577.734 -489.988) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_121",
    "data-name": "Unbenannter Verlauf 121",
    cx: -3692.187,
    cy: 3275.968,
    fx: -3692.187,
    fy: 3275.968,
    r: 0.088,
    gradientTransform: "translate(577.734 -489.977) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_122",
    "data-name": "Unbenannter Verlauf 122",
    cx: -3692.109,
    cy: 3234.31,
    fx: -3692.109,
    fy: 3234.31,
    r: 0.094,
    gradientTransform: "translate(577.734 -490.319) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_123",
    "data-name": "Unbenannter Verlauf 123",
    cx: -3691.999,
    cy: 3243.902,
    fx: -3691.999,
    fy: 3243.902,
    r: 0.101,
    gradientTransform: "translate(577.734 -490.259) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_124",
    "data-name": "Unbenannter Verlauf 124",
    cx: -3692.387,
    cy: 3210.626,
    fx: -3692.387,
    fy: 3210.626,
    r: 0.075,
    gradientTransform: "translate(577.734 -490.504) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_125",
    "data-name": "Unbenannter Verlauf 125",
    cx: -3692.328,
    cy: 3327.106,
    fx: -3692.328,
    fy: 3327.106,
    r: 0.082,
    gradientTransform: "translate(577.734 -489.576) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_126",
    "data-name": "Unbenannter Verlauf 126",
    cx: -3692.245,
    cy: 3283.59,
    fx: -3692.245,
    fy: 3283.59,
    r: 0.087,
    gradientTransform: "translate(577.734 -489.917) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_127",
    "data-name": "Unbenannter Verlauf 127",
    cx: -3691.529,
    cy: 3293.445,
    fx: -3691.529,
    fy: 3293.445,
    r: 0.243,
    gradientTransform: "translate(578.006 -489.7) scale(.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8e32"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,6h30v18H0V6Z",
    style: {
      fill: "#001489"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9h30v12H0v-12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12h30v6H0v-6Z",
    style: {
      fill: "#da291c"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 15,
    rx: 2.25,
    ry: 2.625,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.564,14.646l.051-.093-.12-.033-.037.083.106.043ZM10.435,14.646l-.051-.093.12-.033.037.083-.106.043Z",
    style: {
      fill: "#cea849"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.435,14.653s-.005,0-.006-.004l-.051-.093s-.001-.004,0-.006.002-.003.005-.004l.12-.033s.007,0,.008.004l.037.083s.001.004,0,.005c-.001.002-.002.003-.004.004l-.106.044h-.003ZM10.395,14.557l.044.08.094-.039-.032-.071-.106.03ZM7.564,14.653s-.002,0-.003,0l-.106-.044s-.003-.002-.004-.004c0-.002,0-.004,0-.005l.037-.083s.005-.005.008-.004l.12.033s.004.002.005.004,0,.004,0,.006l-.051.095s-.003.003-.006.003ZM7.467,14.599l.094.039.044-.08-.106-.029-.032.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.968,13.456l-.185.005c-.118.011-.163.057-.09.143-.19.03-.377.073-.549.164-.048-.008-.105.019-.121.066-.013.038.019.078.078.062-.039.101-.494.09-.505.259.034-.029.072-.054.11-.029l-.026.079c-.066.02-.113.031-.141.103-.029.073-.07.184-.098.238-.019.025-.023.052-.023.065,0,.031.022.075.074.075.053,0,.079-.033.079-.066-.003-.023-.012-.05-.068-.047.094-.022.175.009.229.044.075.056.094.163.05.252-.043.086-.152.136-.315.073-.133-.052-.266.016-.31.134-.2.541.15.979.545,1.235.412.266.485.339.596.469s.219.279.38.279c.025,0,.049-.007.071-.019.101,0,.108.038.244.04h.014c.136-.002.143-.04.244-.04.022.012.046.019.071.019.161,0,.269-.149.38-.279.11-.13.184-.203.596-.469.396-.256.745-.694.545-1.235-.044-.118-.177-.187-.31-.134-.163.064-.272.013-.315-.073-.044-.089-.025-.196.05-.252.054-.035.135-.066.229-.044-.056-.003-.065.024-.068.047,0,.033.026.066.079.066.052,0,.074-.044.074-.075,0-.013-.004-.04-.023-.065-.029-.055-.07-.166-.099-.238-.028-.073-.074-.083-.141-.103l-.026-.079c.038-.025.076,0,.11.029-.012-.169-.467-.157-.505-.259.058.016.091-.024.078-.062-.016-.047-.072-.074-.121-.066-.172-.091-.358-.135-.549-.164.073-.086.028-.132-.09-.143l-.185-.005h-.031s-.032,0-.032,0h0Z",
    style: {
      fill: "#dca842"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.993,17.087h-.002c-.072,0-.109-.013-.141-.023-.029-.009-.054-.017-.1-.017-.023.012-.048.019-.073.019-.149,0-.252-.123-.352-.243-.011-.013-.022-.026-.033-.039-.106-.125-.175-.197-.594-.468-.156-.101-.369-.272-.498-.513-.125-.234-.142-.48-.05-.73.022-.06.069-.11.127-.136.06-.027.128-.028.192-.003.168.065.268.007.307-.069.044-.088.023-.19-.048-.243-.042-.027-.104-.054-.179-.049.021.01.027.029.029.046,0,.036-.027.074-.086.074-.056,0-.081-.048-.081-.082,0-.018.007-.045.025-.07.022-.042.054-.124.079-.189.007-.017.013-.033.019-.048.028-.073.073-.086.137-.105h.005s.023-.071.023-.071c-.03-.017-.061,0-.097.031-.002.002-.005.002-.008,0-.002,0-.004-.004-.004-.007.007-.102.163-.14.301-.174.087-.021.17-.042.198-.074-.024.003-.046-.004-.059-.019-.014-.015-.018-.036-.011-.055.016-.047.073-.078.126-.071.183-.096.381-.137.537-.162-.027-.034-.035-.064-.026-.088.013-.031.056-.05.128-.057l.185-.005h.031s.218.006.218.006c.073.007.116.026.128.057.01.024.001.053-.026.088.156.025.355.066.537.162.054-.008.11.024.126.071.007.02.003.04-.011.055s-.035.022-.06.019c.028.032.111.053.198.074.138.034.294.072.301.174,0,.003-.001.005-.004.007-.003,0-.005,0-.008,0-.036-.031-.067-.048-.098-.031l.023.07h.005c.063.02.109.033.137.106.005.014.011.029.018.045.026.066.058.148.081.192.018.023.024.051.024.069,0,.032-.022.082-.081.082s-.086-.038-.086-.073c.002-.018.008-.037.029-.047-.075-.005-.137.023-.18.05-.071.052-.091.155-.048.243.038.076.139.135.306.069.064-.025.132-.024.192.003.058.026.105.076.127.136.092.25.076.495-.05.73-.129.241-.342.412-.498.513-.419.271-.489.343-.594.468-.011.013-.022.026-.033.039-.1.119-.204.243-.352.243-.024,0-.049-.006-.072-.019-.046,0-.071.008-.1.017-.032.01-.069.022-.141.023h-.015ZM8.749,17.033c.049,0,.076.009.106.018.033.01.068.021.139.022h.014c.071,0,.106-.012.139-.022.029-.009.057-.018.106-.018.001,0,.002,0,.003,0,.022.012.045.018.067.018.142,0,.244-.121.342-.238.011-.013.022-.026.033-.039.106-.126.176-.198.597-.47.242-.156.779-.588.543-1.226-.021-.057-.065-.103-.12-.128-.056-.025-.121-.026-.181-.002-.176.069-.283.006-.324-.076-.047-.094-.025-.204.052-.26.053-.034.136-.069.235-.045.003,0,.006.004.005.008-.001.004-.004.006-.007.006-.05-.003-.058.02-.061.041,0,.028.023.059.072.059s.067-.042.067-.068c0-.005-.001-.033-.022-.061-.024-.045-.056-.128-.082-.195-.006-.016-.012-.031-.018-.045-.025-.066-.066-.078-.128-.097l-.008-.002s-.004-.002-.005-.004l-.026-.079s0-.006.003-.008c.036-.024.072-.007.104.018-.023-.079-.163-.114-.287-.144-.106-.026-.197-.048-.215-.095-.001-.002,0-.005.001-.007s.004-.003.007-.002c.026.007.048.003.062-.012.01-.011.013-.026.008-.041-.014-.041-.066-.069-.113-.061-.001,0-.003,0-.004,0-.186-.098-.39-.139-.547-.164-.002,0-.005-.002-.005-.004-.001-.002,0-.005.001-.007.029-.034.04-.062.031-.083-.01-.026-.051-.042-.116-.049l-.217-.009h-.032s-.185.006-.185.006c-.065.006-.105.023-.116.049-.008.021.002.049.031.083.002.002.002.005.001.007-.001.002-.003.004-.005.004-.157.025-.361.065-.547.164-.001,0-.003,0-.004,0-.047-.008-.099.02-.113.061-.005.015-.002.03.008.041.013.014.036.018.061.011.003,0,.005,0,.007.002s.002.005.001.007c-.018.047-.109.069-.215.095-.124.031-.264.065-.287.144.032-.025.068-.042.104-.018.003.002.004.005.003.008l-.026.079s-.002.004-.005.004l-.008.003c-.062.018-.102.03-.128.096-.006.015-.012.031-.019.048-.027.069-.057.148-.08.192-.021.029-.023.057-.023.062,0,.026.018.068.067.068s.072-.031.072-.059c-.003-.021-.01-.043-.061-.04-.003,0-.007-.002-.007-.006,0-.004.002-.007.005-.008.099-.024.182.011.235.045.077.057.099.167.053.261-.041.082-.148.145-.324.076-.06-.024-.125-.023-.181.002-.055.025-.099.071-.12.128-.236.638.301,1.07.543,1.226.421.272.491.344.597.47.011.013.022.026.033.039.098.117.2.238.342.238.022,0,.046-.006.067-.018.002,0,.003,0,.005,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.741,17.05s-.005,0-.006-.004c-.002-.003-.001-.008.003-.009.03-.017.053-.042.065-.07.022-.054.027-.142-.03-.168-.028-.013-.057-.014-.083-.003-.021.009-.037.025-.044.044-.008.022-.008.044.001.061.007.013.019.022.035.025.022.004.039.002.05-.007.01-.008.015-.021.015-.04,0-.015-.012-.027-.025-.027s-.022.011-.022.021c0,.004-.003.007-.007.007s-.007-.003-.007-.007c0-.017.014-.035.036-.035.021,0,.039.019.039.041,0,.023-.007.04-.02.051-.007.006-.015.009-.025.011-.001.002-.003.002-.006.002-.183-.008-.272-.113-.375-.235-.065-.077-.14-.165-.249-.243-.003-.002-.004-.007-.002-.01s.007-.004.01-.002c.111.079.186.167.252.245.091.108.166.196.301.222-.004-.004-.008-.009-.011-.015-.011-.021-.012-.047-.002-.073.009-.023.028-.042.052-.052.029-.012.062-.011.094.004.065.03.06.126.037.186-.013.032-.038.059-.071.077-.003.003-.004.003-.005.003ZM9.356,16.992c-.023,0-.047-.003-.072-.008-.004,0-.006-.004-.005-.008.001-.004.004-.006.008-.005.178.038.291-.071.417-.259.07-.105.256-.251.569-.447.48-.3.636-.835.476-1.129-.039-.071-.139-.096-.191-.081-.095.026-.231.02-.322-.049-.062-.047-.093-.115-.093-.203-.001-.081.037-.17.098-.231.049-.049.107-.076.167-.076.097,0,.143.035.165.064.002.003.002.007-.001.01-.003.002-.007.002-.01,0-.02-.026-.062-.058-.154-.058-.071,0-.125.039-.157.071-.058.059-.094.143-.094.221,0,.083.03.148.088.192.087.067.219.071.31.047.058-.016.164.01.207.088.082.151.085.359.006.57-.086.23-.259.435-.487.578-.311.195-.496.339-.565.443-.112.165-.214.271-.36.271ZM8.644,16.992c-.146,0-.248-.106-.36-.273-.071-.104-.255-.249-.565-.443-.228-.142-.401-.348-.487-.578-.079-.211-.076-.418.006-.57.043-.078.149-.104.207-.088.091.025.223.02.31-.047.058-.044.088-.109.088-.192,0-.078-.035-.162-.094-.221-.032-.033-.086-.071-.157-.071-.092,0-.134.031-.154.058-.002.003-.007.004-.01,0-.003-.002-.004-.007,0-.01.022-.029.068-.063.165-.063.06,0,.118.026.167.075.061.061.098.15.098.231,0,.088-.032.156-.093.203-.091.069-.227.075-.322.049-.052-.014-.152.01-.191.081-.079.146-.081.354-.005.558.085.227.256.43.481.571.311.195.497.341.569.447.126.188.24.297.417.259.004,0,.007.002.008.005.001.004-.002.007-.005.008-.026.007-.05.01-.072.01ZM9.288,16.943s-.007-.003-.007-.007.003-.007.007-.007c.178-.008.261-.106.366-.23.066-.078.141-.166.252-.245.003-.002.007,0,.01.002.002.003.001.007-.002.01-.11.078-.184.165-.249.242-.103.122-.192.227-.377.235h0ZM10.292,14.048h-.002c-.074-.021-.149-.023-.222-.026-.075-.002-.146-.005-.199-.029-.066-.03-.095-.1-.089-.151.005-.043.033-.072.077-.08.004,0,.007.002.008.006.001.004-.002.007-.006.008-.051.009-.063.047-.066.068-.006.046.021.109.081.137.05.023.12.025.193.028.07.002.15.005.225.026.004,0,.006.005.005.009,0,.002-.002.004-.005.004ZM7.707,14.048s-.006-.002-.007-.005c0-.004,0-.008.005-.009.076-.021.155-.024.225-.026.074-.002.143-.005.193-.028.06-.028.087-.091.081-.137-.003-.021-.015-.059-.066-.068-.004,0-.006-.004-.006-.008.001-.004.004-.006.008-.006.044.008.072.037.077.08.006.051-.023.121-.089.151-.053.024-.124.026-.199.029-.073.002-.148.005-.222.026.002,0,0,0,0,0ZM9.899,13.905s-.005,0-.006-.003c-.021-.036-.026-.067-.013-.081.005-.005.018-.012.043.004.003.002.004.006.002.01-.002.003-.006.004-.01.002-.012-.008-.022-.01-.026-.005-.007.007-.004.032.015.064.002.003.001.008-.002.009-.001-.001-.002,0-.003,0ZM8.101,13.905s-.002,0-.004,0c-.003-.002-.004-.006-.002-.009.019-.032.022-.057.015-.064-.004-.004-.014-.002-.026.005-.003.002-.007,0-.01-.002-.002-.003-.001-.008.002-.01.025-.015.038-.009.043-.004.014.013.008.045-.013.081-.001.002-.003.004-.005.004ZM9.836,13.765s-.002,0-.003,0c-.089-.037-.227-.045-.373-.055-.068-.004-.138-.009-.202-.016-.092-.006-.148-.077-.146-.139.001-.047.035-.097.124-.097h0s.007.003.007.007-.003.007-.007.007c-.079,0-.109.043-.11.084-.002.056.049.12.133.125.065.008.134.012.202.016.147.009.286.018.377.056.004,0,.005.006.004.009-.001.002-.004.004-.006.004ZM8.164,13.765s-.005-.002-.006-.004c-.001-.003,0-.008.004-.009.091-.038.23-.046.377-.056.068-.004.137-.009.202-.016.085-.005.135-.069.134-.125-.001-.04-.031-.083-.11-.084-.004,0-.007-.003-.007-.007s.003-.007.007-.007h0c.089,0,.122.05.124.097.002.063-.054.134-.146.139-.064.007-.134.012-.202.016-.146.009-.284.018-.373.055-.002.001-.003.001-.004.001ZM9.311,13.612h-.002c-.01-.002-.019-.004-.029-.006-.026-.005-.051-.009-.066-.023-.013-.012-.019-.028-.015-.041.003-.009.012-.02.04-.023.004,0,.007.003.007.006,0,.004-.003.007-.006.007-.015,0-.025.006-.028.013-.002.007.002.018.011.026.012.011.035.015.059.019.01.002.02.003.03.006.004,0,.006.005.005.008,0,.005-.003.008-.006.008ZM8.689,13.612s-.006-.002-.007-.005c-.001-.004.001-.007.005-.008.01-.002.02-.004.03-.006.024-.004.047-.008.059-.019.009-.008.014-.019.011-.026s-.012-.012-.028-.013c-.004,0-.007-.004-.006-.007,0-.004.003-.007.007-.006.027.002.037.014.04.023.004.013-.001.029-.015.041-.015.014-.04.018-.066.023-.01.002-.019.003-.029.006,0-.003,0-.003,0-.003Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.366,16.873s-.007-.003-.007-.007c0-.113-.193-.153-.359-.153-.165,0-.359.04-.359.153,0,.004-.003.007-.007.007s-.007-.003-.007-.007c0-.123.201-.167.372-.167.172,0,.372.044.372.167.002.004,0,.007-.005.007Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.259,17.05s-.002,0-.003,0c-.033-.018-.058-.046-.071-.077-.024-.059-.028-.156.037-.185.032-.014.065-.016.094-.004.024.01.043.029.052.052.01.026.009.052-.002.073-.009.017-.025.028-.044.032-.026.005-.047.002-.061-.01-.013-.011-.02-.028-.02-.051,0-.022.018-.041.039-.041s.036.018.036.035c0,.004-.003.007-.007.007s-.009-.003-.009-.007c0-.01-.009-.021-.022-.021-.014,0-.025.012-.025.027,0,.018.005.032.015.04.011.009.028.011.05.007.015-.003.027-.012.035-.025.009-.017.01-.039.001-.061-.007-.019-.024-.036-.044-.044-.025-.01-.054-.009-.083.003-.056.026-.051.114-.03.168.012.029.035.054.065.07.003.002.005.006.003.009-.002.003-.004.004-.006.004Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9,17.086c-.068,0-.099-.028-.125-.053-.021-.02-.04-.037-.075-.037-.004,0-.007-.003-.007-.007s.003-.007.007-.007c.041,0,.062.02.085.041.026.024.053.049.116.049s.091-.025.117-.049c.023-.021.044-.04.085-.04.004,0,.007.003.007.007s-.003.007-.007.007c-.035,0-.054.017-.075.037-.029.024-.059.052-.128.052Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9,16.855c-.059,0-.059.088,0,.088s.06-.088,0-.088",
    style: {
      fill: "url(#Unbenannter_Verlauf)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16.95c-.034,0-.051-.026-.051-.051s.018-.051.051-.051c.016,0,.029.005.039.016.008.009.013.022.013.035,0,.025-.018.051-.052.051ZM9,16.862c-.026,0-.037.019-.037.037s.012.037.037.037c.026,0,.038-.019.038-.037s-.012-.037-.038-.037Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.106,16.872c-.037,0-.037.055,0,.055s.038-.055,0-.055",
    style: {
      fill: "url(#Unbenannter_Verlauf_2)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.106,16.933c-.023,0-.034-.017-.034-.034,0-.009.003-.017.009-.023.004-.005.012-.011.026-.011.023,0,.035.017.035.034,0,.009-.003.017-.009.024-.005.004-.013.01-.027.01ZM9.106,16.879c-.006,0-.012.002-.015.006-.003.004-.005.009-.005.014,0,.01.006.02.021.02.007,0,.012-.002.016-.006.003-.004.005-.009.005-.014,0-.01-.007-.02-.022-.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.028,17.007c0-.037-.055-.037-.055,0s.055.037.055,0",
    style: {
      fill: "url(#Unbenannter_Verlauf_3)"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9,17.041c-.017,0-.034-.012-.034-.034,0-.045.068-.045.068,0,0,.023-.017.034-.034.034ZM9,16.986c-.01,0-.02.006-.02.021,0,.028.041.028.041,0,0-.014-.011-.021-.021-.021Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.893,16.928c.037,0,.037-.055,0-.055s-.037.055,0,.055",
    style: {
      fill: "url(#Unbenannter_Verlauf_4)"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.893,16.935c-.023,0-.035-.017-.035-.034,0-.009.003-.017.009-.024.004-.005.013-.011.026-.011.023,0,.034.017.034.034,0,.009-.003.017-.009.023-.003.006-.011.012-.025.012ZM8.893,16.88c-.007,0-.012.002-.016.006-.003.004-.005.009-.005.014,0,.01.006.02.021.02.006,0,.012-.002.015-.006.003-.004.005-.009.005-.014,0-.009-.006-.02-.02-.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.972,16.793c0,.037.055.037.055,0s-.055-.037-.055,0",
    style: {
      fill: "url(#Unbenannter_Verlauf_5)"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.999,16.827c-.017,0-.034-.012-.034-.034,0-.045.068-.045.068,0,.001.022-.017.034-.034.034ZM8.999,16.772c-.01,0-.02.006-.02.021,0,.028.041.028.041,0,0-.014-.01-.021-.021-.021Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.789,14.292c.01,0,.02.003.03.007.017.007.031.019.036.036h0c.147.409.068.583-.062.847-.189.381-.051.948.371,1.196.208.121.368.163.49.193.061.015.113.028.157.047.042.018.086.051.114.088-.042.004-.112.015-.146.025-.049-.063-.174-.12-.302-.164-.129-.044-.263-.075-.335-.089h0c-.237-.069-.457-.223-.623-.418-.176-.207-.266-.491-.231-.775.008-.065.034-.105.071-.126.037-.022.083-.025.133-.022.09.005.178-.019.258-.069.104-.064.146-.177.145-.299-.002-.123-.048-.254-.121-.353-.026-.035-.037-.062-.036-.082s.014-.034.03-.039c.004,0,.008-.002.013-.002,0-.001.005-.001.008-.001h0Z",
    style: {
      fill: "#825123"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.777,16.74l-.003-.004c-.042-.053-.148-.111-.299-.162-.149-.051-.294-.081-.334-.089-.231-.067-.454-.216-.628-.421-.182-.215-.267-.499-.233-.78.008-.063.032-.107.074-.132.033-.02.077-.027.137-.023.087.005.173-.018.254-.068.093-.057.143-.161.141-.293-.002-.12-.046-.25-.12-.349-.026-.035-.038-.063-.038-.087,0-.022.014-.039.035-.045.005,0,.009-.002.014-.003h.011c.011,0,.022.003.032.008.021.009.035.023.04.04.151.42.062.601-.063.852-.176.355-.069.93.368,1.187.211.123.371.163.488.193l.008.002c.058.014.108.027.151.045.046.02.09.054.117.091l.007.01h-.012c-.043.005-.112.016-.144.026l-.003.002ZM8.144,16.472c.045.009.188.039.336.089.107.036.245.094.302.163.031-.009.088-.018.13-.023-.026-.031-.064-.059-.103-.076-.042-.018-.091-.03-.149-.045l-.008-.002c-.118-.03-.28-.07-.492-.194-.443-.26-.553-.844-.374-1.205.123-.248.211-.427.062-.842-.006-.018-.023-.028-.033-.032-.009-.004-.018-.006-.027-.007h-.009s-.008,0-.011.002c-.015.004-.025.016-.025.032,0,.02.011.046.035.078.075.101.121.234.123.357.002.137-.051.246-.148.305-.083.051-.173.075-.262.07-.057-.004-.098.003-.129.021-.038.022-.06.063-.067.121-.034.278.05.558.23.77.17.204.391.352.619.418h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.414,15.17c-.071,0-.071.106,0,.106.071,0,.072-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_6)"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.414,15.278c-.038,0-.055-.029-.055-.055,0-.014.005-.028.014-.038.01-.011.024-.017.042-.017.038,0,.056.029.056.055-.001.027-.02.055-.057.055ZM7.414,15.172c-.016,0-.029.005-.038.016-.008.009-.013.022-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.025-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.547,15.163c-.071,0-.071.106,0,.106.071,0,.071-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_7)"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.547,15.271c-.038,0-.055-.029-.055-.055,0-.014.005-.028.014-.038.01-.011.024-.017.042-.017.038,0,.056.029.056.055,0,.027-.021.055-.057.055ZM7.547,15.166c-.016,0-.029.005-.038.016-.008.009-.013.022-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.025-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.678,15.17c-.071,0-.071.106,0,.106.07,0,.071-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_8)"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.678,15.278c-.038,0-.055-.029-.055-.055,0-.014.005-.028.014-.038.01-.011.024-.017.042-.017.038,0,.056.029.056.055-.002.027-.021.055-.057.055ZM7.678,15.172c-.016,0-.029.005-.038.016-.008.009-.013.022-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.025-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.366,15.287c-.071,0-.071.106,0,.106s.072-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_9)"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.366,15.395c-.038,0-.055-.029-.055-.055,0-.014.005-.028.014-.038.01-.011.024-.017.042-.017.038,0,.056.028.056.055-.001.027-.021.055-.057.055ZM7.366,15.289c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.05.051.05.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.024-.016-.05-.051-.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.497,15.287c-.071,0-.071.106,0,.106.07,0,.071-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_10)"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.497,15.395c-.038,0-.055-.029-.055-.055,0-.014.005-.028.014-.038.01-.011.024-.017.042-.017.038,0,.056.028.056.055-.002.027-.021.055-.057.055ZM7.497,15.289c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.05.051.05.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.024-.016-.05-.051-.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.628,15.287c-.071,0-.071.106,0,.106s.072-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_11)"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.628,15.395c-.038,0-.055-.029-.055-.055,0-.014.005-.028.014-.038.01-.011.024-.017.042-.017.038,0,.056.028.056.055,0,.014-.005.028-.014.038-.011.011-.026.017-.043.017ZM7.628,15.289c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.05.051.05.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.024-.016-.05-.051-.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.361,15.41c-.071,0-.071.106,0,.106.07,0,.071-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_12)"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.361,15.518c-.038,0-.055-.029-.055-.055,0-.014.005-.028.014-.038.01-.011.024-.017.042-.017.038,0,.056.029.056.055-.002.027-.021.055-.057.055ZM7.361,15.412c-.016,0-.029.005-.038.016-.008.009-.013.022-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.025-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.484,15.405c-.071,0-.071.106,0,.106.071,0,.072-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_13)"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.484,15.513c-.038,0-.055-.029-.055-.055,0-.014.005-.028.014-.038.01-.011.024-.017.042-.017.038,0,.056.029.056.055-.001.027-.02.055-.057.055ZM7.484,15.408c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.025-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.616,15.405c-.071,0-.071.106,0,.106.071,0,.071-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_14)"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.616,15.513c-.038,0-.055-.029-.055-.055,0-.014.005-.028.014-.038.01-.011.024-.017.042-.017.038,0,.056.029.056.055-.001.027-.021.055-.057.055ZM7.616,15.408c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.025-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.379,15.535c-.066,0-.066.099,0,.099.067.001.068-.099,0-.099",
    style: {
      fill: "url(#Unbenannter_Verlauf_15)"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.379,15.637c-.036,0-.052-.027-.052-.052,0-.014.005-.026.013-.036.009-.011.023-.016.039-.016.036,0,.053.027.053.052,0,.026-.018.052-.053.052ZM7.379,15.538c-.015,0-.027.005-.036.015-.008.009-.012.02-.012.033,0,.023.015.047.047.047.015,0,.027-.005.036-.015.008-.009.012-.02.012-.033.002-.023-.013-.047-.047-.047Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.503,15.535c-.066,0-.066.099,0,.099.067.001.067-.099,0-.099",
    style: {
      fill: "url(#Unbenannter_Verlauf_16)"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.503,15.637c-.036,0-.052-.027-.052-.052,0-.014.005-.026.013-.036.009-.011.023-.016.039-.016.036,0,.053.027.053.052,0,.014-.005.026-.013.036-.01.01-.024.016-.04.016ZM7.503,15.538c-.015,0-.027.005-.036.015-.008.009-.012.02-.012.033,0,.023.015.047.047.047.015,0,.027-.005.036-.015.008-.009.012-.02.012-.033.001-.023-.014-.047-.047-.047Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.627,15.535c-.066,0-.066.099,0,.099.068.001.069-.099,0-.099",
    style: {
      fill: "url(#Unbenannter_Verlauf_17)"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.627,15.637c-.036,0-.052-.027-.052-.052,0-.014.005-.026.013-.036.009-.011.023-.016.039-.016.036,0,.053.027.053.052,0,.014-.005.026-.013.036-.01.01-.023.016-.04.016ZM7.627,15.538c-.015,0-.027.005-.036.015-.008.009-.012.02-.012.033,0,.023.015.047.047.047.015,0,.027-.005.036-.015.008-.009.012-.02.012-.033.002-.023-.013-.047-.047-.047Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.406,15.665c-.064.003-.059.098.004.095s.06-.099-.004-.095",
    style: {
      fill: "url(#Unbenannter_Verlauf_18)"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.407,15.762c-.018,0-.033-.008-.042-.022-.01-.016-.011-.037-.002-.053.008-.015.023-.024.042-.025.019,0,.035.006.044.021.01.015.011.037.003.053-.008.016-.023.025-.042.026h-.003ZM7.409,15.667h-.003c-.017,0-.031.009-.038.022-.008.015-.007.034.002.048.008.013.023.021.04.02s.031-.009.038-.023c.008-.015.007-.034-.002-.048-.008-.012-.021-.019-.037-.019Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.518,15.652c-.064.003-.059.098.004.095.064-.003.061-.098-.004-.095",
    style: {
      fill: "url(#Unbenannter_Verlauf_19)"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52,15.749c-.031,0-.049-.024-.05-.048,0-.024.013-.05.048-.052h.003c.033,0,.049.025.05.048,0,.024-.014.05-.048.052h-.003ZM7.518,15.654h0c-.031,0-.044.025-.043.047,0,.021.015.043.045.043h.003c.031,0,.044-.025.044-.047-.002-.021-.017-.044-.049-.043Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.637,15.646c-.064.003-.059.098.004.095.064-.003.061-.098-.004-.095",
    style: {
      fill: "url(#Unbenannter_Verlauf_20)"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.639,15.744c-.031,0-.049-.024-.05-.048,0-.013.003-.025.011-.035.009-.011.021-.016.037-.017.019,0,.035.006.044.021.01.015.011.037.002.053-.008.016-.023.025-.042.026h-.002ZM7.641,15.648h-.003c-.014,0-.026.006-.033.015-.007.008-.01.02-.01.031,0,.021.015.043.045.043h.003c.017,0,.031-.009.038-.023.008-.015.007-.034-.002-.048-.009-.011-.022-.018-.038-.018Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.451,15.776c-.061.005-.055.095.006.091.061-.004.056-.095-.006-.091",
    style: {
      fill: "url(#Unbenannter_Verlauf_21)"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7.453,15.869c-.03,0-.045-.022-.047-.044-.002-.023.012-.049.045-.051h0c.019,0,.034.006.043.02.01.015.011.035.003.051-.007.015-.022.024-.04.025-.001-.001-.003-.001-.004-.001ZM7.451,15.778h0c-.03.002-.042.026-.04.046,0,.02.015.04.042.04h.004c.017,0,.03-.009.036-.023.007-.014.006-.033-.003-.046-.008-.012-.022-.018-.039-.017Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.554,15.762c-.058.003-.052.09.005.087.059-.004.053-.091-.005-.087",
    style: {
      fill: "url(#Unbenannter_Verlauf_22)"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.556,15.851c-.016,0-.029-.007-.037-.019-.009-.014-.011-.034-.003-.049.007-.014.021-.023.038-.024h0c.018,0,.032.006.041.019.009.014.011.033.003.049-.007.014-.021.023-.038.024h-.004ZM7.557,15.764h-.003c-.016,0-.028.008-.034.021-.007.014-.006.031.003.044.007.011.019.017.033.017h.003c.016,0,.028-.009.034-.021.007-.014.006-.031-.003-.044-.006-.011-.018-.017-.033-.017Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.663,15.756c-.047.003-.042.074.004.07.047-.002.044-.072-.004-.07",
    style: {
      fill: "url(#Unbenannter_Verlauf_23)"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.664,15.829c-.012,0-.023-.005-.029-.015-.008-.012-.009-.028-.003-.04.006-.012.017-.019.031-.02h.003c.024,0,.036.018.037.035,0,.018-.011.038-.035.039-.001.001-.003.001-.004.001ZM7.663,15.759h0c-.012,0-.022.007-.027.017-.005.011-.004.025.002.036.006.009.016.014.029.013.023,0,.032-.019.031-.034,0-.017-.012-.034-.035-.032Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.498,15.876c-.058.003-.052.09.005.087.058-.003.053-.09-.005-.087",
    style: {
      fill: "url(#Unbenannter_Verlauf_24)"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,15.966c-.016,0-.029-.007-.037-.019-.009-.014-.011-.034-.003-.049.007-.014.021-.023.038-.024h.004c.029,0,.044.022.045.043,0,.022-.012.047-.043.049-.002,0-.003,0-.004,0ZM7.501,15.879h-.003c-.016,0-.028.008-.034.021-.007.014-.006.031.003.044.007.011.019.017.033.017h.003c.028-.002.04-.024.039-.044-.002-.019-.015-.038-.041-.038Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.597,15.853c-.048.004-.043.076.004.073.049-.004.044-.076-.004-.073",
    style: {
      fill: "url(#Unbenannter_Verlauf_25)"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M7.598,15.928c-.024,0-.036-.018-.037-.036,0-.019.009-.04.036-.042h.004c.024,0,.036.018.037.035,0,.019-.011.04-.036.042-.002.001-.003.001-.004.001ZM7.597,15.855c-.023.002-.033.02-.032.037,0,.015.012.031.033.031h.003c.024-.002.033-.02.032-.037,0-.015-.012-.031-.033-.031h-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.689,15.841c-.04.002-.036.063.004.06.04-.002.037-.063-.004-.06",
    style: {
      fill: "url(#Unbenannter_Verlauf_26)"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69,15.903c-.011,0-.02-.005-.026-.014-.007-.01-.008-.024-.002-.035.005-.01.015-.016.027-.016.013,0,.023.004.029.013.007.01.007.024.002.034s-.015.016-.027.017c0,0-.002,0-.003,0ZM7.692,15.843h-.002c-.01,0-.019.005-.023.013-.005.009-.004.021.002.03.005.008.014.012.024.011.011,0,.019-.005.023-.014.005-.009.004-.021-.002-.03-.005-.006-.013-.01-.022-.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.539,15.967c-.053.012-.035.092.018.079.053-.012.035-.091-.018-.079",
    style: {
      fill: "url(#Unbenannter_Verlauf_27)"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M7.546,16.049c-.011,0-.021-.004-.029-.012-.011-.012-.015-.029-.01-.045.004-.014.016-.024.032-.028h0c.028-.006.047.012.051.033.004.02-.004.044-.033.051-.004,0-.008,0-.011,0ZM7.539,15.969c-.014.003-.024.012-.028.025-.004.014,0,.03.009.04.009.01.022.013.036.01.026-.006.033-.027.029-.045-.004-.019-.02-.036-.046-.03h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.627,15.932c-.044.01-.029.076.014.065.044-.01.029-.076-.014-.065",
    style: {
      fill: "url(#Unbenannter_Verlauf_28)"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M7.632,16.001c-.009,0-.017-.003-.023-.01-.009-.01-.013-.025-.009-.038.004-.012.013-.02.027-.023.013-.003.025,0,.034.009.009.01.012.024.009.037-.004.012-.013.021-.027.024-.005,0-.008.001-.011.001ZM7.636,15.933s-.006,0-.009,0h0c-.012.003-.02.01-.023.02-.003.011,0,.025.008.033.007.008.017.01.029.007.012-.003.02-.01.023-.021s0-.024-.007-.033c-.006-.004-.013-.007-.021-.007Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.71,15.907c-.037.008-.024.064.013.055.036-.008.024-.064-.013-.055",
    style: {
      fill: "url(#Unbenannter_Verlauf_29)"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7.715,15.965c-.008,0-.015-.003-.02-.009-.008-.008-.011-.021-.007-.032.003-.01.011-.017.022-.02.011-.003.021,0,.029.008s.011.021.007.032c-.003.01-.011.017-.022.02-.004,0-.007,0-.009,0ZM7.718,15.908s-.005,0-.007,0h0c-.01.002-.016.008-.019.017-.003.009,0,.02.006.027.006.007.015.009.024.006.01-.002.016-.008.019-.017.003-.009,0-.02-.006-.027-.005-.004-.011-.007-.017-.007Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.596,16.048c-.047.016-.022.087.025.07.047-.016.023-.087-.025-.07",
    style: {
      fill: "url(#Unbenannter_Verlauf_30)"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M7.607,16.123c-.009,0-.017-.003-.023-.009-.011-.01-.017-.026-.014-.04.003-.013.012-.023.026-.028s.028-.003.039.006.017.025.014.04c-.003.014-.012.024-.026.029-.006.001-.011.002-.016.002ZM7.61,16.048s-.009,0-.013.002h0c-.012.004-.02.013-.023.025-.002.013.003.027.013.036.009.008.021.01.034.005.013-.004.021-.013.023-.025.002-.013-.003-.027-.012-.035-.007-.005-.014-.008-.022-.008Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.673,16.006c-.039.013-.018.073.021.058.039-.013.019-.072-.021-.058",
    style: {
      fill: "url(#Unbenannter_Verlauf_31)"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.682,16.069c-.007,0-.014-.002-.019-.007-.01-.008-.014-.022-.012-.034.002-.011.01-.02.022-.024.012-.004.024-.003.033.005s.014.021.012.034c-.002.011-.01.02-.022.024-.006.001-.01.002-.014.002ZM7.685,16.006s-.007,0-.011.002h0c-.01.004-.017.011-.019.021-.002.011.002.022.011.029.008.006.017.008.027.004.011-.004.017-.011.019-.021s-.002-.022-.01-.029c-.005-.003-.011-.006-.017-.006Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.747,15.975c-.032.011-.015.06.017.048.032-.011.015-.061-.017-.048",
    style: {
      fill: "url(#Unbenannter_Verlauf_32)"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M7.754,16.027c-.006,0-.012-.002-.017-.006-.008-.007-.012-.018-.01-.029.002-.009.008-.016.018-.02s.019-.003.027.003c.008.007.012.018.01.028s-.008.017-.018.021c-.003.003-.007.003-.01.003ZM7.757,15.975s-.006,0-.009.002h0c-.008.003-.014.008-.015.016-.002.009.002.018.008.024.006.005.014.006.022.003.009-.003.014-.009.015-.017.002-.009-.002-.018-.009-.024-.003-.002-.008-.004-.012-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.645,16.117c-.041.019-.013.08.029.061.041-.018.013-.079-.029-.061",
    style: {
      fill: "url(#Unbenannter_Verlauf_33)"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M7.658,16.184c-.007,0-.013-.002-.019-.006-.011-.008-.017-.021-.016-.035,0-.013.009-.023.021-.028.013-.006.025-.005.036.003.011.008.017.022.016.035,0,.012-.009.022-.021.027-.006.003-.011.004-.017.004ZM7.661,16.116c-.005,0-.01,0-.014.003-.011.005-.018.014-.019.025,0,.012.005.024.014.03.009.006.02.007.031,0,.011-.005.017-.013.019-.024,0-.011-.004-.024-.014-.031-.005-.002-.011-.004-.017-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.712,16.073c-.034.015-.01.067.023.051.034-.015.011-.068-.023-.051",
    style: {
      fill: "url(#Unbenannter_Verlauf_34)"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M7.722,16.129c-.005,0-.011-.002-.015-.005-.009-.006-.015-.019-.014-.03,0-.011.007-.019.018-.024.01-.005.021-.004.03.002.009.007.015.018.014.03,0,.011-.007.019-.018.024-.006.002-.01.003-.015.003ZM7.724,16.072s-.008,0-.012.003h0c-.009.004-.014.011-.015.02,0,.01.004.02.012.026.007.005.016.005.024,0,.009-.004.014-.011.015-.02,0-.01-.004-.02-.012-.026-.002-.003-.007-.004-.012-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.775,16.038c-.029.013-.008.055.02.043.029-.014.009-.057-.02-.043",
    style: {
      fill: "url(#Unbenannter_Verlauf_35)"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M7.785,16.085c-.01,0-.019-.007-.023-.016-.005-.011-.003-.026.013-.034h0c.009-.004.018-.004.025,0,.008.005.012.015.012.025,0,.009-.006.016-.015.021-.005.002-.009.003-.012.003ZM7.776,16.04c-.013.006-.015.018-.01.028.004.009.015.017.028.011.007-.003.012-.009.013-.017,0-.008-.003-.016-.01-.021-.006-.004-.013-.005-.021,0h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.707,16.175c-.034.017-.007.069.026.051.034-.017.008-.069-.026-.051",
    style: {
      fill: "url(#Unbenannter_Verlauf_36)"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M7.719,16.232c-.005,0-.01,0-.015-.004-.01-.006-.016-.018-.015-.03,0-.011.007-.02.017-.025s.021-.005.03,0c.01.006.016.018.015.03,0,.011-.007.02-.017.025-.005.002-.01.004-.015.004ZM7.721,16.173s-.009,0-.013.003h0c-.009.004-.014.012-.014.021,0,.01.005.02.013.026.008.005.016.005.025,0,.009-.005.014-.012.015-.021,0-.01-.005-.02-.013-.025-.004-.002-.008-.004-.013-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.762,16.134c-.029.014-.006.057.022.042.028-.014.006-.057-.022-.042",
    style: {
      fill: "url(#Unbenannter_Verlauf_37)"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.771,16.182s-.008,0-.012-.004c-.008-.005-.013-.015-.013-.025,0-.009.006-.017.015-.021.009-.005.018-.005.025,0,.008.005.013.015.013.025,0,.009-.006.017-.015.021-.004.003-.008.004-.013.004ZM7.774,16.133s-.007,0-.011.003h0c-.007.004-.012.01-.012.017,0,.008.004.016.011.021.006.004.014.004.021,0s.012-.01.012-.017c0-.008-.004-.016-.011-.021-.004-.002-.007-.003-.01-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.815,16.102c-.023.013-.004.047.018.035.023-.012.005-.048-.018-.035",
    style: {
      fill: "url(#Unbenannter_Verlauf_38)"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.823,16.142s-.007,0-.01-.003c-.007-.004-.011-.013-.011-.021s.004-.014.012-.018c.007-.004.015-.004.021,0,.007.004.011.013.011.021s-.005.014-.012.018c-.004.002-.007.003-.011.003ZM7.825,16.102s-.006,0-.009.003h0c-.006.003-.009.008-.009.015s.003.013.009.017c.005.003.011.003.016,0,.006-.003.009-.008.01-.014,0-.007-.003-.014-.009-.017-.003-.003-.005-.004-.008-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.759,16.225c-.03.019,0,.064.029.044.029-.019.001-.064-.029-.044",
    style: {
      fill: "url(#Unbenannter_Verlauf_39)"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M7.773,16.276s-.008,0-.011-.003c-.01-.005-.017-.015-.017-.026,0-.01.004-.019.013-.025.009-.006.019-.007.028-.002s.016.015.017.026c0,.01-.004.019-.013.025-.006.003-.012.005-.017.005ZM7.774,16.222c-.005,0-.009,0-.014.005h0c-.008.005-.012.012-.011.02,0,.009.006.018.015.022.007.004.015.003.023-.002s.012-.012.011-.021c0-.009-.006-.018-.014-.022-.003,0-.007-.002-.01-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.805,16.184c-.024.016,0,.053.024.037.024-.017,0-.054-.024-.037",
    style: {
      fill: "url(#Unbenannter_Verlauf_40)"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M7.817,16.227c-.008,0-.016-.005-.02-.011-.007-.01-.007-.025.007-.034.007-.005.016-.006.023-.003.008.004.014.013.015.022s-.003.016-.011.021c-.005.003-.01.005-.014.005ZM7.817,16.182s-.008,0-.011.004h0c-.011.007-.011.019-.005.027.005.008.016.013.027.006.006-.004.009-.01.009-.017,0-.008-.005-.015-.012-.018-.003-.002-.005-.002-.008-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.85,16.149c-.021.013,0,.044.02.03.021-.013,0-.044-.02-.03",
    style: {
      fill: "url(#Unbenannter_Verlauf_41)"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86,16.185s-.006,0-.008-.002c-.007-.003-.012-.011-.012-.018s.003-.014.01-.018c.006-.004.013-.005.02-.002s.012.011.012.018-.003.013-.01.018c-.004.003-.008.004-.012.004ZM7.861,16.148s-.006,0-.009.003h0c-.005.003-.008.008-.007.014,0,.006.004.012.01.014.005.002.01.002.015-.002.005-.003.008-.008.008-.014s-.004-.012-.01-.014c-.003,0-.005,0-.007,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.81,16.266c-.03.02,0,.064.029.044.03-.019.001-.064-.029-.044",
    style: {
      fill: "url(#Unbenannter_Verlauf_42)"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M7.824,16.317s-.008,0-.011-.003c-.009-.005-.016-.015-.017-.025,0-.01.004-.019.013-.025h0c.009-.006.019-.007.028-.003.009.005.016.015.017.026,0,.01-.004.019-.013.025-.006.003-.011.005-.017.005ZM7.812,16.268h0c-.008.005-.012.013-.011.021,0,.009.006.018.014.021.007.004.015.003.023-.002s.012-.012.011-.021c0-.009-.006-.018-.014-.022-.007-.003-.016-.002-.023.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.856,16.226c-.024.016,0,.053.024.037.024-.017,0-.053-.024-.037",
    style: {
      fill: "url(#Unbenannter_Verlauf_43)"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M7.868,16.269s-.007,0-.01-.002c-.008-.004-.014-.012-.014-.021,0-.009.003-.016.011-.021h0c.008-.005.016-.006.023-.002.008.004.014.013.014.022,0,.008-.003.016-.011.021-.004.001-.009.003-.013.003ZM7.857,16.228h0c-.006.004-.009.01-.009.017,0,.007.005.014.012.018.006.003.013.002.019-.002s.009-.01.009-.017-.005-.014-.012-.018c-.006-.003-.013-.002-.019.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.893,16.191c-.021.014,0,.044.02.031.021-.014,0-.046-.02-.031",
    style: {
      fill: "url(#Unbenannter_Verlauf_44)"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M7.903,16.227s-.006,0-.008-.002c-.007-.003-.012-.011-.012-.018s.003-.014.009-.018.013-.005.019-.002c.007.003.012.01.013.018,0,.007-.003.014-.01.018-.003.003-.007.004-.011.004ZM7.904,16.19s-.006,0-.009.003h0c-.005.003-.008.008-.007.014,0,.006.004.012.01.014.005.002.01.002.015,0,.005-.003.008-.009.007-.014,0-.006-.004-.012-.01-.015-.002,0-.004,0-.006,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.934,16.234c-.019.012,0,.04.018.029.018-.013,0-.042-.018-.029",
    style: {
      fill: "url(#Unbenannter_Verlauf_45)"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M7.943,16.267s-.005,0-.008-.002c-.007-.003-.011-.01-.011-.018,0-.007.003-.012.009-.016.006-.004.012-.004.018-.002.006.003.011.01.012.017,0,.007-.003.013-.009.017-.004.003-.008.004-.011.004ZM7.943,16.233s-.005,0-.008.003h0c-.006.004-.007.008-.007.012,0,.006.004.011.009.014.004.002.009.002.013,0,.005-.003.007-.008.007-.013,0-.006-.004-.011-.009-.013,0,0-.003-.002-.005-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.901,16.271c-.021.013,0,.044.02.03.02-.013,0-.044-.02-.03",
    style: {
      fill: "url(#Unbenannter_Verlauf_46)"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91,16.307s-.006,0-.008-.002c-.007-.003-.012-.011-.012-.018s.003-.013.01-.018c.006-.004.013-.005.02-.002s.012.011.012.018-.003.013-.01.018c-.004.002-.008.004-.012.004ZM7.911,16.27s-.006,0-.009.003h0c-.005.003-.008.008-.007.014,0,.006.004.012.01.014.005.002.01.002.015-.002.005-.003.008-.008.008-.014s-.004-.012-.01-.014c-.003,0-.005,0-.007,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.865,16.308c-.022.015,0,.048.022.033.022-.014,0-.048-.022-.033",
    style: {
      fill: "url(#Unbenannter_Verlauf_47)"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875,16.348s-.006,0-.008-.002c-.007-.003-.013-.011-.013-.019,0-.008.003-.015.01-.02.007-.005.014-.006.021-.002.008.004.013.012.013.02s-.003.015-.01.019c-.004.002-.009.004-.013.004ZM7.876,16.307s-.007,0-.01.003h0c-.006.004-.009.01-.008.016,0,.007.005.013.011.016.005.002.011.002.016-.002.006-.004.009-.009.008-.015,0-.007-.005-.013-.011-.016-.002-.002-.004-.002-.006-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.976,16.278c-.017.012,0,.037.017.026.017-.012,0-.038-.017-.026",
    style: {
      fill: "url(#Unbenannter_Verlauf_48)"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M7.984,16.309c-.006,0-.012-.003-.015-.008-.005-.007-.005-.018.005-.024.01-.007.02-.002.024.004.005.007.005.018-.005.025-.002.002-.005.003-.009.003ZM7.985,16.277s-.005,0-.008.003c-.007.005-.007.013-.004.018s.011.009.018.004c.008-.005.007-.013.003-.019,0-.003-.005-.006-.009-.006Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.949,16.31c-.019.013,0,.04.018.028.019-.013,0-.04-.018-.028",
    style: {
      fill: "url(#Unbenannter_Verlauf_49)"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M7.958,16.343s-.005,0-.007-.002c-.006-.003-.011-.01-.011-.017,0-.007.003-.013.009-.017s.012-.005.018-.002.011.01.011.017-.003.013-.009.017c-.004.003-.007.004-.011.004ZM7.959,16.309s-.005,0-.008.003h0c-.005.003-.007.008-.007.013s.004.01.009.013c.004.002.009,0,.013-.002.005-.003.007-.008.007-.013s-.004-.011-.009-.013c-.002,0-.003,0-.005,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.917,16.342c-.02.012,0,.043.02.03.02-.014,0-.044-.02-.03",
    style: {
      fill: "url(#Unbenannter_Verlauf_50)"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M7.927,16.377s-.006,0-.008-.002c-.007-.003-.012-.011-.012-.018s.003-.013.009-.017c.011-.008.022-.003.028.005s.006.021-.005.028c-.004.003-.008.004-.012.004ZM7.928,16.341s-.006,0-.009.003h0c-.005.003-.007.008-.007.013,0,.006.004.012.009.014.005.002.01.002.015,0,.009-.006.008-.016.004-.022-.003-.004-.007-.007-.012-.007Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.017,16.307c-.015.01,0,.034.015.023.015-.009,0-.034-.015-.023",
    style: {
      fill: "url(#Unbenannter_Verlauf_51)"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8.024,16.335s-.004,0-.006,0c-.005-.003-.009-.009-.01-.015,0-.006.002-.011.007-.014s.01-.004.015-.002c.005.003.009.009.01.015,0,.006-.002.011-.007.014-.003.002-.006.003-.009.003ZM8.024,16.307s-.004,0-.006.002h0s-.005.006-.005.01c0,.005.003.009.007.011.002,0,.006.002.011,0,.004-.002.006-.006.005-.01,0-.005-.003-.009-.007-.011-.001-.001-.003-.001-.005-.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.993,16.337c-.017.012,0,.038.017.026.017-.012,0-.037-.017-.026",
    style: {
      fill: "url(#Unbenannter_Verlauf_52)"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M8.001,16.368c-.006,0-.011-.003-.014-.008-.005-.007-.005-.018.005-.025h0c.01-.007.02-.002.024.005.005.008.005.019-.005.025-.003.002-.007.003-.01.003ZM7.994,16.339c-.008.005-.007.013-.003.019.004.005.011.008.018.004.008-.005.007-.013.003-.019-.004-.006-.011-.009-.018-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.964,16.371c-.018.012,0,.04.018.027.017-.012-.001-.04-.018-.027",
    style: {
      fill: "url(#Unbenannter_Verlauf_53)"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M7.972,16.404s-.004,0-.007,0c-.006-.003-.011-.009-.011-.017,0-.007.003-.013.008-.017.006-.004.012-.005.018-.003.006.003.011.01.011.017,0,.007-.003.013-.008.017-.004.003-.008.004-.011.004ZM7.973,16.37s-.005,0-.008.003h0s-.007.007-.006.012c0,.005.004.011.009.013.003,0,.008.002.013-.002.005-.003.007-.007.006-.012,0-.006-.004-.011-.009-.013,0,0-.003,0-.005,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.05,16.333c-.014.011.002.032.016.022.014-.011-.001-.032-.016-.022",
    style: {
      fill: "url(#Unbenannter_Verlauf_54)"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M8.058,16.36c-.005,0-.01-.003-.012-.006-.005-.006-.005-.016.003-.022h0c.008-.006.017-.003.021.003.005.006.006.016-.002.022-.003.002-.007.003-.01.003ZM8.052,16.335h0c-.006.005-.005.011-.002.016.003.004.009.007.016.002.006-.005.005-.012.002-.016-.004-.004-.01-.007-.016-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.028,16.361c-.015.012.002.035.017.023.016-.011-.001-.034-.017-.023",
    style: {
      fill: "url(#Unbenannter_Verlauf_55)"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M8.037,16.39c-.005,0-.01-.003-.013-.007-.005-.007-.006-.017.003-.024h0c.005-.004.011-.005.016-.002.006.002.01.008.011.014.001.006-.002.011-.007.015-.004.003-.007.004-.01.004ZM8.03,16.363c-.007.005-.006.013-.002.017.004.005.01.007.016.002.004-.003.005-.007.005-.011-.001-.005-.004-.009-.008-.011-.002,0-.007,0-.011.003h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.008,16.391c-.016.013.002.039.019.025.016-.012-.002-.038-.019-.025",
    style: {
      fill: "url(#Unbenannter_Verlauf_56)"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.017,16.423c-.005,0-.01-.003-.013-.007-.006-.007-.006-.019.003-.026h0c.01-.008.019-.004.025.003s.006.019-.003.026c-.005.002-.009.004-.012.004ZM8.009,16.393h0c-.007.006-.007.014-.002.02.004.005.011.008.018.002s.007-.014.002-.02c-.003-.004-.01-.008-.018-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.083,16.354c-.012.01.004.028.015.017s-.004-.028-.015-.017",
    style: {
      fill: "url(#Unbenannter_Verlauf_57)"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09,16.377s-.003,0-.004,0c-.005-.002-.009-.006-.01-.011s.001-.009.005-.013c.007-.006.015-.004.019,0,.005.005.006.014-.001.02-.002.002-.006.004-.009.004ZM8.091,16.353s-.004,0-.006.003h0s-.004.006-.003.008c.001.004.003.007.007.008.002,0,.005,0,.009-.002.005-.005.004-.01.001-.013-.003-.003-.006-.004-.008-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.065,16.384c-.012.011.004.03.017.018.012-.011-.005-.031-.017-.018",
    style: {
      fill: "url(#Unbenannter_Verlauf_58)"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M8.073,16.408s-.002,0-.004,0c-.005,0-.009-.006-.011-.012-.001-.005,0-.01.004-.014.004-.004.009-.006.014-.004.005.002.01.006.011.012.001.005-.001.01-.005.014-.002.003-.005.005-.009.005ZM8.074,16.382s-.005,0-.007.003h0s-.003.007-.003.009c.001.004.004.007.007.008s.006,0,.009-.003.004-.006.004-.009c-.001-.004-.004-.007-.008-.008h-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.048,16.412c-.013.013.004.032.018.02.014-.012-.004-.032-.018-.02",
    style: {
      fill: "url(#Unbenannter_Verlauf_59)"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M8.057,16.438s-.008-.002-.011-.005c-.003-.003-.004-.007-.004-.011,0-.003.001-.008.005-.012h0s.01-.005.015-.004c.006.002.01.007.011.013.001.005-.001.011-.005.014-.004.004-.008.005-.011.005ZM8.05,16.414s-.005.007-.004.011c.001.004.004.007.008.008.004,0,.007,0,.011-.003.003-.003.005-.006.004-.01s-.004-.008-.008-.009c-.003-.001-.007-.001-.011.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.117,16.371c-.011.01.004.026.015.016.011-.01-.005-.026-.015-.016",
    style: {
      fill: "url(#Unbenannter_Verlauf_60)"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8.124,16.393h-.001s-.006-.002-.009-.005c-.002-.003-.004-.006-.004-.009,0-.004.001-.007.004-.01.006-.007.014-.005.019,0s.006.013,0,.02c-.002.003-.005.004-.009.004ZM8.125,16.37s-.004,0-.006.003h0s-.003.009,0,.012c.002.002.004.003.006.003.003,0,.005,0,.007-.002.004-.005.003-.01,0-.013-.003-.002-.005-.003-.007-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.104,16.398c-.012.012.004.029.016.017.012-.011-.004-.029-.016-.017",
    style: {
      fill: "url(#Unbenannter_Verlauf_61)"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8.112,16.421s-.007-.002-.01-.004c-.005-.005-.007-.014,0-.021h0s.009-.005.013-.004c.005,0,.009.006.01.011s0,.01-.004.014c-.002.003-.006.004-.009.004ZM8.106,16.4h0c-.005.005-.004.011,0,.014.003.003.009.004.013,0,.003-.003.004-.006.003-.009-.001-.004-.004-.007-.007-.007-.002-.001-.006-.001-.009.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.086,16.428c-.013.013.005.031.018.019.013-.012-.004-.032-.018-.019",
    style: {
      fill: "url(#Unbenannter_Verlauf_62)"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M8.095,16.453h-.004c-.005,0-.01-.006-.011-.011-.001-.005,0-.011.004-.015h0s.01-.006.015-.004c.005.002.01.006.011.012.001.005,0,.011-.005.015-.002,0-.006.003-.01.003ZM8.088,16.429s-.004.007-.003.011c.001.004.004.007.008.008.002,0,.006,0,.01-.003.003-.003.004-.006.003-.01-.001-.004-.004-.007-.008-.008-.002,0-.006,0-.01.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.148,16.391c-.008.009.005.022.013.013.009-.009-.004-.022-.013-.013",
    style: {
      fill: "url(#Unbenannter_Verlauf_63)"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M8.155,16.409h-.002s-.008-.004-.009-.008c-.001-.004,0-.008.003-.011h0c.005-.006.012-.005.016,0s.006.011.001.017c-.003.002-.006.003-.009.003ZM8.15,16.393s-.002.005-.002.007c.001.003.003.005.006.005.002,0,.004,0,.006-.002.003-.004.002-.008-.001-.01-.002-.003-.006-.004-.009,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.138,16.416c-.009.01.005.023.015.013.009-.009-.005-.023-.015-.013",
    style: {
      fill: "url(#Unbenannter_Verlauf_64)"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M8.146,16.435s-.006,0-.009-.004c-.004-.004-.006-.011,0-.017h0c.006-.006.013-.005.017,0,.004.004.006.011.001.017-.003.004-.006.005-.009.005ZM8.14,16.418s-.002.008,0,.011c.003.003.008.004.012,0,.003-.004.002-.008-.001-.011-.002-.003-.007-.004-.011,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.125,16.442c-.01.011.006.025.016.014.01-.011-.006-.026-.016-.014",
    style: {
      fill: "url(#Unbenannter_Verlauf_65)"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M8.133,16.462s-.007,0-.009-.004c-.005-.004-.006-.012-.001-.018.003-.004.008-.006.012-.005.005,0,.009.005.01.009.001.005,0,.009-.003.013-.002.004-.005.005-.009.005ZM8.133,16.44s-.004,0-.006.003h0s-.003.009,0,.012c.003.003.008.004.012,0,.002-.003.003-.005.002-.008s-.004-.006-.007-.006t-.001-.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.751,15.096c-.047,0-.047.07,0,.07s.047-.07,0-.07",
    style: {
      fill: "url(#Unbenannter_Verlauf_66)"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M7.751,15.169c-.026,0-.037-.019-.037-.037,0-.01.003-.019.009-.026.007-.008.016-.012.028-.012.026,0,.038.019.038.037,0,.01-.003.019-.009.026-.008.008-.018.012-.029.012ZM7.751,15.099c-.022,0-.033.017-.033.033s.01.033.033.033c.01,0,.019-.004.025-.01.005-.006.008-.014.008-.023,0-.016-.01-.033-.033-.033Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.211,14.292c-.01,0-.02.003-.03.007-.017.007-.031.019-.036.036h0c-.147.409-.068.583.062.847.189.381.051.948-.371,1.196-.208.121-.368.163-.49.193-.061.015-.113.028-.157.047-.042.018-.086.051-.114.088.042.004.112.015.146.025.049-.063.174-.12.302-.164.129-.044.263-.075.335-.089h0c.237-.069.457-.223.623-.418.176-.207.266-.491.231-.775-.008-.065-.034-.105-.071-.126-.037-.022-.083-.025-.133-.022-.09.005-.178-.019-.258-.069-.104-.064-.146-.177-.145-.299.002-.123.048-.254.121-.353.026-.035.037-.062.036-.082-.001-.021-.014-.034-.03-.039-.004,0-.008-.002-.013-.002-.002-.001-.005-.001-.008-.001h0Z",
    style: {
      fill: "#825123"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M9.223,16.74h-.004c-.032-.011-.101-.022-.144-.026h-.012s.007-.011.007-.011c.027-.037.071-.071.117-.091.043-.018.093-.031.151-.045l.008-.002c.117-.029.278-.069.488-.193.437-.257.545-.831.368-1.187-.124-.251-.214-.432-.063-.852.005-.017.02-.031.04-.04.01-.004.021-.007.032-.008h.011c.005,0,.009,0,.014.003.021.006.035.023.035.045.001.023-.012.052-.038.087-.074.098-.118.229-.12.349-.002.132.048.236.141.293.081.05.167.073.254.068.06-.004.103.003.137.023.041.024.066.069.074.132.034.281-.05.566-.233.78-.173.204-.396.354-.627.42h-.002c-.04.008-.184.038-.333.089-.151.051-.257.109-.299.162l-.002.004ZM9.088,16.701c.042.004.098.014.13.023.058-.069.196-.127.302-.163.15-.051.295-.081.336-.089.228-.066.448-.214.62-.416.18-.212.263-.492.23-.77-.007-.058-.03-.099-.067-.121-.031-.018-.072-.025-.129-.021-.089.005-.18-.019-.262-.07-.097-.06-.15-.168-.148-.305.002-.123.048-.256.123-.357.024-.032.035-.058.035-.078,0-.016-.01-.028-.025-.032-.004,0-.007-.002-.011-.002h-.009c-.009,0-.018.003-.027.007-.01.004-.027.014-.033.031-.15.415-.061.594.062.842.179.361.07.944-.374,1.205-.212.124-.374.165-.492.194h-.009c-.057.015-.107.028-.149.046-.04.017-.077.045-.103.076Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.585,15.17c.071,0,.071.106,0,.106-.07,0-.071-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_67)"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M10.585,15.278c-.037,0-.056-.028-.056-.055,0-.014.005-.028.014-.038.01-.011.025-.017.042-.017.038,0,.055.029.055.055,0,.014-.005.028-.014.038-.009.011-.024.017-.041.017ZM10.585,15.172c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.025-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.453,15.163c.071,0,.071.106,0,.106s-.072-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_68)"
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M10.453,15.271c-.037,0-.056-.028-.056-.055,0-.014.005-.028.014-.038.01-.011.025-.017.042-.017.038,0,.055.029.055.055,0,.014-.005.028-.014.038-.01.011-.024.017-.041.017ZM10.453,15.166c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.021.013-.035,0-.025-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.322,15.17c.071,0,.071.106,0,.106-.071,0-.072-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_69)"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10.322,15.278c-.037,0-.056-.028-.056-.055,0-.014.005-.028.014-.038.01-.011.025-.017.042-.017.038,0,.055.029.055.055,0,.014-.005.028-.014.038-.01.011-.024.017-.041.017ZM10.322,15.172c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.025-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.634,15.287c.071,0,.071.106,0,.106s-.072-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_70)"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.634,15.395c-.037,0-.056-.028-.056-.055,0-.014.005-.028.014-.038.01-.011.025-.017.042-.017.038,0,.055.029.055.055,0,.014-.005.028-.014.038-.01.011-.024.017-.041.017ZM10.634,15.289c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.021.013-.035,0-.024-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.503,15.287c.071,0,.071.106,0,.106s-.072-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_71)"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M10.503,15.395c-.037,0-.056-.028-.056-.055,0-.014.005-.028.014-.038.01-.011.025-.017.042-.017.038,0,.055.029.055.055,0,.014-.005.028-.014.038-.01.011-.024.017-.041.017ZM10.503,15.289c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.021.013-.035,0-.024-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.371,15.287c.071,0,.071.106,0,.106s-.071-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_72)"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M10.371,15.395c-.037,0-.056-.028-.056-.055,0-.014.005-.028.014-.038.01-.011.025-.017.042-.017.038,0,.055.029.055.055,0,.014-.005.028-.014.038-.009.011-.024.017-.041.017ZM10.371,15.289c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.021.013-.035,0-.024-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.639,15.41c.071,0,.071.106,0,.106s-.072-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_73)"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M10.639,15.518c-.037,0-.056-.028-.056-.055,0-.014.005-.028.014-.038.01-.011.025-.017.042-.017.038,0,.055.029.055.055,0,.014-.005.028-.014.038-.009.011-.024.017-.041.017ZM10.639,15.412c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.021.013-.035,0-.025-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.516,15.405c.071,0,.071.106,0,.106s-.072-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_74)"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M10.516,15.513c-.037,0-.056-.028-.056-.055,0-.014.005-.028.014-.038.01-.011.025-.017.042-.017.038,0,.055.029.055.055,0,.014-.005.028-.014.038-.01.011-.024.017-.041.017ZM10.516,15.408c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.025-.017-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.384,15.405c.071,0,.071.106,0,.106s-.072-.106,0-.106",
    style: {
      fill: "url(#Unbenannter_Verlauf_75)"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M10.384,15.513c-.037,0-.056-.028-.056-.055,0-.014.005-.028.014-.038.01-.011.025-.017.042-.017.038,0,.055.029.055.055,0,.014-.005.028-.014.038-.01.011-.024.017-.041.017ZM10.384,15.408c-.016,0-.029.005-.038.016-.008.009-.013.021-.013.035,0,.024.016.051.051.051.016,0,.029-.005.038-.016.008-.009.013-.022.013-.035,0-.025-.016-.051-.051-.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.62,15.535c.066,0,.066.099,0,.099-.067.001-.068-.099,0-.099",
    style: {
      fill: "url(#Unbenannter_Verlauf_76)"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M10.62,15.637c-.035,0-.053-.026-.053-.052,0-.013.005-.026.013-.036.01-.011.023-.016.04-.016.036,0,.052.027.052.052,0,.014-.005.026-.013.036-.009.01-.023.016-.039.016ZM10.62,15.538c-.015,0-.028.005-.036.015-.008.009-.012.02-.012.032,0,.023.015.048.048.048.015,0,.027-.005.036-.015.008-.009.012-.02.012-.033,0-.023-.015-.047-.048-.047Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.497,15.535c.066,0,.066.099,0,.099-.068.001-.068-.099,0-.099",
    style: {
      fill: "url(#Unbenannter_Verlauf_77)"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M10.497,15.637c-.036,0-.053-.027-.053-.052,0-.014.005-.026.013-.036.01-.011.023-.016.04-.016.036,0,.052.027.052.052,0,.014-.005.026-.013.036-.01.01-.023.016-.039.016ZM10.497,15.538c-.015,0-.027.005-.036.015-.008.009-.012.02-.012.033,0,.023.015.047.048.047.015,0,.027-.005.036-.015.008-.009.012-.02.012-.033-.001-.023-.016-.047-.048-.047Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.372,15.535c.066,0,.066.099,0,.099-.067.001-.068-.099,0-.099",
    style: {
      fill: "url(#Unbenannter_Verlauf_78)"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M10.372,15.637c-.035,0-.053-.026-.053-.052,0-.013.005-.026.013-.036.01-.011.023-.016.04-.016.036,0,.052.027.052.052,0,.014-.005.026-.013.036-.009.01-.023.016-.039.016ZM10.372,15.538c-.015,0-.028.005-.036.015-.008.009-.012.02-.012.032,0,.023.015.048.048.048.015,0,.027-.005.036-.015.008-.009.012-.02.012-.033,0-.023-.015-.047-.048-.047Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.594,15.665c.064.003.059.098-.004.095s-.061-.099.004-.095",
    style: {
      fill: "url(#Unbenannter_Verlauf_79)"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M10.592,15.762h-.003c-.019,0-.034-.01-.042-.026-.008-.016-.007-.038.003-.053.009-.015.025-.022.044-.021s.034.01.042.025c.008.016.008.037-.002.053-.009.015-.024.022-.042.022ZM10.59,15.667c-.016,0-.029.007-.037.019-.009.014-.01.033-.002.048.007.014.021.022.038.023h.003c.016,0,.03-.007.038-.02.009-.014.01-.034.002-.048-.007-.014-.021-.022-.038-.022h-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.481,15.652c.064.003.059.098-.004.095-.064-.003-.06-.098.004-.095",
    style: {
      fill: "url(#Unbenannter_Verlauf_80)"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M10.48,15.749h-.003c-.034,0-.049-.028-.048-.052.001-.024.018-.049.053-.048h0c.034,0,.049.028.048.052-.002.024-.019.048-.05.048ZM10.479,15.654c-.03,0-.045.022-.045.044-.001.022.012.046.044.047h.003c.03,0,.044-.022.045-.043.001-.022-.012-.046-.043-.047-.002,0-.003,0-.004,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.362,15.646c.064.003.059.098-.004.095-.064-.003-.06-.098.004-.095",
    style: {
      fill: "url(#Unbenannter_Verlauf_81)"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M10.361,15.744h-.003c-.019,0-.034-.01-.042-.026-.008-.016-.007-.038.002-.053.009-.015.025-.022.044-.021s.034.01.042.025c.009.016.008.037-.002.053-.009.014-.024.022-.041.022ZM10.359,15.648c-.016,0-.029.007-.037.019-.009.014-.01.033-.002.048.007.014.021.022.038.023h.003c.016,0,.03-.007.038-.02.009-.014.01-.033.002-.048-.007-.014-.021-.022-.038-.023h0s-.003.001-.004.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.549,15.776c.061.005.055.095-.006.091-.062-.004-.056-.095.006-.091",
    style: {
      fill: "url(#Unbenannter_Verlauf_82)"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M10.547,15.869h-.004c-.018,0-.033-.01-.04-.025-.008-.016-.007-.036.003-.051.009-.014.025-.021.043-.02h0c.033.003.046.028.045.051-.002.023-.017.045-.047.045ZM10.544,15.778c-.015,0-.027.006-.035.018-.009.013-.01.032-.003.046.007.013.02.021.036.023h.004c.027,0,.041-.02.042-.04.002-.021-.01-.044-.04-.046h0s-.002-.001-.004-.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.446,15.762c.058.003.052.09-.005.087-.059-.004-.054-.091.005-.087",
    style: {
      fill: "url(#Unbenannter_Verlauf_83)"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M10.444,15.851h-.003c-.018,0-.031-.01-.038-.024-.008-.015-.006-.034.003-.049.009-.013.023-.02.041-.019.017,0,.031.009.038.024.008.015.006.035-.003.049-.01.012-.023.019-.038.019ZM10.442,15.764c-.014,0-.026.006-.033.017-.008.013-.01.03-.003.044.006.013.019.02.034.021h.003c.014,0,.026-.006.033-.017.008-.013.01-.031.003-.044-.006-.013-.018-.02-.034-.021h-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.336,15.756c.047.003.042.074-.004.07-.047-.002-.043-.072.004-.07",
    style: {
      fill: "url(#Unbenannter_Verlauf_84)"
    }
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M10.335,15.829h-.004c-.024,0-.036-.021-.035-.039.001-.017.013-.035.037-.035h.003c.014,0,.025.008.031.02.006.013.005.029-.003.04-.006.008-.016.014-.029.014ZM10.334,15.759c-.021,0-.032.016-.033.031-.001.016.008.033.031.034.012,0,.023-.004.029-.013.007-.01.008-.024.002-.036-.005-.01-.015-.016-.027-.017h0s0,.001-.002.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.502,15.876c.058.003.052.09-.005.087-.059-.003-.053-.09.005-.087",
    style: {
      fill: "url(#Unbenannter_Verlauf_85)"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,15.966h-.003c-.032-.002-.045-.027-.043-.049.001-.021.016-.043.045-.043h.004c.017,0,.031.009.038.024.008.015.006.035-.003.049-.009.012-.022.019-.038.019ZM10.499,15.879c-.026,0-.039.02-.04.039-.001.02.01.042.039.044.016,0,.029-.005.036-.017.008-.013.01-.031.003-.044-.006-.013-.018-.02-.034-.021h0s-.003,0-.004,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.403,15.853c.048.004.043.076-.004.073-.049-.004-.045-.076.004-.073",
    style: {
      fill: "url(#Unbenannter_Verlauf_86)"
    }
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M10.402,15.928h-.004c-.026-.002-.038-.023-.036-.042.001-.018.015-.037.041-.035h0c.027.002.037.023.036.042-.002.017-.014.035-.037.035ZM10.399,15.855c-.021,0-.032.016-.033.031-.001.017.008.035.032.037h.003c.021,0,.031-.016.033-.031.001-.016-.008-.035-.032-.037h-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.31,15.841c.04.002.036.063-.004.06-.04-.002-.036-.063.004-.06",
    style: {
      fill: "url(#Unbenannter_Verlauf_87)"
    }
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M10.309,15.903h-.003c-.012,0-.022-.006-.027-.017-.005-.011-.005-.024.002-.034.006-.009.017-.014.029-.013.012,0,.022.006.027.016.005.011.005.025-.002.035-.006.008-.015.013-.026.013ZM10.308,15.843c-.01,0-.017.004-.022.011-.006.009-.006.021-.002.03.004.009.013.013.023.014s.019-.003.024-.011c.006-.009.007-.021.002-.03-.004-.008-.012-.013-.023-.013h0s0,0-.002,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.461,15.967c.053.012.035.092-.018.079-.053-.012-.035-.091.018-.079",
    style: {
      fill: "url(#Unbenannter_Verlauf_88)"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M10.454,16.049s-.008,0-.012,0c-.029-.006-.037-.031-.032-.051.005-.021.024-.039.051-.033h0c.016.004.027.013.032.028.005.015.001.033-.01.045-.008.008-.018.012-.029.012ZM10.451,15.968c-.02,0-.033.015-.036.03-.004.018.004.039.029.045.014.003.027,0,.036-.01.01-.01.013-.026.009-.04-.004-.013-.014-.021-.028-.025h-.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.373,15.932c.044.01.029.076-.014.065-.044-.01-.03-.076.014-.065",
    style: {
      fill: "url(#Unbenannter_Verlauf_89)"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M10.368,16.001s-.006,0-.01,0c-.013-.003-.023-.011-.027-.024-.004-.013,0-.028.009-.037.008-.009.02-.012.034-.009.013.003.023.011.027.023.004.013,0,.028-.009.038-.007.006-.015.01-.024.01ZM10.364,15.933c-.008,0-.015.003-.02.009-.008.008-.011.021-.008.033.003.011.012.018.023.021s.022,0,.029-.007c.008-.008.011-.022.008-.033-.003-.01-.011-.018-.023-.02h0s-.006-.003-.009-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.29,15.907c.037.008.024.064-.013.055-.036-.008-.024-.064.013-.055",
    style: {
      fill: "url(#Unbenannter_Verlauf_90)"
    }
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M10.285,15.965s-.005,0-.008,0c-.011-.003-.019-.009-.022-.02-.003-.011,0-.023.007-.032.007-.008.017-.01.029-.008.011.003.019.009.022.02.003.011,0,.023-.007.032-.006.006-.013.009-.021.009ZM10.282,15.908c-.007,0-.013.003-.017.007-.007.007-.009.018-.006.027s.009.014.019.017c.01.002.018,0,.024-.006.007-.007.009-.018.006-.027s-.009-.014-.019-.017h0s-.005-.001-.007-.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.404,16.048c.047.016.022.087-.025.07-.047-.016-.023-.087.025-.07",
    style: {
      fill: "url(#Unbenannter_Verlauf_91)"
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M10.392,16.123c-.005,0-.01,0-.015-.003-.014-.005-.023-.015-.026-.029s.003-.03.014-.04c.011-.009.024-.011.039-.006.014.005.023.015.026.028.003.014-.003.031-.014.04-.007.007-.015.01-.024.01ZM10.389,16.048c-.008,0-.015.003-.021.008-.01.008-.015.023-.012.035.002.012.01.021.023.025.013.005.024.003.034-.005s.015-.023.013-.036c-.002-.012-.01-.021-.023-.025h0c-.005,0-.009-.002-.014-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.327,16.006c.039.013.018.073-.021.058-.039-.013-.019-.072.021-.058",
    style: {
      fill: "url(#Unbenannter_Verlauf_92)"
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M10.318,16.069s-.008,0-.013-.002c-.012-.004-.02-.013-.022-.024-.002-.012.002-.026.012-.034.009-.008.02-.009.033-.005.012.004.02.013.022.024.002.012-.003.026-.012.034-.007.005-.013.007-.02.007ZM10.315,16.006c-.006,0-.012.002-.017.006-.008.007-.012.019-.01.029s.009.017.019.021c.01.004.02.003.027-.004.008-.007.013-.019.011-.029s-.009-.017-.019-.021h0s-.008-.002-.011-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.253,15.975c.032.011.015.06-.017.048-.032-.011-.015-.061.017-.048",
    style: {
      fill: "url(#Unbenannter_Verlauf_93)"
    }
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M10.246,16.027s-.007,0-.01-.002c-.01-.004-.017-.011-.018-.021-.002-.01.002-.022.01-.028.007-.006.017-.007.027-.003.01.003.016.01.018.02s-.002.022-.01.029c-.006.003-.011.005-.017.005ZM10.243,15.975c-.005,0-.009.002-.013.005-.007.005-.01.015-.009.024.001.008.007.014.015.017.008.003.016.002.022-.003.007-.006.01-.015.008-.024-.002-.008-.007-.014-.015-.016h0s-.005-.003-.008-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.354,16.117c.041.019.013.08-.029.061-.041-.018-.012-.079.029-.061",
    style: {
      fill: "url(#Unbenannter_Verlauf_94)"
    }
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M10.342,16.184c-.006,0-.011,0-.017-.004-.012-.005-.02-.015-.021-.027-.001-.013.005-.027.016-.035.01-.008.023-.008.036-.003.013.006.02.016.021.028.001.013-.005.027-.016.035-.006.004-.013.006-.019.006ZM10.339,16.116c-.006,0-.012.002-.017.006-.01.007-.015.019-.014.031.001.01.008.019.019.024s.022.005.031,0c.01-.007.015-.019.014-.03-.001-.011-.008-.02-.019-.025-.005-.004-.009-.005-.014-.005Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.288,16.073c.034.015.01.067-.023.051-.034-.015-.011-.068.023-.051",
    style: {
      fill: "url(#Unbenannter_Verlauf_95)"
    }
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M10.277,16.129s-.009,0-.014-.003c-.01-.005-.017-.013-.018-.024-.001-.011.004-.023.014-.03.009-.006.019-.007.03-.002.01.005.017.013.018.024.001.011-.005.023-.014.03-.005.003-.01.005-.016.005ZM10.275,16.072c-.005,0-.009,0-.013.004-.008.006-.013.016-.012.026.001.009.006.016.015.02.009.004.017.004.024,0,.008-.006.013-.016.012-.026-.001-.009-.006-.016-.015-.02h0s-.007-.003-.011-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.224,16.038c.029.013.008.055-.02.043-.028-.014-.008-.057.02-.043",
    style: {
      fill: "url(#Unbenannter_Verlauf_96)"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M10.215,16.085s-.007,0-.011-.003c-.009-.004-.014-.012-.015-.021-.001-.01.004-.019.012-.025.007-.005.016-.006.025,0h0c.016.008.018.023.013.034-.005.009-.014.016-.024.016ZM10.214,16.037s-.008,0-.011.003c-.006.005-.01.013-.01.021.001.007.005.013.013.017.013.006.024,0,.028-.011.004-.009.003-.022-.01-.028h0s-.007-.002-.01-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.292,16.175c.034.017.007.069-.026.051-.034-.017-.008-.069.026-.051",
    style: {
      fill: "url(#Unbenannter_Verlauf_97)"
    }
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M10.28,16.232c-.005,0-.01,0-.015-.004-.01-.005-.017-.014-.017-.025-.001-.012.005-.023.015-.03.009-.006.02-.006.03,0,.01.005.016.014.017.025.001.012-.006.024-.015.03-.005.002-.01.004-.015.004ZM10.278,16.173s-.009,0-.013.004c-.008.005-.013.016-.013.025,0,.009.006.017.015.021.009.005.017.005.025,0,.008-.005.014-.016.013-.026,0-.009-.006-.016-.014-.021h0s-.008-.003-.013-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.238,16.134c.029.014.006.057-.022.042-.028-.014-.006-.057.022-.042",
    style: {
      fill: "url(#Unbenannter_Verlauf_98)"
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M10.228,16.182s-.009,0-.013-.004c-.009-.004-.014-.012-.015-.021,0-.01.005-.02.013-.025.008-.005.017-.005.025,0,.009.004.014.012.015.021,0,.01-.005.02-.013.025-.003.003-.008.004-.012.004ZM10.226,16.133s-.007,0-.01.003c-.007.004-.011.013-.011.021,0,.007.005.014.012.017.007.004.014.004.021,0s.011-.013.011-.021c0-.007-.005-.014-.012-.017h0s-.007-.003-.011-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.185,16.102c.023.013.004.047-.018.035-.023-.012-.005-.048.018-.035",
    style: {
      fill: "url(#Unbenannter_Verlauf_99)"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M10.177,16.142s-.007,0-.011-.003c-.007-.004-.012-.01-.012-.018s.004-.017.011-.021c.006-.004.014-.004.021,0s.012.011.012.018c0,.008-.004.017-.011.021-.003.002-.007.003-.01.003ZM10.175,16.102s-.006,0-.008.002c-.006.003-.009.01-.009.017,0,.006.004.011.01.014.006.003.011.003.016,0,.006-.003.009-.01.009-.017,0-.006-.004-.011-.009-.015h0s-.006,0-.009,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.241,16.225c.03.019,0,.064-.029.044-.03-.019,0-.064.029-.044",
    style: {
      fill: "url(#Unbenannter_Verlauf_100)"
    }
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M10.227,16.276c-.005,0-.011-.002-.016-.005-.009-.006-.014-.015-.013-.025.001-.011.007-.021.017-.026.009-.004.019-.004.028.002.009.006.014.015.013.025-.001.011-.007.021-.017.026-.005.002-.009.003-.012.003ZM10.225,16.222s-.007,0-.01.002c-.008.004-.014.013-.014.022,0,.008.004.016.011.021s.015.006.023.002c.008-.004.014-.013.015-.022,0-.008-.004-.016-.011-.02h0s-.009-.005-.014-.005Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.195,16.184c.024.016,0,.053-.024.037s0-.054.024-.037",
    style: {
      fill: "url(#Unbenannter_Verlauf_101)"
    }
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M10.183,16.227s-.009,0-.013-.004c-.008-.005-.012-.013-.011-.021.001-.009.007-.018.015-.022.007-.003.016-.003.023.003.013.009.013.024.007.034-.006.005-.013.01-.021.01ZM10.182,16.182s-.005,0-.007.002c-.007.003-.011.01-.012.018-.001.007.003.013.009.017.011.007.022.002.027-.006s.006-.02-.005-.027h0s-.008-.004-.012-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.149,16.149c.021.013,0,.044-.02.03-.02-.013,0-.044.02-.03",
    style: {
      fill: "url(#Unbenannter_Verlauf_102)"
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M10.14,16.185s-.008,0-.011-.004c-.007-.004-.01-.011-.01-.018,0-.008.005-.015.012-.018.006-.003.013-.003.02.002h0c.007.004.01.011.01.018,0,.008-.005.015-.012.018-.004.001-.007.002-.009.002ZM10.139,16.148s-.004,0-.006.002c-.005.003-.009.008-.01.014,0,.005.002.01.007.014.005.003.01.004.015.002.005-.003.009-.008.01-.014,0-.006-.002-.01-.007-.014h0s-.006-.004-.009-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.189,16.266c.03.02,0,.064-.029.044-.029-.019,0-.064.029-.044",
    style: {
      fill: "url(#Unbenannter_Verlauf_103)"
    }
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M10.176,16.317c-.005,0-.011-.002-.016-.005-.009-.006-.014-.015-.013-.025.001-.011.007-.021.017-.026.009-.005.019-.004.028.003h0c.009.006.014.015.013.025-.001.011-.008.021-.017.025-.005.002-.009.003-.012.003ZM10.174,16.264s-.007,0-.01.002c-.008.004-.014.013-.014.022,0,.008.004.016.011.021.008.005.016.006.023.002.008-.004.014-.012.014-.021.001-.008-.003-.016-.011-.021h0s-.008-.005-.013-.005Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.144,16.226c.024.016,0,.053-.024.037-.025-.017,0-.053.024-.037",
    style: {
      fill: "url(#Unbenannter_Verlauf_104)"
    }
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M10.132,16.269c-.005,0-.009-.002-.014-.005-.008-.005-.012-.012-.011-.021s.006-.018.014-.022c.008-.004.016-.003.023.002h0c.008.005.012.013.011.021-.001.009-.006.018-.014.021-.003.003-.006.004-.009.004ZM10.131,16.224s-.005,0-.008.002c-.007.003-.011.01-.012.018,0,.007.003.013.009.017s.013.005.019.002c.007-.003.011-.01.012-.018,0-.007-.003-.013-.009-.017h0s-.007-.004-.011-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.106,16.191c.021.014,0,.044-.02.031-.02-.014,0-.046.02-.031",
    style: {
      fill: "url(#Unbenannter_Verlauf_105)"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M10.097,16.227s-.008,0-.011-.004c-.007-.004-.01-.011-.01-.018.001-.008.006-.015.013-.018.006-.003.013-.002.019.002.007.004.01.011.01.018,0,.008-.005.015-.012.018-.004.001-.007.002-.009.002ZM10.096,16.19s-.004,0-.006,0c-.005.003-.009.008-.01.015,0,.006.002.011.007.014s.01.004.015,0c.005-.003.009-.008.01-.014,0-.005-.002-.01-.007-.014h0s-.007-.003-.009-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.066,16.234c.019.012,0,.04-.018.029-.019-.013,0-.042.018-.029",
    style: {
      fill: "url(#Unbenannter_Verlauf_106)"
    }
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M10.057,16.267s-.007,0-.01-.003c-.006-.004-.009-.01-.009-.017s.005-.014.012-.017c.006-.003.012-.002.018.002s.009.009.009.016-.005.014-.011.018c-.004.001-.007.001-.009.001ZM10.057,16.233s-.004,0-.005,0c-.005.002-.009.008-.009.013s.002.01.007.013c.004.003.009.003.013,0,.005-.003.009-.008.009-.014,0-.003-.001-.008-.007-.012h0s-.006-.002-.008-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.099,16.271c.021.013,0,.044-.02.03-.02-.013,0-.044.02-.03",
    style: {
      fill: "url(#Unbenannter_Verlauf_107)"
    }
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M10.089,16.307s-.008,0-.011-.004c-.007-.004-.01-.011-.01-.018,0-.008.005-.015.012-.018.006-.003.013-.003.02.002.007.004.01.011.01.018,0,.008-.005.015-.012.018-.003.001-.006.002-.009.002ZM10.089,16.27s-.004,0-.006,0c-.005.003-.009.008-.01.014,0,.005.002.01.007.014.005.003.01.004.015.002.005-.003.009-.008.01-.014,0-.005-.002-.01-.007-.014h0s-.006-.003-.009-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.135,16.308c.022.015,0,.048-.022.033-.022-.014,0-.048.022-.033",
    style: {
      fill: "url(#Unbenannter_Verlauf_108)"
    }
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125,16.348s-.009-.002-.013-.004c-.007-.004-.011-.011-.01-.019.001-.008.006-.016.013-.02.007-.003.014-.002.021.002.007.005.011.012.01.02-.001.008-.006.016-.013.019-.003,0-.005.002-.008.002ZM10.124,16.307s-.004,0-.006,0c-.006.003-.01.009-.011.016,0,.006.003.011.008.015s.011.005.017.002c.006-.003.01-.009.011-.016.001-.006-.002-.012-.008-.016h0c-.005-.001-.008-.002-.011-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.024,16.278c.017.012,0,.037-.017.026-.017-.012,0-.038.017-.026",
    style: {
      fill: "url(#Unbenannter_Verlauf_109)"
    }
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M10.015,16.309s-.006,0-.01-.003c-.01-.007-.01-.018-.005-.025s.014-.011.024-.004h0c.01.007.01.017.005.024-.002.004-.008.008-.014.008ZM10.015,16.277s-.008.003-.01.006c-.004.005-.004.014.003.019s.015,0,.018-.004c.004-.005.004-.013-.004-.018-.002-.002-.005-.003-.007-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.05,16.31c.019.013,0,.04-.018.028-.019-.013,0-.04.018-.028",
    style: {
      fill: "url(#Unbenannter_Verlauf_110)"
    }
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M10.042,16.343s-.007,0-.011-.004c-.006-.004-.009-.01-.009-.017s.005-.014.011-.017c.006-.003.012-.002.018.002s.009.01.009.017c-.001.007-.005.014-.011.017-.002.002-.005.002-.007.002ZM10.041,16.309s-.004,0-.005,0c-.005.002-.008.008-.009.013,0,.005.002.009.007.013.004.003.009.004.013.002.005-.002.008-.007.009-.013,0-.005-.002-.01-.007-.013h0s-.005-.003-.008-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.082,16.342c.02.012,0,.043-.02.03-.019-.014.001-.044.02-.03",
    style: {
      fill: "url(#Unbenannter_Verlauf_111)"
    }
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M10.073,16.377s-.008,0-.011-.004c-.011-.008-.011-.02-.005-.028.005-.008.016-.013.028-.005.006.004.01.01.009.017,0,.008-.005.015-.012.018-.004,0-.007.002-.009.002ZM10.072,16.341c-.005,0-.009.003-.012.007-.004.006-.005.016.004.022.005.003.01.004.015,0,.005-.003.009-.008.009-.014,0-.005-.002-.01-.007-.013h0s-.006-.003-.009-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.983,16.307c.015.01,0,.034-.015.023-.016-.009,0-.034.015-.023",
    style: {
      fill: "url(#Unbenannter_Verlauf_112)"
    }
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M9.976,16.335s-.006,0-.009-.003c-.005-.003-.008-.008-.007-.014,0-.006.004-.012.01-.015.005-.002.01-.002.015.002.005.003.008.008.007.014,0,.006-.004.012-.01.015-.002,0-.004,0-.006,0ZM9.975,16.307s-.003,0-.004,0c-.004.002-.007.006-.007.011,0,.004.002.008.005.01.005.003.008.003.011,0,.004-.002.007-.006.007-.011,0-.004-.002-.008-.005-.01h0s-.005-.002-.007-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.007,16.337c.017.012,0,.038-.017.026-.017-.012,0-.037.017-.026",
    style: {
      fill: "url(#Unbenannter_Verlauf_113)"
    }
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M9.999,16.368s-.007,0-.01-.003c-.01-.007-.01-.018-.005-.025s.014-.011.024-.005h0c.01.007.01.018.005.025-.003.005-.008.008-.014.008ZM9.998,16.336s-.008.003-.01.006c-.004.005-.004.014.003.019s.014.002.018-.004c.004-.005.004-.014-.003-.019-.003,0-.005-.002-.008-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.036,16.371c.018.012,0,.04-.018.027-.018-.012,0-.04.018-.027",
    style: {
      fill: "url(#Unbenannter_Verlauf_114)"
    }
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M10.028,16.404s-.008,0-.011-.004c-.006-.004-.009-.01-.008-.016.001-.007.005-.014.011-.017.006-.003.012-.002.018.003.006.004.009.01.008.017-.001.007-.005.014-.011.017-.003,0-.005,0-.007,0ZM10.026,16.37s-.003,0-.005,0c-.005.002-.008.007-.009.013,0,.005.002.009.006.012.006.004.01.003.013.002.005-.002.008-.007.009-.013,0-.005-.002-.009-.006-.012h0s-.005-.003-.008-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.949,16.333c.014.011-.002.032-.016.022-.013-.011.002-.032.016-.022",
    style: {
      fill: "url(#Unbenannter_Verlauf_115)"
    }
  }), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M9.941,16.36s-.006,0-.01-.003c-.008-.007-.007-.016-.002-.023.004-.006.013-.009.021-.003s.008.016.003.022c-.002.004-.007.007-.012.007ZM9.941,16.333s-.006.002-.008.004c-.003.004-.004.011.002.016s.012.002.016-.002c.003-.004.004-.011-.002-.016h0s-.006-.002-.008-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.971,16.361c.015.012-.002.035-.017.023-.015-.011.002-.034.017-.023",
    style: {
      fill: "url(#Unbenannter_Verlauf_116)"
    }
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M9.963,16.39s-.007,0-.01-.004c-.005-.004-.007-.009-.007-.015.001-.006.005-.012.011-.014.005-.002.011,0,.016.002h0c.009.007.008.017.003.024-.003.004-.008.007-.013.007ZM9.962,16.361s-.003,0-.004,0c-.004.002-.007.006-.008.011-.001.004.001.008.005.011.006.005.013.003.016-.002.004-.005.004-.012-.002-.017h0s-.004-.004-.007-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.992,16.391c.016.013-.002.039-.019.025-.016-.012.002-.038.019-.025",
    style: {
      fill: "url(#Unbenannter_Verlauf_117)"
    }
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M9.983,16.423s-.007,0-.011-.004c-.009-.007-.009-.019-.003-.026.005-.007.015-.01.025-.003h0c.009.007.009.019.003.026-.004.004-.009.007-.014.007ZM9.982,16.39s-.008.002-.01.005c-.004.005-.005.014.002.02.008.006.015.003.018-.002.004-.006.005-.014-.002-.02h0s-.005-.003-.008-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.917,16.354c.012.01-.004.028-.015.017s.003-.028.015-.017",
    style: {
      fill: "url(#Unbenannter_Verlauf_118)"
    }
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M9.909,16.377s-.006,0-.009-.004c-.007-.006-.006-.015-.001-.02.005-.005.013-.007.019,0,.004.003.006.008.005.013-.001.005-.005.01-.01.011-.001.001-.002.001-.004.001ZM9.909,16.353s-.005,0-.007.003c-.003.003-.004.009.001.013.003.003.007.003.009.002.003,0,.006-.004.007-.008,0-.002,0-.005-.003-.008h0s-.005-.002-.007-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.935,16.384c.012.011-.004.03-.017.018-.013-.011.004-.031.017-.018",
    style: {
      fill: "url(#Unbenannter_Verlauf_119)"
    }
  }), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M9.926,16.408s-.007-.002-.01-.005c-.004-.004-.006-.009-.005-.014.001-.005.005-.01.011-.012.005,0,.01,0,.014.004s.006.009.004.014c-.001.005-.006.01-.011.012,0,0,0,0-.003,0ZM9.926,16.382h-.002s-.007.004-.008.008c-.001.003,0,.007.003.009.003.003.006.004.009.003.004,0,.007-.004.007-.008,0-.002.001-.006-.003-.009h0s-.004-.003-.006-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.951,16.412c.013.013-.004.032-.018.02-.013-.012.005-.032.018-.02",
    style: {
      fill: "url(#Unbenannter_Verlauf_120)"
    }
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M9.943,16.438s-.008-.002-.011-.005c-.004-.004-.006-.009-.005-.014.001-.006.006-.011.011-.013s.011,0,.015.004h0c.008.007.006.017.001.023-.003.003-.006.005-.01.005,0,0-.001,0-.001,0ZM9.942,16.411h-.003s-.007.005-.008.009c-.001.004.001.007.004.01.003.003.007.004.011.003.004,0,.007-.004.008-.008.001-.004,0-.008-.004-.011-.003-.003-.005-.003-.008-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.883,16.371c.011.01-.004.026-.015.016-.011-.01.004-.026.015-.016",
    style: {
      fill: "url(#Unbenannter_Verlauf_121)"
    }
  }), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875,16.393s-.006,0-.009-.004c-.007-.007-.005-.015,0-.02.002-.002.006-.004.009-.004h0s.007,0,.009.004c.006.006.005.014.001.018-.002.003-.005.004-.009.005t-.001.001ZM9.875,16.37h0s-.004,0-.006.003c-.003.003-.004.008,0,.013.004.004.01.003.012,0,.003-.003.004-.008,0-.012h0s-.004-.003-.006-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.895,16.398c.012.012-.004.029-.016.017-.011-.011.005-.029.016-.017",
    style: {
      fill: "url(#Unbenannter_Verlauf_122)"
    }
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M9.888,16.421s-.007,0-.01-.005c-.004-.004-.006-.009-.004-.013.001-.005.005-.009.01-.011.005,0,.01,0,.013.004h0c.007.007.005.016,0,.021-.002.003-.005.004-.009.004ZM9.887,16.396h-.002s-.006.004-.007.007,0,.007.003.009c.005.005.01.004.013,0,.003-.003.005-.009,0-.014-.003-.002-.005-.003-.007-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.913,16.428c.013.013-.005.031-.018.019-.012-.012.005-.032.018-.019",
    style: {
      fill: "url(#Unbenannter_Verlauf_123)"
    }
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M9.905,16.453s-.008-.002-.011-.005c-.004-.004-.006-.009-.005-.014.001-.005.006-.01.011-.012s.011,0,.015.004h0s.006.01.004.015c-.001.005-.006.01-.011.011-.001,0-.002,0-.003,0ZM9.904,16.426h-.003s-.007.004-.008.008c-.001.004,0,.007.003.01.004.004.008.004.01.003.004,0,.007-.004.008-.008.001-.004,0-.008-.003-.011-.002-.001-.005-.002-.007-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.851,16.391c.008.009-.005.022-.013.013-.008-.009.004-.022.013-.013",
    style: {
      fill: "url(#Unbenannter_Verlauf_124)"
    }
  }), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M9.844,16.409s-.006,0-.008-.004c-.005-.006-.003-.013.001-.017.004-.004.011-.005.016,0h0s.004.007.003.011c-.001.004-.005.007-.009.008-.001.001-.002.001-.003.001ZM9.844,16.39s-.003,0-.004.002c-.003.003-.004.007-.001.01.002.002.004.002.006.002.003,0,.005-.003.006-.005.001-.002.001-.004-.002-.007,0-.001-.003-.002-.005-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.861,16.416c.009.01-.005.023-.015.013-.008-.009.005-.023.015-.013",
    style: {
      fill: "url(#Unbenannter_Verlauf_125)"
    }
  }), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M9.854,16.435s-.006,0-.009-.004c-.005-.006-.003-.014.001-.018.004-.004.011-.005.017,0h0c.005.006.004.013,0,.017-.003.003-.006.004-.009.004ZM9.854,16.415s-.004,0-.005.002c-.003.002-.004.007-.001.011.004.004.009.003.012,0s.004-.007,0-.011c-.003,0-.005-.002-.006-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.874,16.442c.01.011-.006.025-.016.014-.01-.011.007-.026.016-.014",
    style: {
      fill: "url(#Unbenannter_Verlauf_126)"
    }
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M9.866,16.462s-.007,0-.01-.004c-.003-.004-.005-.008-.003-.013s.006-.008.01-.009c.005,0,.009,0,.012.005.006.006.004.014-.001.018,0,.002-.004.003-.008.003ZM9.866,16.44h-.001s-.006.003-.007.006,0,.006.002.008c.004.004.009.003.012,0s.004-.008,0-.012h0s-.004-.002-.006-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.249,15.096c.047,0,.047.07,0,.07s-.048-.07,0-.07",
    style: {
      fill: "url(#Unbenannter_Verlauf_127)"
    }
  }), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M10.249,15.169c-.025,0-.038-.019-.038-.038,0-.01.003-.019.009-.025.007-.008.017-.012.028-.012.026,0,.037.019.037.037,0,.01-.003.019-.009.026-.006.008-.016.012-.027.012ZM10.249,15.099c-.01,0-.019.003-.025.01-.005.006-.008.014-.008.022,0,.016.01.033.033.033.01,0,.019-.004.024-.01s.008-.014.008-.023c0-.015-.01-.032-.032-.032Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.919,15.033c.052-.173.078-.395.004-.684.323-.209.551-.399,1.078-.399s.774.145,1.078.399c-.073.289-.047.51.004.684h-2.166",
    style: {
      fill: "#89c5e3"
    }
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M10.086,15.035h-2.169v-.003h0v-.002h0c.064-.215.066-.438.004-.681v-.002h0c.034-.023.067-.045.099-.066.272-.18.508-.335.98-.335.251,0,.449.033.623.104.178.073.325.185.456.296h.001v.002c-.061.242-.059.466.004.683v.004ZM7.922,15.03h2.158c-.063-.217-.064-.44-.004-.681-.315-.264-.568-.398-1.075-.398-.471,0-.706.155-.978.334-.032.021-.064.042-.097.064.061.243.06.466-.004.681Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.165,14.612l-.024.261h-.001l-.093-.259.045.274h-.001l-.104-.137.062.163-.076-.053.046.087v.002s-.055-.007-.055-.007l.034.047c-.007.02-.011.04-.011.061v.003h.358v-.003c0-.021-.004-.042-.011-.061l.071-.068-.089.031-.002-.003c.014-.017.147-.181.142-.181-.006,0-.169.14-.175.145h-.001s.128-.285.128-.285l-.177.255s-.001,0-.002,0l.052-.269-.093.258-.023-.26h0Z",
    style: {
      fill: "#fcdd09"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.917,15.033c-.029.096-.064.177-.096.247-.082.184-.099.611.202.913.447.447.787.267.958.51h.035c.171-.244.511-.064.958-.51.301-.302.285-.729.202-.913-.03-.069-.067-.151-.096-.247h-2.163",
    style: {
      fill: "#0f47af"
    }
  }), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M9.018,16.705h-.038c-.074-.106-.18-.132-.314-.164-.175-.042-.392-.094-.645-.347-.169-.169-.227-.367-.245-.502-.025-.179.006-.331.042-.413.033-.073.068-.153.096-.247h0v-.002h2.168v.002c.028.093.062.172.093.241l.003.006c.037.082.068.234.043.413-.019.135-.077.333-.246.502-.253.253-.47.305-.645.347-.132.033-.238.058-.313.164h0ZM8.983,16.701h.033c.075-.106.181-.132.316-.164.174-.042.391-.094.642-.346.168-.169.226-.365.244-.499.025-.178-.006-.329-.042-.411l-.003-.006c-.03-.069-.065-.147-.093-.24h-2.161c-.028.093-.063.173-.095.246-.071.16-.115.592.202.91.252.252.468.304.642.346.134.032.24.058.315.164Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.571,14.621c-.005-.025-.064-.02-.059-.061-.039-.006-.032-.076.041-.071.008-.014.095-.045.085-.002.044-.038.076-.003.051.014.017.017.026.056-.027.052.02.035-.026.034-.057.024.001.013-.002.024-.019.021-.011.008-.003.017-.001.026l-.014-.003ZM9.377,14.649c0-.032-.059-.022-.057-.058-.032-.005-.028-.072.039-.068-.004-.019.09-.044.081-.002.033-.035.065-.002.045.013.016.016.036.044-.021.05.023.022-.025.033-.055.023.001.013-.008.017-.025.014-.011.007.004.022.005.031l-.012-.003ZM9.841,14.758c.006-.024-.049-.022-.048-.049-.025-.004-.021-.055.03-.051-.003-.015.064-.039.06-.004.025-.026.053,0,.038.012.013.012.028.034-.016.038.018.017-.019.025-.042.018.001.01-.003.011-.015.009-.008.005.01.018.011.025l-.018.002h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.655,15.214c.013-.07.071-.134.077-.189.005-.049.015-.07.044-.122.029-.052.04-.076.047-.112.009-.047.044-.056.06-.009.015.047.046.167.062.194.015.028.031.066.029.085-.003.019.021.026.034.039.013.013.015.056.055.094.039.038.083.064.12.083.033.075.056.187.05.316h-2.465c0-.034,0-.067.002-.099.219-.056.301-.201.393-.191.05-.07.111-.145.153-.184.05-.046.149-.227.174-.339.025-.11.062-.169.09-.163s.039.012.073.111c.046.137.077.153.112.252.031.085.094.238.192.318.061-.046.131-.097.153-.133.019-.031.048-.08.082-.103.015-.046.035-.127.051-.147.015-.018.022-.036.023-.067.001-.031.025-.098.058-.153s.077-.072.097,0c.019.073.063.225.104.32.017.039.048.117.118.199l.007.009s.003-.002.005-.009h0Z",
    style: {
      fill: "#509164"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M10.235,15.597h-2.47v-.002c0-.031,0-.063.002-.099v-.002h.002c.116-.03.193-.084.255-.128.052-.037.094-.067.137-.063.044-.061.107-.141.153-.183.05-.046.149-.228.173-.337.023-.1.058-.165.088-.165h.005c.03.007.042.014.074.113.025.076.046.114.066.151.016.029.031.057.046.101.037.103.1.241.19.316l.009-.007c.057-.043.122-.091.143-.124h.001c.019-.032.047-.08.081-.103.004-.013.009-.029.014-.046.013-.042.025-.086.037-.101.015-.018.021-.035.023-.066.001-.033.027-.101.059-.154.021-.034.043-.052.063-.049.012.002.028.012.038.049.019.074.063.225.104.32l.003.007c.017.04.049.115.114.191l.005.006s.002-.004.002-.007c.007-.036.025-.069.042-.102.016-.031.032-.06.035-.087.005-.049.015-.07.044-.123.028-.051.04-.075.046-.111.005-.024.017-.041.032-.042h.001c.013,0,.024.012.031.033.005.015.011.037.018.06.015.051.033.115.044.134.015.028.032.067.029.087-.002.012.008.018.019.026.005.004.01.007.015.011.005.005.009.014.013.026.007.019.017.045.042.068.033.031.073.059.12.083h.001c.037.084.055.2.05.318h.001ZM7.77,15.593h2.461c.005-.117-.014-.23-.05-.312-.047-.024-.087-.052-.12-.083-.025-.024-.035-.051-.043-.07-.004-.011-.007-.02-.012-.024-.004-.004-.009-.008-.014-.011-.011-.008-.023-.016-.021-.03.003-.017-.012-.055-.028-.084-.011-.019-.029-.081-.044-.135-.007-.023-.013-.045-.018-.06-.006-.019-.016-.03-.027-.03h-.001c-.012,0-.023.016-.028.038-.006.037-.019.062-.047.113-.028.051-.038.071-.044.121-.003.027-.019.057-.036.089s-.035.066-.042.101h0c-.001.006-.003.008-.004.01l-.002.004-.01-.011c-.066-.077-.098-.152-.115-.193l-.003-.007c-.041-.095-.085-.246-.104-.32-.008-.028-.019-.044-.034-.046-.017-.002-.039.015-.059.047-.032.053-.057.12-.058.152-.002.032-.008.05-.024.069-.011.013-.024.059-.036.099-.005.017-.01.034-.015.047h0s-.001,0-.001,0c-.033.023-.061.07-.08.101h-.001c-.021.035-.084.082-.144.127l-.012.009h-.001c-.092-.076-.156-.216-.193-.32-.016-.044-.03-.071-.046-.1-.02-.037-.041-.075-.066-.151-.034-.101-.045-.104-.071-.11h-.003c-.023,0-.058.049-.084.162-.025.11-.124.294-.175.34-.046.042-.109.122-.153.183h-.001s-.001,0-.001,0c-.042-.004-.083.025-.136.062-.062.044-.139.098-.255.129.001.031,0,.062.001.092Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.372,15.472c-.046-.044-.118-.034-.155-.069-.036-.034-.093-.011-.217-.073-.015-.008-.031-.018-.046-.03-.098-.08-.162-.233-.192-.318-.034-.098-.066-.114-.112-.252-.024-.073-.038-.096-.054-.104.042.046.02.117.054.194.013.031-.009.031-.016.021-.006-.01-.027-.014-.037-.014.018.015.021.054.039.094.017.04-.013.036.023.093.01.016.013.04-.001.05-.015.009-.026-.028-.048-.015.006.014.032.04.049.055s.001.023-.013.016-.033-.014-.043-.022c0,.012.014.025.034.043.021.017.007.03-.04.03.007.011.005.038-.017.041.03.002.052.056.089.06.036.003.039.028.005.034-.035.006-.106-.05-.141-.087-.009.013-.028.018-.041.011-.001.017.004.058.021.085-.017-.007-.039-.03-.062-.057-.022-.026-.036.013-.017.036s.031.042.001.06c-.03.017-.048.011-.071-.021-.031.026-.044.028-.068.023,0,.015-.026.051-.038.078-.026.052,1.154.159,1.121.034M10.221,15.48c-.311-.027-.482-.147-.579-.262-.069-.081-.101-.159-.118-.199-.041-.095-.085-.247-.104-.32-.006-.024-.015-.039-.026-.044-.016-.008-.008.02.004.034.013.014.012.026-.004.016-.016-.009-.024.009-.009.031.014.022.037.047.041.071.005.023.006.044.018.055.011.012-.03.014-.047-.013-.001.018.005.044.016.041.011-.002.014.008-.001.035-.015.026-.013.035-.008.047.008.018.029-.053.041-.013.006.019.017.042.027.057.01.014.009.023-.005.023s-.027-.036-.029-.005c-.001.03.022.039.047.038.023,0,.027.008.023.021-.003.013.007.025.021.022.013-.004.032.008.043.039.011.031-.007.044-.033.022-.026-.022-.064-.042-.067-.058-.003-.014-.013.006-.002.026s.017.029.031.037c.014.007-.001.037-.025.018-.023-.018-.034-.014-.041.007-.012.033-.047.025-.036.043s.006.047-.01.054c-.017.007-.037-.003-.035-.035-.004.006-.022.009-.035.005-.002.044-.014.059-.041.047-.001.01-.002.027-.015.039.03-.004.036.016.039.029.002.013.006.011.023.013.016,0,.037.022.006.017-.031-.004-.078.006-.106-.014.029.026.11.027.144.06.249.102.687.138.86.091.001-.021-.002-.068-.004-.083",
    style: {
      fill: "#034418"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.861,14.754c.007.003.014.013.021.029.015.047.046.167.062.194.015.028.031.066.029.085-.003.019.021.026.034.039.013.013.015.056.055.094.039.038.083.065.12.083.022.05.039.117.047.196-.106-.008-.239-.039-.305-.069.003-.01.003-.022-.001-.041-.004-.019-.001-.033.019-.051s.013-.048.003-.065c-.011-.016-.01-.026-.001-.036.008-.009.008-.025-.011-.043-.02-.018-.006-.037.004-.053.011-.016.027-.044.015-.08-.012-.035-.03.008-.044-.005-.009-.009-.014-.026-.004-.04s.004-.039-.008-.059c.026-.007-.018-.083-.025-.116-.007-.032.008-.048-.009-.061",
    style: {
      fill: "#034418"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.731,15.045c0,.017-.004.041-.009.049.011.017.025.052.023.063.014-.013.042-.003.048.034.006.038.013.072.009.093.013.011.039.03.044.05.004.02.018.017.031.015.042-.006.039.045.083.038.062-.009.023.04.085.039.036-.002.085.005.11.04.028-.038.052-.023.077-.014.025.009.057.006.029-.013-.029-.021-.085-.023-.11-.017s-.063.002-.089-.021c-.025-.023-.069-.043-.096-.044s-.033-.003-.054-.033c-.02-.03-.052-.026-.068-.028-.015,0-.027-.021-.009-.039.026-.028-.011-.031.003-.048.013-.017.006-.039-.03-.042-.036-.003-.022-.014-.017-.039.013-.06-.068-.05-.062-.079M10.14,15.368c.004-.037-.024-.052-.031-.08-.005-.028-.049-.029-.061-.02.004.008,0,.022-.005.03-.005.007-.005.012.005.015.012.003.022.005.022.015.001.009.006,0,.011-.011.004-.011.035.014.039.038.003.023.016.039.02.013M9.995,15.328c.005.014.025.032.036.032s.027.008.03.021c.002.011.011.026.022.028s.005.011-.009.01c-.015,0-.039-.01-.04-.021.005.022-.002.032-.016.016-.013-.015-.021-.037-.039-.039.013-.003.015-.006.009-.02-.006-.013-.001-.049.007-.027",
    style: {
      fill: "#509164"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77,15.553c.03-.014.075-.009.092.006.009-.017.023-.03.05-.025.021-.023.039-.035.052-.023.013-.023.055-.029.069-.014.015-.023.046-.034.066-.022.027-.035.074-.047.103-.03.025-.019.054-.015.066-.003.013.012.039-.012.05.01.019-.004.055-.005.062.014.004-.011.021-.017.03-.009,0-.041.03-.073.071-.063.02-.03.054-.042.07-.031.017-.017.052-.005.067.015.033,0,.049.014.066.044s.066.047.097.034c.031-.012.06-.015.071,0,.019-.017.039-.013.052,0,.021.019.042-.014.055-.002.02.021.038-.019.072.002.034.021.101.052.153.052s.093-.064.126-.019c.033-.022.083-.033.118-.014.021-.019.068-.025.087-.007.019-.029.055-.046.085-.036.017-.029.085-.034.105.007.017,0,.044.015.044.034.017,0,.044.011.044.031.019-.005.042.007.046.03.038-.003.068.013.085.044.013-.011.005-.039.034-.044s.038.004.046.014c.031-.023.075-.02.112.013.027-.011.052-.006.06.007.012-.011.03-.013.049-.013.001.061-.004.127-.018.195h-2.424c-.013-.066-.018-.133-.017-.194",
    style: {
      fill: "#078930"
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M10.206,15.751h-2.425v-.002c-.012-.064-.018-.131-.017-.194h.005c0,.062.005.128.017.191h2.417c.012-.064.018-.128.018-.191-.022,0-.036.004-.045.013l-.002.002v-.002c-.008-.012-.031-.017-.058-.006h-.002c-.034-.032-.077-.037-.109-.013h-.002s-.001-.001-.001-.001c-.008-.01-.017-.018-.043-.013-.017.003-.02.014-.024.025-.002.007-.004.013-.009.018l-.002.002v-.003c-.016-.028-.042-.043-.075-.043h-.01v-.002c-.001-.009-.007-.017-.015-.022-.008-.006-.019-.008-.028-.005h-.003s0-.002,0-.002c0-.019-.027-.028-.042-.028h-.006v-.002c0-.017-.025-.032-.041-.032h-.003c-.009-.018-.028-.029-.051-.03-.022,0-.043.008-.051.022v.002s-.003,0-.003,0c-.028-.009-.063.006-.082.035l-.002.002-.002-.002c-.018-.017-.064-.01-.084.007h-.001s-.001,0-.001,0c-.034-.019-.084-.007-.116.014h-.002s-.001-.001-.001-.001c-.019-.025-.039-.014-.066,0-.017.009-.037.02-.058.02-.054,0-.122-.033-.154-.052-.017-.01-.03-.005-.041,0-.011.005-.021.009-.031-.002-.004-.004-.01-.002-.018.002-.01.005-.023.011-.036,0-.011-.01-.03-.016-.049,0l-.002.002-.002-.002c-.009-.012-.033-.011-.068.002-.032.014-.083-.004-.1-.035-.016-.028-.03-.043-.061-.043h-.005c-.009-.013-.025-.022-.04-.023-.007,0-.016,0-.023.007h-.001s-.002,0-.002,0c-.015-.01-.047.002-.067.031h-.001s-.002,0-.002,0c-.017-.004-.033,0-.045.009-.014.011-.023.03-.023.052v.005l-.004-.004s-.009-.003-.012-.003c-.006,0-.012.006-.014.011l-.002.005-.002-.006c-.007-.019-.043-.017-.059-.013h-.002v-.002c-.006-.011-.016-.009-.027-.007-.009.002-.018.004-.024-.002-.012-.012-.04-.015-.063.003h-.001s0,.002,0,.002c-.028-.018-.074-.005-.1.029v.002s-.003,0-.003,0c-.019-.012-.048-.002-.063.021h0s-.002-.001-.002-.001c-.006-.006-.018-.009-.031-.007-.015.002-.029.01-.034.02v.003s-.003-.002-.003-.002c-.003-.003-.006-.004-.01-.004h0c-.009,0-.022.009-.038.027h0s0,0,0,0c-.022-.004-.037.004-.048.024v.003s-.003-.002-.003-.002c-.016-.015-.061-.02-.089-.006l-.002-.004c.03-.015.074-.009.092.005.011-.02.027-.027.05-.024.017-.019.03-.027.041-.028h0s.007,0,.011.003c.007-.01.02-.018.036-.02.013-.002.026,0,.033.006.016-.023.045-.032.066-.021.027-.034.073-.047.103-.029.025-.018.054-.015.068-.002.005.004.012.003.02,0,.011-.002.023-.005.03.008.02-.004.05-.004.061.012.003-.005.009-.008.015-.01.005,0,.009,0,.012,0,.001-.021.01-.04.024-.051.013-.01.03-.014.048-.01.02-.029.053-.041.07-.032.006-.006.015-.008.025-.007.016,0,.033.01.043.023h.002c.033,0,.049.017.065.045.017.029.064.046.095.033.035-.013.061-.014.072-.002.019-.016.04-.011.053,0,.011.01.021.004.031,0,.008-.004.017-.008.023,0,.008.009.016.006.026,0,.012-.005.026-.011.046,0,.032.019.099.051.152.051.02,0,.038-.01.056-.019.026-.014.05-.026.07,0,.031-.02.08-.033.117-.014.021-.018.066-.024.087-.008.02-.029.055-.044.084-.035.009-.014.029-.022.051-.022h.003c.024,0,.045.012.054.03.017,0,.043.016.045.034.018,0,.042.011.044.03.01-.002.021,0,.029.006.008.006.014.014.016.023.037-.002.066.013.084.042.003-.004.004-.008.006-.014.004-.012.008-.025.027-.029.028-.005.038.003.046.013.033-.023.077-.018.112.013.025-.009.05-.007.06.006.01-.008.026-.012.049-.012h.002v.002c.001.065-.005.13-.018.196l-.002.005Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.999,14.165l-.024.078h-.083l.067.048-.025.078.066-.048.066.048-.025-.078.066-.047h-.081l-.025-.078M8.687,14.191l-.012.081-.081.013.073.037-.013.08.057-.058.073.037-.038-.073.058-.057-.081.013-.036-.073M8.383,14.267v.082s-.077.026-.077.026l.079.024v.081l.047-.067.078.024-.049-.066.047-.066-.078.026-.049-.066M8.095,14.392l.014.081-.073.039.081.011.013.08.035-.073.081.011-.059-.057.036-.073-.073.039-.059-.056M9.312,14.191l.012.081.081.013-.073.037.013.08-.057-.058-.073.037.038-.073-.057-.057.081.013.035-.073M9.617,14.267v.082s.077.026.077.026l-.079.024v.081l-.047-.067-.078.024.049-.066-.047-.066.077.026.049-.066M9.905,14.392l-.014.081.073.039-.082.011-.013.08-.035-.073-.081.011.059-.057-.036-.073.073.039.059-.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "AS",
    d: "M8.865,16.137l.009-.599c0-.029.005-.033.006-.002l.002.607",
    style: {
      fill: "#865800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "AS1",
    "data-name": "AS",
    d: "M8.865,16.137l.009-.599c0-.029.005-.033.006-.002l.002.607",
    style: {
      fill: "#704d25"
    }
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M8.882,16.146s-.002,0-.002-.002l-.002-.607c0-.006-.001-.011-.001-.014,0,.003-.001.009-.001.016l-.009.599s-.001.002-.002.002h0s-.002,0-.002-.002l.009-.599c0-.026.004-.026.005-.026h0s.005,0,.005.024l.002.608s0,.001-.002.001h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "AT",
    d: "M8.881,15.537c.021-.018.068.022.098.005-.018.058-.09.012-.098.034v-.039",
    style: {
      fill: "#fff"
    }
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M8.881,15.579s0,0,0,0c-.002,0-.002,0-.002-.002v-.039s0,0,.001-.002c.011-.01.028-.004.047.002.018.006.037.012.051.004h.003s.001.002.001.003c-.012.038-.045.034-.07.031-.014-.002-.025-.003-.028.003-.001,0-.002,0-.003,0ZM8.895,15.568c.005,0,.011,0,.017,0,.023.003.051.006.063-.022-.015.005-.033,0-.05-.006-.017-.005-.032-.01-.041-.003v.032s.006-.002.011-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "AU",
    d: "M9.067,16.138l.009-.598c0-.029.005-.034.006,0l.002.606",
    style: {
      fill: "#865800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "AU1",
    "data-name": "AU",
    d: "M9.067,16.138l.009-.598c0-.029.005-.034.006,0l.002.606",
    style: {
      fill: "#704d25"
    }
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M9.084,16.148s-.002,0-.002-.002l-.002-.606c0-.007-.001-.012-.001-.015,0,.003-.001.009-.001.016l-.009.598s-.001.002-.002.002h0s-.002,0-.002-.002l.009-.598c0-.026.004-.026.005-.026.002,0,.005,0,.006.025l.002.606s-.002.002-.003.002h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "AV",
    d: "M9.084,15.539c.021-.018.068.022.098.005-.019.058-.09.013-.098.034v-.039",
    style: {
      fill: "#fff"
    }
  }), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M9.084,15.581h0s-.002,0-.002-.002v-.039s0,0,.001-.002c.011-.01.028-.004.047.002.018.006.037.012.051.003h.003s.001.002.001.002c-.012.038-.046.034-.07.031-.016-.002-.025-.003-.027.003-.002.001-.003.002-.004.002ZM9.098,15.57c.005,0,.011,0,.017,0,.023.003.051.006.063-.023-.015.005-.033,0-.05-.005s-.032-.01-.041-.003v.032s.006-.002.011-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "AW",
    d: "M9.259,16.172l.009-.599c0-.029.005-.033.006,0l.002.606",
    style: {
      fill: "#865800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "AW1",
    "data-name": "AW",
    d: "M9.259,16.172l.009-.599c0-.029.005-.033.006,0l.002.606",
    style: {
      fill: "#704d25"
    }
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M9.276,16.18s-.002,0-.002-.002l-.002-.606c0-.007-.001-.011-.001-.015,0,.003-.001.008-.001.015l-.009.599s-.001.002-.002.002h0s-.002,0-.002-.002l.009-.599c0-.027.004-.026.005-.026.002,0,.005,0,.005.025l.002.606s0,.003-.002.003h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.275,15.572c.021-.018.068.022.098.005-.019.058-.09.013-.098.034v-.039",
    style: {
      fill: "#fff"
    }
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M9.275,15.613h0s-.002,0-.002-.002v-.039s.001-.002.002-.002h0c.011-.008.027-.003.045.003s.037.012.052.003c.001,0,.002,0,.003,0,.001,0,.001.002.001.003-.012.038-.046.034-.07.031-.015-.002-.025-.003-.027.003-.002,0-.003,0-.004,0ZM9.288,15.602c.005,0,.011,0,.017,0,.023.003.051.006.063-.022-.015.006-.034,0-.05-.005s-.032-.01-.041-.003v.031s.007-.002.011-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.328,16.24c-.021,0-.047-.01-.054-.026-.015.014-.079.022-.104,0-.017.014-.07.024-.097.007-.021.019-.085.017-.118-.003-.013.014-.052.025-.073.027-.03-.042-.109-.109-.159-.134-.056-.028-.169-.082-.229-.108-.035-.015-.067-.041-.001-.013l.262.11c.11.048.55.041.623.035.038-.003.088-.031.123-.053.027-.016.028-.006.002.007-.029.015-.06.027-.082.058-.03.042-.073.061-.089.089",
    style: {
      fill: "#704d25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.328,16.24c-.021,0-.047-.01-.054-.026-.015.014-.079.022-.104,0-.017.014-.07.024-.097.007-.021.019-.085.017-.118-.003-.013.014-.052.025-.073.027-.03-.042-.109-.109-.159-.134-.056-.028-.169-.082-.229-.108-.035-.015-.067-.041-.001-.013l.262.11c.11.048.55.041.623.035.038-.003.088-.031.123-.053.027-.016.028-.006.002.007-.029.015-.06.027-.082.058-.03.042-.073.061-.089.089l-.004.003h0Z",
    style: {
      fill: "#704d25"
    }
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M8.883,16.249s-.001,0-.002,0c-.029-.042-.109-.109-.159-.134-.058-.028-.17-.082-.229-.107,0,0-.044-.02-.041-.028.001-.003.002-.006.041.011l.262.11c.109.048.551.041.621.035.037-.003.087-.031.122-.052.008-.005.019-.01.023-.008.001,0,.002.002.002.003,0,.006-.015.014-.02.016-.005.003-.01.005-.014.007-.024.012-.049.024-.067.05-.016.022-.035.038-.052.052-.015.013-.029.024-.036.037,0,0,0,0-.001,0l-.003.002h-.001c-.02,0-.046-.009-.055-.025-.018.013-.077.021-.103,0-.019.014-.069.023-.097.007-.023.018-.084.017-.118-.003-.015.015-.052.025-.073.027h0ZM8.458,15.982c.005.004.019.013.036.021.059.025.172.079.229.108.05.025.129.091.16.134.021-.002.057-.013.07-.026.001,0,.002,0,.003,0,.032.019.095.021.116.003.001,0,.002,0,.003,0,.025.016.077.007.094-.007.001,0,.002,0,.003,0,.024.021.087.013.101,0t.002,0s.001,0,.002,0c.007.015.031.024.051.024h.002c.008-.014.021-.026.037-.038.017-.014.036-.029.051-.051.019-.027.044-.039.069-.052.005-.002.01-.005.014-.007.009-.005.014-.009.016-.011-.003,0-.008.003-.016.008-.038.023-.086.051-.124.053-.074.006-.512.014-.624-.035l-.262-.11c-.02-.01-.029-.012-.033-.013Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.369,15.674l-.142-.015c-.025.042-.029.095-.015.132.046-.043.128-.021.169.002-.014-.038-.034-.089-.012-.119",
    style: {
      fill: "#fff"
    }
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M9.381,15.795h-.001c-.043-.023-.123-.043-.167-.002t-.002,0s-.001,0-.002,0c-.015-.04-.008-.094.015-.134,0,0,.001,0,.002,0l.142.015s.001,0,.001,0h.001s.001.003,0,.004c-.021.026-.005.071.009.108l.003.007s0,.002-.001.003c0,0,0,0,0,0ZM9.282,15.764c.034,0,.069.011.095.024v-.002c-.014-.036-.03-.082-.011-.11l-.138-.015c-.022.038-.028.087-.015.125.018-.015.043-.022.069-.022Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.38,15.792c-.042,0-.142-.002-.174-.002-.034.044-.015.11-.007.135.038-.06.157-.028.202.015-.023-.044-.041-.081-.021-.148",
    style: {
      fill: "#fff"
    }
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M9.401,15.943s-.001,0-.002,0c-.029-.028-.093-.053-.145-.047-.025.003-.043.014-.054.031,0,0-.001,0-.002,0s-.002,0-.002-.002c-.024-.075-.009-.116.008-.137,0,0,.001,0,.002,0,.011,0,.032,0,.055,0,.041,0,.091,0,.118,0h0s.002,0,.003,0,.001.002.001.003c-.021.069-.001.107.02.148.001,0,0,.002-.001.003t-.001,0ZM9.272,15.89c.044,0,.093.019.122.041-.022-.043-.033-.078-.016-.137-.028,0-.077,0-.116,0-.023,0-.042,0-.054,0-.015.02-.029.059-.008.128.012-.016.031-.026.055-.029.005-.001.011-.001.017-.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.4,15.942c-.041-.007-.174-.016-.201-.023-.022.045-.039.103-.048.159.064-.071.214-.019.245.05-.031-.06-.062-.149.004-.186",
    style: {
      fill: "#fff"
    }
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M9.397,16.13s-.002,0-.002,0c-.001-.002-.002-.005-.004-.007-.02-.035-.071-.065-.125-.073-.048-.008-.088.003-.113.031-.001,0-.002,0-.003,0s-.001,0-.001-.002c.009-.056.027-.114.049-.159,0,0,.002-.002.003,0,.014.004.06.008.104.012.038.004.077.008.096.011h.001s.002,0,.002.002c0,0,0,.002-.001.003-.065.035-.034.122-.007.175.001.002.003.005.004.007.001,0,0,.003-.001.003l-.002-.002ZM9.237,16.041c.009,0,.019,0,.029.002.045.007.089.029.114.057-.023-.053-.04-.123.013-.157-.02-.003-.056-.007-.091-.01-.044-.004-.087-.008-.103-.012-.02.043-.037.097-.046.149.022-.019.051-.029.084-.029Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.223,15.631l-.188-.025c-.027.031-.047.087-.044.151.039-.038.184-.022.22.031-.012-.057-.028-.131.012-.157",
    style: {
      fill: "#fff"
    }
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M9.211,15.791s-.001,0-.002,0c-.02-.03-.072-.045-.113-.05-.046-.005-.086.003-.103.019-.001,0-.002,0-.002,0-.001,0-.001,0-.001-.002-.002-.059.015-.118.044-.153,0,0,.001,0,.002,0l.187.025h.001s.002,0,.003,0c.001,0,.001.002,0,.003h-.001s-.001.002-.001.002c-.037.027-.022.097-.01.154h0s-.002.004-.004.004t0,0ZM9.068,15.735c.009,0,.019,0,.028.002.039.004.086.018.111.044-.012-.054-.023-.118.01-.147l-.181-.024c-.028.033-.044.088-.043.144.015-.013.043-.019.075-.019Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.209,15.794l-.209-.027c-.033.042-.031.102-.023.166.047-.039.202-.018.239.035-.023-.078-.041-.123-.007-.174",
    style: {
      fill: "#fff"
    }
  }), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M9.216,15.97s-.001,0-.002,0c-.017-.024-.062-.044-.116-.051-.053-.007-.098,0-.119.017-.001,0-.002,0-.002,0-.001,0-.001,0-.001-.002-.009-.071-.008-.127.024-.168t.002,0l.209.028s.002,0,.002,0v.002c-.031.044-.019.086,0,.15.002.007.004.014.006.021,0,.002,0,.003-.003.004h0ZM9.057,15.91c.013,0,.027,0,.041.003.04.005.088.02.112.045-.001-.004-.002-.007-.003-.011-.019-.063-.031-.105-.002-.151l-.205-.027c-.03.039-.031.092-.023.159.018-.012.047-.018.08-.018Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.215,15.967l-.212-.022c-.033.041-.056.083-.048.145.033-.055.174-.015.234.046-.037-.047-.04-.115.026-.169",
    style: {
      fill: "#fff"
    }
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M9.188,16.139s-.001,0-.002,0c-.043-.044-.13-.077-.185-.07-.022.003-.037.011-.045.024t-.002,0s-.002,0-.002-.002c-.008-.066.019-.11.049-.147,0,0,.001,0,.002,0l.212.022s.002,0,.002.002c0,0,0,.002-.001.002-.07.056-.058.125-.026.166.001,0,.001.002,0,.003t-.002,0ZM9.016,16.063c.05,0,.118.025.16.06-.024-.042-.027-.103.033-.154l-.206-.021c-.028.035-.053.076-.048.136.009-.011.025-.019.045-.021h.016Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.869,15.631c-.023.018-.059.08-.065.097.039-.016.123-.021.175.018-.015-.03-.021-.081-.007-.103-.02-.009-.075-.013-.103-.012",
    style: {
      fill: "#fff"
    }
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M8.979,15.748h-.001c-.05-.037-.132-.034-.172-.018h-.002v-.002c.005-.018.041-.08.064-.098h.001s.001,0,.002,0h0c.028-.003.082.002.102.011.001,0,.001,0,.001,0v.002c-.014.022-.007.073.007.101,0,0,0,.002-.001.003t0,0ZM8.875,15.714c.033,0,.069.007.098.026-.012-.029-.016-.073-.005-.095-.022-.008-.072-.012-.099-.01h-.001c-.021.017-.052.069-.06.09.018-.007.042-.011.067-.011Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.782,15.757c.055,0,.167.013.215.026-.029.043-.025.117-.013.162-.074-.073-.197-.072-.27-.05.014-.033.047-.102.068-.138",
    style: {
      fill: "#fff"
    }
  }), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M8.984,15.947s-.001,0-.002,0c-.069-.068-.187-.073-.267-.049-.001,0-.002,0-.002,0-.001,0-.001-.002,0-.002.014-.035.047-.104.067-.139,0,0,.001,0,.002,0s.001,0,.002,0h.004c.056,0,.163.013.21.026.001,0,.001,0,.002,0v.002c-.027.04-.026.111-.013.16,0,0,0,.002-.001.003h-.002ZM8.807,15.879c.062,0,.127.017.173.058-.011-.048-.011-.114.014-.154-.05-.013-.159-.026-.211-.025h0c-.019.034-.049.097-.064.132.026-.006.056-.011.088-.011Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.999,15.961c-.053.002-.188-.022-.25-.052-.021.058-.031.155-.033.19.06-.081.207-.036.254.047-.005-.044-.021-.152.029-.185",
    style: {
      fill: "#fff"
    }
  }), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M8.969,16.148s-.002,0-.002,0c-.027-.047-.089-.084-.149-.087h-.01c-.039,0-.071.014-.091.041-.001,0-.002,0-.003,0s-.002,0-.002-.002c.002-.03.011-.13.033-.191,0,0,.001,0,.001,0h.002c.061.03.194.053.247.052,0,0,.001,0,.001,0,.001,0,.002,0,.002,0,.001,0,.001,0,.001.002h0s-.001.003-.002.003h-.001c-.043.032-.033.122-.028.171,0,.004.001.008.001.011.003,0,.002,0,0,.002t0,0ZM8.808,16.054h.01c.058.004.117.036.147.081h0c-.005-.049-.015-.136.025-.173-.056,0-.18-.022-.241-.051-.02.056-.029.144-.032.18.023-.024.054-.037.091-.037Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.869,15.631c-.149.09-.262.271-.304.396.042,0,.095.013.114.05.044-.18.106-.346.19-.446",
    style: {
      fill: "#fff"
    }
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M9.397,16.134s-.001,0,0,0c-.002,0-.002,0-.002-.003.014-.082.005-.299-.028-.457,0,0,.001-.002.002-.003.001,0,.002,0,.003.002.033.158.042.376.028.459-.001.002-.002.002-.003.002ZM8.679,16.08s-.002,0-.002,0c-.018-.036-.068-.049-.108-.049h-.004s-.001,0-.002,0c0,0-.001,0,0-.002.043-.128.156-.307.303-.396,0,0,.001,0,.001-.002.001,0,.002,0,.003,0s.002,0,.002.002h0s0,.003-.001.003h-.001c-.075.091-.138.241-.188.445-.001,0-.002.002-.003.002h0ZM8.569,16.025c.039,0,.088.012.109.046.048-.195.108-.339.179-.43-.139.091-.246.26-.288.384h0ZM8.516,16.007h-.001s-.002-.002-.001-.003c.065-.123.242-.345.358-.461.001,0,.002,0,.003,0s.001.002,0,.003c-.115.116-.292.337-.357.46,0,0,0,0-.002,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.545,15.966c-.038.019-.109-.034-.143-.01v-.021c.033-.023.104.03.143.01v.022",
    style: {
      fill: "#00009e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.545,15.966c-.038.019-.109-.034-.143-.01v-.021c.033-.023.104.03.143.01v.022h0Z",
    style: {
      fill: "#001489"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.545,15.987c-.038.019-.109-.034-.143-.011v-.022c.033-.023.104.03.143.01v.023",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "AX",
    d: "M9.545,16.009c-.038.02-.109-.033-.143-.01v-.022c.033-.023.104.03.143.011v.021",
    style: {
      fill: "#ff0016"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "AX1",
    "data-name": "AX",
    d: "M9.545,16.009c-.038.02-.109-.033-.143-.01v-.022c.033-.023.104.03.143.011v.021",
    style: {
      fill: "#da291c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.545,16.031c-.038.02-.109-.033-.143-.01v-.022c.033-.022.104.03.143.01v.022Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.545,16.052c-.038.02-.109-.033-.143-.01v-.022c.033-.023.104.03.143.01v.022",
    style: {
      fill: "#00009e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.545,16.052c-.038.02-.109-.033-.143-.01v-.022c.033-.023.104.03.143.01v.022h0Z",
    style: {
      fill: "#001489"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "AY",
    d: "M8.943,15.065l.003-.213c0-.01.002-.012.002,0v.216",
    style: {
      fill: "#865800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "AY1",
    "data-name": "AY",
    d: "M8.943,15.065l.003-.213c0-.01.002-.012.002,0v.216",
    style: {
      fill: "#704d25"
    }
  }), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M8.949,15.069s-.001,0-.001,0v-.172s-.004.17-.004.17c0,0-.001,0-.001,0h0s-.001,0-.001-.002l.003-.213c0-.01.001-.01.003-.01h0s.002,0,.003.009v.216s-.002.002-.002.002h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "AZ",
    d: "M8.948,14.852c.007-.006.024.008.035.002-.006.021-.032.004-.035.012v-.014",
    style: {
      fill: "#fff"
    }
  }), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M8.948,14.868h0s-.001,0-.001-.002v-.014s0,0,.001,0c.004-.004.011-.002.017,0,.006.002.013.004.018,0h.002s.001,0,0,.002c-.004.014-.017.012-.026.011-.004,0-.008,0-.009,0,0,.001,0,.002-.002.002ZM8.953,14.862s.004,0,.006,0c.008,0,.017.002.021-.006-.005,0-.011,0-.017-.002-.006-.002-.011-.003-.014,0v.01s.003-.002.004-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Aa",
    d: "M9.014,15.065l.003-.212c0-.01.002-.012.002,0v.215",
    style: {
      fill: "#865800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Aa1",
    "data-name": "Aa",
    d: "M9.014,15.065l.003-.212c0-.01.002-.012.002,0v.215",
    style: {
      fill: "#704d25"
    }
  }), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02,15.07s-.001,0-.001,0v-.172s-.004.17-.004.17c0,0-.001,0-.001,0h0s-.001,0-.001-.002l.003-.212c0-.01.001-.01.003-.01h0s.002,0,.003.01v.215s0,0-.002,0h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ab",
    d: "M9.02,14.853c.007-.006.024.008.035.002-.007.021-.032.005-.035.012v-.014",
    style: {
      fill: "#fff"
    }
  }), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02,14.868h0s-.001,0-.001-.002v-.014s0,0,.001,0c.004-.004.011-.002.017,0,.006.002.013.004.018,0h.002s.001,0,0,.002c-.005.014-.017.013-.026.011-.004,0-.008,0-.009,0,0,.002-.001.002-.002.002ZM9.025,14.863h.006c.008,0,.017.002.021-.006-.005,0-.011,0-.017-.002-.006-.002-.011-.003-.014,0v.01s.003-.001.004-.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ac",
    d: "M9.082,15.077l.003-.213c0-.01.002-.012.002,0v.215",
    style: {
      fill: "#865800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ac1",
    "data-name": "Ac",
    d: "M9.082,15.077l.003-.213c0-.01.002-.012.002,0v.215",
    style: {
      fill: "#704d25"
    }
  }), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M9.088,15.081s-.001,0-.001,0v-.172s-.004.17-.004.17c0,0-.001,0-.001,0h0s-.001,0-.001-.002l.003-.213c0-.01.001-.01.003-.01h0s.002,0,.003.009v.215s0,.003-.002.003h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.088,14.865c.007-.006.024.008.035.002-.007.021-.032.004-.035.012v-.014",
    style: {
      fill: "#fff"
    }
  }), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M9.088,14.88h0s-.001,0-.001,0v-.014s.001,0,.001,0c.004-.003.01,0,.016,0,.006.002.013.004.018,0h.002s.001,0,0,.002c-.005.014-.017.012-.026.011-.004,0-.008,0-.009,0,0,0,0,0,0,0ZM9.093,14.875s.004,0,.006,0c.008,0,.017.002.021-.006-.005,0-.011,0-.017-.002-.005-.002-.011-.003-.014,0v.01s.003-.002.004-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.107,15.102c-.007,0-.017-.003-.019-.009-.005.005-.028.008-.037,0-.006.005-.025.009-.034.003-.008.007-.03.006-.042,0-.005.005-.018.009-.026.01-.01-.015-.039-.039-.057-.048-.02-.01-.06-.029-.081-.038-.012-.005-.024-.015,0-.005l.093.039c.039.017.195.015.221.012.013,0,.031-.011.044-.019.01-.006.01-.002.001.003-.01.005-.021.01-.029.021-.012.015-.027.021-.034.032",
    style: {
      fill: "#704d25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.107,15.102c-.007,0-.017-.003-.019-.009-.005.005-.028.008-.037,0-.006.005-.025.009-.034.003-.008.007-.03.006-.042,0-.005.005-.018.009-.026.01-.01-.015-.039-.039-.057-.048-.02-.01-.06-.029-.081-.038-.012-.005-.024-.015,0-.005l.093.039c.039.017.195.015.221.012.013,0,.031-.011.044-.019.01-.006.01-.002.001.003-.01.005-.021.01-.029.021-.012.015-.027.021-.034.032h0Z",
    style: {
      fill: "#704d25"
    }
  }), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M8.949,15.106s-.001,0-.001,0c-.01-.015-.039-.039-.056-.047-.02-.01-.06-.029-.081-.038-.002,0-.016-.007-.015-.011.001-.002.002-.002.016.004l.093.039c.039.017.195.015.22.012.013,0,.031-.011.043-.019.007-.004.008-.003.009-.003,0,0,.001,0,.001.002,0,.002-.004.005-.008.006-.002,0-.003.002-.005.003-.008.004-.017.009-.024.018-.006.008-.013.014-.019.019-.005.004-.01.008-.013.013h-.001s-.001.002-.001.002h-.001c-.007,0-.016-.003-.02-.008-.007.005-.027.007-.036,0-.007.005-.024.008-.034.003-.008.006-.03.006-.042,0-.005.002-.018.006-.025.007h0ZM8.802,15.012s.006.003.009.005c.021.009.061.028.081.038.018.009.046.032.057.047.007,0,.02-.005.024-.009,0,0,.001,0,.002,0,.011.007.033.007.04,0,0,0,.001,0,.002,0,.009.006.027.003.033-.002h.002c.008.007.03.004.035,0h.001s.001,0,.001,0c.002.005.011.008.017.008h0c.003-.005.008-.009.013-.013.006-.005.013-.01.018-.018.002-.003.005-.006.008-.009-.008.003-.015.006-.022.007-.026.002-.182.005-.222-.013l-.093-.039s-.004-.003-.006-.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.122,14.901l-.051-.005c-.009.015-.01.034-.005.047.016-.015.045-.007.06,0-.005-.015-.012-.033-.004-.043",
    style: {
      fill: "#fff"
    }
  }), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M9.126,14.944s-.001,0,0,0c-.016-.008-.044-.015-.059,0h-.001s-.001,0-.001,0c-.005-.014-.003-.034.006-.048h.001s.051.004.051.004h.001s.001,0,0,.002c-.007.009-.001.025.003.038v.003s0,.003,0,.003h0ZM9.091,14.932c.012,0,.023.003.032.008-.005-.013-.01-.028-.004-.038l-.048-.005c-.007.013-.009.03-.005.043.007-.006.016-.008.025-.008Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.125,14.943c-.015,0-.051,0-.062,0-.012.016-.005.039-.003.048.013-.021.056-.01.072.005-.007-.015-.014-.029-.007-.052",
    style: {
      fill: "#fff"
    }
  }), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M9.133,14.997h-.001c-.01-.01-.033-.019-.051-.016-.009,0-.015.005-.019.011h-.001s-.001,0-.001,0c-.009-.027-.003-.042.003-.049h.001s.011,0,.019,0h.044s.001,0,.001.002c-.007.024,0,.038.007.052,0-.001,0,0-.002,0,0,0,0,0,0,0ZM9.087,14.977c.015,0,.031.006.041.013-.007-.014-.01-.026-.005-.046h-.06c-.005.007-.009.02-.003.043.004-.005.011-.008.019-.01h.008Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.133,14.996c-.015-.003-.062-.006-.071-.008-.008.016-.014.036-.017.056.023-.025.076-.007.087.018-.012-.021-.023-.053.001-.066",
    style: {
      fill: "#fff"
    }
  }), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M9.131,15.063s-.001,0-.001,0-.001-.002-.001-.003c-.007-.012-.025-.023-.044-.026-.01-.002-.028-.002-.04.011,0,0-.001,0-.002,0-.001,0-.001,0-.001-.002.003-.02.009-.04.017-.057,0,0,.001,0,.002,0,.005,0,.021.003.037.004.013,0,.027.003.034.004h0s.001,0,.001,0,0,0-.001.002c-.022.012-.012.043-.002.061,0,0,.001.002.001.003.002.003.002.004,0,.004t0,0ZM9.075,15.03s.007,0,.011,0c.015.002.029.009.038.018-.01-.024-.008-.043.005-.052-.007,0-.019-.002-.03-.003-.015-.002-.03-.003-.036-.004-.007.015-.012.033-.016.05.007-.006.017-.01.028-.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.07,14.886l-.067-.009c-.01.011-.017.031-.016.054.014-.013.065-.008.078.011-.004-.021-.01-.047.005-.056",
    style: {
      fill: "#fff"
    }
  }), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M9.066,14.943s-.001,0-.001,0c-.006-.009-.022-.015-.04-.017-.016-.002-.03,0-.036.006h-.002s-.001,0-.001,0c-.001-.021.005-.042.016-.055h.001s.066.008.066.008h.002v.002h-.001c-.013.009-.007.034-.003.054h0s0,.004,0,.004h0ZM9.015,14.922s.007,0,.01,0c.013,0,.029.006.038.014-.004-.018-.007-.039.003-.05l-.062-.008c-.009.011-.015.03-.015.049.006-.004.015-.006.026-.006Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.065,14.943l-.074-.01c-.012.015-.011.036-.008.059.017-.014.072-.006.085.012-.009-.027-.015-.043-.003-.061",
    style: {
      fill: "#fff"
    }
  }), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M9.067,15.006s-.001,0-.001,0c-.006-.008-.022-.015-.041-.018-.018-.003-.034,0-.042.006h-.003c-.003-.026-.003-.046.009-.061h.001s.074.009.074.009t.001,0v.002c-.011.016-.007.029,0,.053.001.002.001.005.002.008.002,0,.002,0,0,0,0,0,0,0,0,0ZM9.011,14.984c.005,0,.01,0,.014,0,.013.002.029.006.038.014h0c-.007-.023-.011-.038-.001-.054l-.071-.009c-.01.013-.01.032-.008.055.007-.006.018-.007.028-.007Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.067,15.005l-.075-.008c-.012.015-.02.03-.017.052.012-.019.062-.005.083.016-.013-.017-.015-.041.009-.06",
    style: {
      fill: "#fff"
    }
  }), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M9.057,15.066h-.001c-.014-.014-.041-.025-.06-.025h-.005c-.007,0-.013.004-.015.008,0,0-.001,0-.002,0s-.001,0-.001,0c-.003-.024.007-.039.017-.053,0,0,.001,0,.001,0l.075.008s.001,0,.001,0v.002c-.024.02-.02.044-.009.058t0,.002s0,0,0,0ZM8.996,15.038c.017,0,.039.008.055.019-.007-.015-.007-.034.012-.051l-.071-.007c-.01.012-.018.026-.017.046.003-.004.009-.006.015-.007.003,0,.005,0,.006,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.944,14.886c-.008.006-.021.028-.023.034.014-.006.044-.007.062.006-.005-.01-.007-.029-.003-.036-.007-.003-.026-.005-.036-.004",
    style: {
      fill: "#fff"
    }
  }), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M8.983,14.928h0c-.018-.013-.047-.012-.061-.006h-.002s-.001,0,0-.002c.002-.006.015-.029.023-.035h.002c.01,0,.029,0,.036.004h.001v.002c-.004.007-.003.024.003.035,0,0,0,.001-.002.002t0,0ZM8.946,14.914c.011,0,.023.002.034.008-.004-.01-.005-.024-.001-.032-.008-.003-.025-.004-.034-.003h0c-.007.006-.017.022-.02.03.005-.002.013-.003.021-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.913,14.93c.019,0,.059.004.076.009-.01.015-.009.041-.005.057-.026-.026-.07-.025-.096-.018.006-.011.018-.035.025-.048",
    style: {
      fill: "#fff"
    }
  }), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M8.985,14.998h-.001c-.024-.024-.066-.026-.094-.017h-.002v-.002c.005-.012.017-.037.024-.049h.001s.001,0,.001,0h.001c.02,0,.058.005.075.009,0,0,.001,0,.001,0h0c-.009.015-.009.04-.005.057,0,.001,0,.002-.001.002h0ZM8.922,14.973c.021,0,.044.006.06.019-.003-.014-.004-.037.005-.052-.017-.004-.053-.009-.072-.009h-.002c-.007.012-.017.033-.022.045.01-.002.02-.003.031-.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.99,15.003c-.019,0-.067-.008-.089-.018-.008.021-.011.055-.012.067.021-.029.073-.013.09.017-.001-.017-.007-.055.011-.066",
    style: {
      fill: "#fff"
    }
  }), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98,15.07s-.001,0-.001,0c-.009-.016-.031-.029-.052-.031-.015,0-.028.004-.035.014,0,0-.001,0-.002,0-.001,0-.001,0-.001,0,.001-.011.004-.046.012-.068,0,0,0,0,.001,0h.001c.021.01.066.018.086.018h.004s-.001.003-.001.003h0c-.015.011-.011.044-.009.06v.004s-.002.002-.003.003h0ZM8.923,15.035h.004c.02,0,.04.012.051.027-.002-.017-.004-.045.008-.058-.021,0-.062-.008-.083-.018-.007.019-.01.047-.011.061.007-.008.018-.012.031-.012Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.944,14.886c-.053.032-.093.096-.108.141.015,0,.034.005.04.018.016-.065.038-.124.068-.159",
    style: {
      fill: "#fff"
    }
  }), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M9.131,15.065h0s-.002,0-.001-.002c.005-.029.002-.106-.01-.162,0,0,0-.002.001-.002s.002,0,.002,0c.012.056.015.134.01.163,0,.001,0,.002-.002.002ZM8.877,15.045s-.001,0-.001,0c-.006-.013-.024-.017-.038-.017h-.001s-.001,0-.001,0h0c.015-.047.055-.11.108-.142h0s.001,0,.002,0,.001,0,.001,0t-.001.002h0c-.026.032-.049.085-.066.157t-.003,0h0ZM8.839,15.025c.013,0,.03.004.038.015.016-.066.037-.116.061-.148-.048.032-.085.09-.099.133ZM8.819,15.02s-.001,0,0,0c-.001,0-.002,0-.001-.002.023-.044.086-.122.127-.164.001,0,.002,0,.002,0,.001,0,.001.002,0,.002-.041.041-.104.12-.127.163,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.184,15.004c-.013.007-.039-.012-.051-.004v-.007c.012-.008.037.011.051.004v.007",
    style: {
      fill: "#00009e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.184,15.004c-.013.007-.039-.012-.051-.004v-.007c.012-.008.037.011.051.004v.007h0Z",
    style: {
      fill: "#001489"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.184,15.012c-.013.007-.039-.012-.051-.004v-.008c.012-.008.037.011.051.004v.008",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ad",
    d: "M9.184,15.02c-.013.007-.039-.012-.051-.004v-.008c.012-.008.037.011.051.004v.008",
    style: {
      fill: "#ff0016"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ad1",
    "data-name": "Ad",
    d: "M9.184,15.02c-.013.007-.039-.012-.051-.004v-.008c.012-.008.037.011.051.004v.008",
    style: {
      fill: "#da291c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.184,15.028c-.013.007-.039-.012-.051-.004v-.008c.012-.008.037.011.051.003v.009Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.184,15.035c-.013.007-.039-.012-.051-.003v-.008c.012-.008.037.011.051.004v.007",
    style: {
      fill: "#00009e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.184,15.035c-.013.007-.039-.012-.051-.003v-.008c.012-.008.037.011.051.004v.007Z",
    style: {
      fill: "#001489"
    }
  }), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M8.976,16.708c-.073-.104-.178-.129-.311-.161-.175-.042-.393-.095-.647-.348-.293-.294-.296-.716-.204-.921.085-.19.214-.478.101-.927l.013-.003c.114.453-.016.744-.102.936-.071.158-.115.588.201.905.251.251.467.303.64.345.136.033.243.058.319.167l-.01.007ZM9.024,16.707l-.011-.008c.076-.108.183-.134.319-.167.174-.042.389-.094.64-.345.316-.317.272-.747.201-.905-.086-.193-.216-.484-.102-.936l.013.003c-.113.447.016.735.101.926.092.206.09.627-.204.921-.254.254-.472.306-.647.348-.132.034-.237.059-.31.163Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.051,13.218c.006.029.014.108-.029.119.079.097.193.111.392.111h.301c0,.025-.008.052-.008.083,0,.03.031.044.077.034s.143-.04.196.007c.089.079.252.093.296.143-.013-.06-.071-.122-.134-.172.06-.009.138-.002.165.018-.068-.074-.192-.076-.254-.112-.063-.036-.123-.068-.169-.08,0-.021-.003-.037-.021-.049-.039-.028-.116-.037-.179-.041.009-.009.011-.021.011-.038v-.097c0-.034.004-.042-.035-.066-.15-.093-.331-.158-.66-.158s-.51.065-.659.157c-.039.024-.035.033-.035.066v.097c0,.017.001.028.011.038-.063.003-.139.012-.179.041-.017.012-.021.028-.021.049-.046.011-.106.043-.169.08-.063.036-.186.038-.254.112.026-.021.104-.028.164-.018-.063.05-.12.111-.134.172.044-.05.207-.064.297-.143.052-.047.15-.018.196-.007.046.01.077-.003.077-.034s-.008-.058-.008-.083c.073-.002.175,0,.301,0,.199,0,.313-.014.392-.111-.044-.011-.036-.089-.029-.119-.093-.021-.14-.056-.215-.056-.074,0-.088.039-.088.054v.012c-.059,0-.142-.015-.163-.054.115-.047.285-.089.519-.089s.404.042.519.089c-.021.039-.104.054-.163.054v-.012c0-.014-.013-.054-.088-.054s-.122.034-.215.056h-.005Z",
    style: {
      fill: "#89c5e3"
    }
  }), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M7.722,13.721s-.002,0-.003,0c-.003,0-.004-.005-.004-.008.012-.052.054-.108.124-.166-.057-.006-.122.002-.143.019-.003.002-.007.002-.009,0s-.002-.007,0-.009c.044-.048.111-.066.169-.082.033-.009.065-.018.087-.031.055-.032.118-.066.166-.08.001-.02.005-.037.023-.049.032-.023.09-.037.17-.041-.004-.009-.005-.019-.005-.032v-.106c0-.029.001-.041.038-.063.127-.078.304-.158.663-.158s.536.08.663.158c.037.023.039.034.038.064v.105c0,.013-.001.023-.005.032.082.006.14.019.171.041.02.013.023.032.023.049.048.014.108.046.166.08.022.013.054.022.087.031.059.016.125.034.169.082.002.003.002.007,0,.009-.002.003-.006.003-.009,0-.022-.017-.085-.024-.144-.019.071.059.113.115.124.166.001.003-.001.006-.004.008-.003,0-.006,0-.008-.002-.019-.021-.063-.036-.114-.054-.062-.021-.132-.045-.181-.089-.045-.04-.127-.02-.176-.008l-.014.003c-.03.007-.055.004-.071-.008-.01-.008-.015-.019-.015-.032,0-.017.002-.032.004-.047.001-.01.003-.02.003-.029h-.29c-.207,0-.319-.017-.398-.114-.001-.002-.002-.004-.001-.007s.003-.004.005-.005c.037-.01.03-.082.024-.11-.001-.002,0-.004.001-.006.001-.002.004-.003.006-.003h.003c.035-.008.065-.019.091-.029.041-.015.077-.028.124-.028.075,0,.095.04.095.061v.005c.059,0,.123-.016.146-.043-.1-.04-.268-.085-.508-.085s-.408.045-.508.085c.022.027.087.042.146.043v-.005c0-.021.02-.061.095-.061.046,0,.081.013.122.027.027.01.057.021.095.029.002,0,.003.002.004.003.001.002.001.003.001.005-.006.026-.015.101.024.111.002,0,.004.002.005.005s0,.005-.001.007c-.079.097-.191.114-.398.114h-.127c-.065,0-.122,0-.167,0,0,.009.002.019.003.029.002.015.004.03.004.047,0,.013-.005.024-.015.032-.015.012-.04.015-.071.008l-.01-.003c-.047-.012-.134-.033-.18.008-.05.044-.12.068-.182.089-.051.017-.095.032-.114.054-.003.003-.005.004-.007.004ZM9.899,13.538c.032,0,.063.007.086.027.047.042.116.065.177.086.04.014.077.026.101.042-.018-.045-.061-.095-.125-.147-.002-.002-.003-.005-.002-.007.001-.003.003-.005.006-.005.041-.006.092-.005.13.003-.039-.027-.088-.04-.132-.052-.034-.009-.066-.018-.09-.032-.056-.032-.12-.067-.168-.08-.003,0-.005-.004-.005-.007,0-.02-.003-.033-.018-.043-.03-.021-.09-.035-.176-.039-.003,0-.005-.002-.006-.004-.001-.003,0-.005.001-.007.007-.007.009-.015.009-.033v-.105c0-.026,0-.033-.032-.052-.125-.077-.301-.156-.656-.156s-.531.079-.656.156c-.032.02-.032.026-.032.051v.107c0,.017.001.026.009.033.002.002.003.005.002.007-.001.003-.003.004-.006.004-.083.003-.144.017-.175.039-.015.01-.018.024-.018.043,0,.003-.002.006-.005.007-.047.012-.111.047-.167.08-.024.014-.056.023-.09.032-.044.012-.092.025-.131.052.038-.008.089-.009.128-.003.003,0,.005.002.006.005s0,.005-.002.007c-.064.051-.107.101-.125.146.024-.016.061-.028.101-.042.061-.021.13-.044.177-.086.051-.046.143-.023.192-.011l.01.002c.026.006.047.004.059-.005.006-.005.01-.012.01-.021,0-.016-.002-.031-.004-.045-.002-.013-.004-.026-.004-.038,0-.004.003-.007.007-.007.047,0,.106,0,.175,0h.126c.201,0,.305-.015.381-.101-.035-.018-.033-.08-.025-.117-.035-.008-.064-.019-.09-.028-.039-.014-.074-.026-.117-.026-.064,0-.081.031-.081.047v.012s-.003.007-.007.007c-.052,0-.145-.012-.169-.057-.001-.002-.001-.004,0-.006s.002-.003.004-.004c.1-.041.272-.089.521-.089s.421.048.521.089c.002,0,.003.002.004.004.001.002.001.004,0,.006-.024.045-.118.057-.169.057-.004,0-.007-.003-.007-.007v-.012c0-.016-.017-.047-.081-.047-.044,0-.079.012-.119.027-.026.009-.055.02-.091.028.004.024.013.095-.025.116.075.086.18.101.381.101h.301s.007.003.007.007c0,.012-.002.025-.004.038-.002.014-.004.029-.004.045,0,.009.003.016.01.021.012.009.033.012.059.006l.014-.003c.024-.006.062-.016.099-.016Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M9.709,13.538s-.007-.003-.007-.007c0-.009.004-.017.011-.023.017-.014.05-.018.09-.01.018.004.033.004.045,0,.001,0,.002-.002.003-.002.007-.003.011-.007.011-.01,0-.005-.008-.012-.026-.018-.021-.006-.06-.01-.12-.011-.004,0-.007-.003-.007-.007s.003-.007.007-.007h0c.061,0,.101.005.124.012.017.005.029.013.033.022.003-.007.003-.013.003-.017v-.089s.003-.007.007-.007.007.003.007.007v.089c0,.017-.007.032-.019.041-.016.013-.04.017-.071.01-.042-.008-.068,0-.079.007-.004.004-.006.008-.006.013.001.003-.002.007-.006.007ZM8.289,13.538s-.007-.003-.007-.007c0-.005-.002-.009-.006-.013-.01-.009-.036-.015-.079-.007-.031.006-.055.003-.071-.01-.012-.01-.019-.025-.019-.041v-.089s.003-.007.007-.007.007.003.007.007v.089s.001.011.004.018c.004-.009.016-.017.034-.023.023-.007.063-.011.124-.012.004,0,.007.003.007.007s-.003.007-.007.007c-.06,0-.099.004-.12.011-.018.006-.026.013-.026.018,0,.003.004.007.011.01.001,0,.002,0,.003.003.012.003.027.003.044,0,.041-.007.073-.004.09.01.007.006.011.014.011.023,0,.002-.004.006-.007.006ZM9.279,13.38c-.098,0-.199-.014-.28-.048-.176.076-.449.051-.578.004-.066-.024-.096-.036-.111-.051-.003-.003-.003-.007,0-.01s.007-.003.01,0c.013.013.043.025.106.047.128.047.397.071.57-.004.001,0,.002,0,.004,0,.001,0,.002,0,.004,0,.173.076.442.051.57.004.041-.014.067-.025.085-.034t.002-.002c.012-.006.018-.012.018-.015,0-.014-.064-.046-.098-.063-.018-.009-.038-.018-.063-.028-.004,0-.005-.005-.004-.009.001-.004.006-.005.009-.004.025.01.046.02.064.029.082.041.106.058.106.075,0,.002,0,.004-.001.006,0,.002,0,.005-.002.006-.015.015-.045.027-.111.051-.072.027-.184.046-.3.046ZM9.275,13.348c-.062,0-.099-.006-.131-.01-.031-.005-.057-.009-.1-.008-.004,0-.007-.003-.007-.007,0,0,0-.003.001-.004,0-.003.003-.005.006-.006.035-.006.068-.018.099-.029.041-.015.08-.029.122-.029.056,0,.075.019.081.03.001-.004.002-.008.002-.011v-.045s.003-.007.007-.007.007.003.007.007v.045c0,.031-.034.074-.087.074ZM9.09,13.317c.02,0,.038.004.056.007.032.005.068.01.129.01.025,0,.044-.01.057-.024,0,0,.001-.002.002-.003.003-.004.004-.008.001-.013-.005-.012-.026-.024-.07-.024-.04,0-.078.014-.118.028-.018.006-.037.013-.057.019ZM8.723,13.348c-.054,0-.087-.043-.087-.074v-.045s.003-.007.007-.007.007.003.007.007v.045s.001.007.002.011c.006-.01.025-.029.081-.029.042,0,.081.014.122.029.031.011.064.023.099.029.003,0,.005.003.006.006.001,0,.001.002.001.004,0,.004-.003.007-.007.007-.042,0-.069.003-.1.008-.032.003-.069.009-.131.009ZM8.665,13.309c.012.014.032.026.058.026.061,0,.097-.005.129-.01.018-.003.035-.005.056-.007-.02-.006-.039-.013-.057-.019-.04-.014-.078-.028-.118-.028-.043,0-.064.012-.07.024-.002.005-.002.01.001.013,0,0,.001,0,.001.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.999,13.341c.055,0,.056-.041.056-.079,0-.037-.002-.078-.056-.078s-.056.041-.056.078.001.079.056.079Z",
    style: {
      fill: "#89c5e3"
    }
  }), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M8.999,13.348c-.063,0-.063-.054-.063-.086s0-.085.063-.085.063.053.063.085c0,.034,0,.086-.063.086ZM8.999,13.19c-.046,0-.05.031-.05.072s.004.072.05.072.05-.03.05-.072c0-.041-.004-.072-.05-.072Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M8.336,13.3s-.002,0-.003,0c-.013-.007-.026-.015-.026-.028,0-.017.025-.034.108-.075.018-.009.04-.018.066-.029.004,0,.008,0,.009.004.001.004,0,.008-.004.009-.025.01-.046.019-.065.028-.035.017-.1.049-.101.063,0,.004.006.009.018.015.003.002.005.006.003.009,0,.004-.003.005-.005.005Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.868,13.923c.075-.048.168-.13.202-.184.047-.075.053-.039.089-.045-.084.092-.189.191-.263.243l-.028-.014M8.238,14.104c-.188-.107-.26.005-.304.01.053.012.097.095.304-.01Z",
    style: {
      fill: "#078930"
    }
  }), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M8.064,14.164c-.046,0-.075-.016-.099-.029-.012-.006-.022-.012-.032-.014l-.037-.009.038-.005c.009,0,.021-.008.034-.016.047-.028.127-.076.274.007l.011.006-.011.006c-.08.041-.136.054-.178.054ZM7.955,14.114c.005.003.011.006.017.009.042.023.1.055.252-.019-.133-.071-.202-.029-.248,0-.008.004-.015.008-.021.011ZM8.896,13.945l-.042-.022.01-.006c.071-.046.165-.126.2-.182.034-.055.049-.055.071-.049.007.002.014.003.023.002l.02-.003-.014.015c-.09.099-.194.195-.264.244h-.004ZM8.882,13.922l.014.007c.067-.047.162-.135.248-.228-.004,0-.008,0-.011-.002-.015-.003-.025-.006-.056.043-.035.055-.124.133-.195.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.323,14.042c-.179-.121-.259-.015-.304-.013.051.017.089.103.304.013Z",
    style: {
      fill: "#078930"
    }
  }), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16,14.09c-.055,0-.086-.02-.112-.037-.011-.007-.021-.014-.031-.017l-.036-.011.037-.002c.009,0,.021-.007.036-.014.049-.025.132-.067.272.028l.011.007-.012.005c-.072.03-.125.041-.165.041ZM8.039,14.031c.005.003.011.007.016.01.041.026.096.062.252,0-.127-.081-.199-.044-.248-.02-.006.005-.013.008-.02.011Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.451,13.97c-.176-.125-.259-.021-.304-.019.051.018.086.104.304.019ZM8.556,13.907c-.162-.143-.255-.048-.299-.052.049.023.075.113.299.052Z",
    style: {
      fill: "#078930"
    }
  }), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M8.291,14.014c-.058,0-.09-.021-.116-.039-.011-.008-.021-.014-.03-.017l-.034-.012h.036c.009,0,.021-.007.036-.014.029-.014.071-.034.128-.028-.011-.007-.019-.015-.028-.022-.01-.009-.019-.016-.028-.021l-.034-.016.037.003c.009,0,.022-.004.037-.009.052-.018.14-.049.266.063l.01.009-.012.003c-.066.018-.115.023-.153.021.016.008.032.018.05.031l.011.007-.012.005c-.073.026-.125.036-.164.036ZM8.167,13.954c.005.003.011.007.016.01.04.027.094.064.253.005-.125-.083-.198-.048-.247-.025-.008.004-.015.007-.022.01ZM8.277,13.859c.005.004.01.008.014.012.037.031.087.074.251.032-.115-.097-.192-.07-.243-.052-.008.004-.015.006-.022.008Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.692,13.86c-.155-.152-.253-.061-.296-.067.047.025.068.117.296.067Z",
    style: {
      fill: "#078930"
    }
  }), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M8.574,13.882c-.09,0-.126-.034-.154-.061-.01-.009-.018-.017-.028-.022l-.035-.018.039.005c.009,0,.022-.003.038-.007.053-.016.142-.042.263.076l.009.009-.013.003c-.048.011-.087.015-.119.015ZM8.415,13.798c.005.004.009.008.014.013.035.033.083.078.248.045-.11-.102-.188-.079-.24-.064-.008.003-.015.005-.022.006Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.833,13.845c-.128-.174-.239-.101-.282-.114.042.033.048.126.282.114Z",
    style: {
      fill: "#078930"
    }
  }), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M8.792,13.853c-.153,0-.193-.052-.222-.091-.008-.01-.015-.019-.023-.026l-.028-.022.034.01c.009.003.022,0,.038,0,.055-.007.147-.019.248.117l.008.01h-.013c-.015.003-.029.003-.042.003ZM8.569,13.74c.004.005.008.01.011.015.029.039.069.091.239.084-.092-.119-.173-.108-.227-.102-.008,0-.016.002-.023.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.856,13.852c-.006-.039-.08-.089-.086-.108.019-.002.021-.024.013-.032-.006-.006-.022-.003-.03.005-.008.01-.016.033.01.053.027.02.061.056.072.082",
    style: {
      fill: "#078930"
    }
  }), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M8.829,13.855c-.01-.025-.043-.06-.069-.079-.012-.009-.019-.02-.02-.032-.002-.016.007-.028.009-.031.007-.007.016-.011.025-.011.007,0,.011.002.014.005.006.006.008.017.005.027-.002.007-.007.012-.012.014.005.006.014.015.023.024.024.023.055.053.059.079l-.014.002c-.004-.022-.033-.05-.055-.071-.018-.017-.028-.027-.031-.036l-.003-.008h.009c.007-.002.009-.006.011-.009.002-.005.001-.01-.001-.012-.001,0-.002,0-.004,0h0c-.005,0-.011.003-.015.007-.003.004-.007.012-.006.02s.006.016.015.022c.027.02.062.057.074.085l-.014.005Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.067,14.116c.051-.015.116-.008.16-.013M8.151,14.041c.053-.012.116,0,.161,0M8.279,13.966c.053-.01.116.003.161.003M8.386,13.883c.054-.004.115.015.159.021M8.522,13.828c.054-.002.114.021.159.029M8.672,13.787c.054.005.109.039.151.053",
    style: {
      fill: "#078930"
    }
  }), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M8.067,14.123s-.006-.002-.007-.005c-.001-.004.001-.008.005-.009.034-.01.075-.011.11-.011.019,0,.036,0,.052-.002.004,0,.007.002.008.006,0,.004-.002.007-.006.008-.016.002-.034.002-.053.002-.035,0-.074,0-.106.01-.001,0-.002,0-.003,0ZM8.151,14.048s-.006-.002-.007-.005c-.001-.004.002-.007.005-.008.037-.008.079-.005.116-.003.017,0,.033.002.047.002.004,0,.007.003.007.007s-.003.007-.007.007c-.015,0-.031,0-.048-.002-.036-.003-.077-.006-.112.002,0,0,0,0,0,0ZM8.44,13.975c-.016,0-.034,0-.052-.003-.035-.003-.074-.006-.108,0-.004,0-.007-.002-.008-.006-.001-.004.002-.007.006-.008.036-.006.076-.003.111,0,.018.002.036.003.051.003.004,0,.007.003.007.007,0,.004-.003.007-.007.007ZM8.546,13.911s0,0,0,0c-.016-.002-.033-.005-.05-.009-.035-.007-.074-.015-.109-.012-.004,0-.007-.003-.007-.006,0-.004.003-.007.006-.007.037-.003.077.005.112.012.017.003.034.007.048.008.004,0,.007.004.006.008,0,.003-.003.006-.006.006ZM8.681,13.864h-.001c-.014-.003-.03-.007-.047-.011-.035-.009-.074-.019-.11-.018-.004,0-.007-.003-.007-.007s.003-.007.007-.007c.038,0,.078.009.114.018.017.004.032.008.046.011.004,0,.006.004.006.008-.002.003-.005.006-.008.006ZM8.823,13.846h-.002c-.015-.005-.031-.012-.048-.019-.032-.014-.068-.03-.102-.033-.004,0-.007-.004-.006-.008,0-.004.004-.007.008-.006.036.004.073.02.106.034.017.007.033.014.047.019.004,0,.006.005.004.009,0,.003-.004.004-.007.004Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.131,13.923c-.075-.048-.168-.13-.202-.184-.047-.075-.053-.039-.089-.045.084.092.189.191.263.243l.028-.014M9.76,14.104c.188-.107.26.005.304.01-.052.012-.096.095-.304-.01Z",
    style: {
      fill: "#078930"
    }
  }), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M9.935,14.164c-.042,0-.098-.013-.178-.054l-.011-.006.011-.006c.147-.083.226-.036.274-.007.014.008.025.015.034.016l.038.005-.037.009c-.01.002-.02.008-.032.014-.024.013-.053.029-.099.029ZM9.775,14.104c.152.074.209.042.252.019.006-.003.011-.006.017-.009-.006-.003-.013-.007-.02-.012-.047-.028-.116-.069-.249.002ZM9.102,13.945l-.003-.002c-.07-.049-.174-.145-.264-.244l-.014-.015.02.003c.009.002.016,0,.023-.002.022-.005.037-.005.071.049.035.056.129.136.2.182l.01.006-.043.023ZM8.855,13.702c.086.092.181.18.248.228l.014-.007c-.071-.047-.16-.125-.195-.179-.03-.049-.041-.047-.056-.043-.003,0-.006,0-.011.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.676,14.042c.179-.121.259-.015.304-.013-.051.017-.089.103-.304.013Z",
    style: {
      fill: "#078930"
    }
  }), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M9.839,14.09c-.04,0-.093-.011-.165-.041l-.012-.005.011-.007c.14-.095.223-.053.272-.028.014.007.026.013.036.014l.037.002-.036.011c-.01.003-.02.01-.031.017-.026.017-.057.037-.112.037ZM9.691,14.041c.156.063.212.027.252,0,.006-.004.011-.007.016-.01-.006-.003-.013-.006-.021-.01-.048-.026-.12-.062-.247.019Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.548,13.97c.176-.125.259-.021.304-.019-.051.018-.086.104-.304.019ZM9.442,13.907c.162-.143.255-.048.299-.052-.048.023-.074.113-.299.052Z",
    style: {
      fill: "#078930"
    }
  }), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M9.708,14.014c-.04,0-.091-.01-.162-.038l-.012-.005.011-.007c.017-.012.034-.022.05-.031-.038.002-.087-.003-.153-.021l-.012-.003.01-.009c.127-.112.214-.081.266-.063.015.005.028.01.037.009l.037-.003-.034.016c-.009.005-.018.012-.028.021-.008.007-.017.015-.028.022.057-.006.098.014.128.028.014.007.027.013.036.013h.036s-.034.013-.034.013c-.01.004-.019.01-.03.017-.028.02-.06.041-.118.041ZM9.563,13.969c.159.059.213.022.253-.005.005-.004.011-.007.016-.01-.007-.003-.014-.006-.021-.01-.05-.024-.123-.059-.248.025ZM9.457,13.903c.164.042.214,0,.251-.032.005-.004.01-.008.014-.012-.007-.002-.014-.004-.022-.007-.052-.018-.128-.045-.243.051Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.307,13.86c.155-.152.253-.061.296-.067-.047.025-.068.117-.296.067Z",
    style: {
      fill: "#078930"
    }
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M9.425,13.882c-.032,0-.071-.004-.119-.015l-.013-.003.009-.009c.121-.118.21-.092.263-.076.015.005.029.008.038.007l.039-.005-.035.018c-.009.005-.018.013-.028.022-.028.027-.064.061-.154.061ZM9.321,13.856c.165.034.213-.012.248-.045.005-.004.009-.009.014-.013-.007-.002-.014-.004-.023-.006-.051-.015-.128-.038-.239.064Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.165,13.845c.128-.174.239-.101.282-.114-.041.033-.048.126-.282.114Z",
    style: {
      fill: "#078930"
    }
  }), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M9.207,13.853c-.013,0-.027,0-.042,0h-.013s.008-.011.008-.011c.1-.136.192-.124.248-.117.016.002.03.004.038,0l.034-.01-.028.022c-.008.006-.015.015-.023.026-.029.038-.068.09-.222.09ZM9.179,13.839c.17.006.21-.046.239-.084.004-.005.008-.01.011-.015-.007,0-.015,0-.024-.003-.053-.007-.134-.017-.226.102Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.142,13.852c.006-.039.08-.089.086-.108-.019-.002-.021-.024-.013-.032.006-.006.022-.003.03.005.008.01.016.033-.01.053-.027.02-.061.056-.072.082",
    style: {
      fill: "#078930"
    }
  }), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M9.169,13.855l-.013-.005c.011-.029.047-.065.074-.085.009-.007.014-.014.015-.022s-.003-.016-.006-.02c-.003-.003-.01-.006-.015-.006-.003,0-.004,0-.005,0-.002.002-.003.007-.001.012.001.003.004.008.011.008h.009s-.003.009-.003.009c-.003.008-.013.019-.031.036-.022.021-.051.049-.055.071l-.014-.002c.004-.026.035-.056.059-.079.009-.009.018-.018.023-.024-.006-.003-.01-.008-.012-.014-.003-.01-.002-.021.005-.027.004-.003.008-.006.014-.005.009,0,.019.004.025.011.003.004.011.015.01.031-.001.012-.008.023-.02.032-.027.017-.06.052-.07.078Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.931,14.116c-.051-.015-.116-.008-.16-.013M9.848,14.041c-.053-.012-.116,0-.161,0M9.72,13.966c-.053-.01-.116.003-.161.003M9.613,13.883c-.054-.004-.115.015-.159.021M9.476,13.828c-.054-.002-.114.021-.159.029M9.327,13.787c-.054.005-.109.039-.151.053",
    style: {
      fill: "#078930"
    }
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M9.931,14.123h-.002c-.032-.01-.072-.01-.106-.01-.019,0-.037,0-.053-.002-.004,0-.007-.004-.006-.008,0-.004.004-.007.008-.006.015.002.033.002.052.002.035,0,.076,0,.11.011.004,0,.006.005.005.009-.002.002-.005.004-.008.004ZM9.848,14.048h-.001c-.035-.008-.076-.005-.112-.002-.017,0-.033.002-.048.002-.004,0-.007-.003-.007-.007s.003-.007.007-.007c.014,0,.03,0,.047-.002.037-.003.079-.006.116.003.004,0,.006.005.005.008,0,.003-.004.005-.007.005ZM9.559,13.975s-.007-.003-.007-.007.003-.007.007-.007c.015,0,.033,0,.051-.003.035-.003.076-.006.111,0,.004,0,.006.004.006.008-.001.004-.004.006-.008.006-.034-.006-.073-.003-.108,0-.019.002-.036.003-.052.003ZM9.453,13.911s-.006-.003-.007-.006c0-.004.002-.007.006-.008.015-.002.031-.005.048-.008.035-.007.076-.015.112-.012.004,0,.007.004.006.007,0,.004-.004.007-.007.006-.035-.003-.074.005-.109.012-.016.004-.033.007-.049.009.001,0,0,0,0,0ZM9.318,13.864s-.006-.002-.007-.006c-.001-.004.002-.007.006-.008.014-.003.03-.007.046-.011.036-.009.076-.019.114-.018.004,0,.007.003.007.007s-.004.006-.007.007c-.036,0-.075.009-.11.018-.017.004-.033.008-.047.011,0-.001-.002,0-.002,0ZM9.175,13.846s-.006-.002-.007-.005c-.001-.004.001-.008.004-.009.014-.005.03-.012.047-.019.033-.014.07-.031.106-.034.004,0,.007.002.008.006,0,.004-.002.007-.006.008-.034.003-.07.019-.102.033-.017.008-.033.015-.048.019,0,0-.001,0-.002,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9,13.913c.042,0,.078,0,.104-.003v-.06c0-.02.07-.043.176-.022.414.081.47.268.785.375.004,0,.015.005.029.007l.027-.061c.005-.017.051-.016.091.003.047.022.067.048.059.062-.008.02-.016.036-.023.052.073.026.207.066.163.242-.034-.033-.116-.069-.167-.069-.058,0-.121-.022-.101-.086-.011-.005-.03-.015-.039-.017-.002.005-.004.011-.007.016-.013.033-.072.045-.13.025-.328-.112-.429-.359-.816-.363v.011c0,.031-.04.06-.149.06-.108,0-.149-.029-.149-.06v-.011c-.386.003-.488.25-.816.363-.057.02-.116.007-.13-.025-.002-.005-.004-.011-.007-.016-.01.002-.029.012-.039.017.019.063-.042.086-.101.086-.051,0-.133.036-.167.069-.044-.175.088-.215.163-.242l-.023-.052c-.007-.014.013-.039.059-.062.04-.02.085-.021.091-.003l.027.061c.013-.003.024-.006.029-.007.314-.108.371-.295.785-.375.105-.021.176.003.176.022v.06c.022.002.058.003.1.003h0Z",
    style: {
      fill: "#fff"
    }
  }), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M10.41,14.514s-.004,0-.005-.002c-.031-.03-.111-.067-.163-.067-.022,0-.077-.004-.101-.036-.011-.015-.014-.032-.008-.053-.008-.004-.019-.009-.027-.012-.002.004-.004.007-.005.011-.015.036-.077.049-.138.029-.132-.045-.226-.111-.318-.175-.135-.094-.263-.183-.489-.187v.004c0,.02-.015.067-.156.067-.14,0-.156-.047-.156-.067v-.004c-.226.003-.354.093-.489.187-.092.064-.186.13-.318.175-.06.021-.122.008-.138-.029,0-.004-.003-.007-.005-.011-.008.003-.019.008-.028.012.005.021.002.038-.009.053-.017.023-.054.036-.1.036-.051,0-.131.037-.163.067-.002.002-.004.002-.007.002-.002,0-.004-.003-.005-.005-.044-.175.083-.22.159-.247h.002s-.02-.046-.02-.046c-.002-.005-.003-.011,0-.017.006-.018.029-.037.063-.054.031-.015.067-.021.087-.012.009.004.013.01.014.014l.024.055c.006,0,.012-.003.016-.004.003,0,.005-.002.007-.002.13-.045.218-.105.303-.163.118-.081.241-.165.482-.212.084-.016.152-.006.175.013.007.006.009.012.009.016v.054c.023.002.055.003.097.003.038,0,.072,0,.097-.003v-.054s.002-.01.009-.016c.023-.019.091-.03.175-.013.241.047.363.131.481.212.085.058.173.119.305.164h.003s.011.004.019.006l.025-.056s.004-.009.012-.012c.019-.008.056-.004.088.011.035.017.058.037.064.055.002.006.001.012-.002.017-.005.012-.01.023-.015.034-.002.003-.003.007-.005.01h.001c.076.027.203.071.159.247-.001.002-.002.004-.005.005,0,0,0,0,0,0ZM7.85,14.143c-.016,0-.037.004-.058.015-.036.017-.052.035-.056.046,0,.003,0,.005,0,.007l.023.052s0,.004,0,.006c0,.002-.002.003-.004.004l-.009.003c-.074.026-.185.066-.153.22.038-.031.113-.063.163-.063.042,0,.075-.011.089-.031.009-.012.011-.028.005-.046,0-.003,0-.007.004-.008l.005-.003c.012-.006.027-.013.036-.015.003,0,.006,0,.007.004v.002c.004.005.006.01.008.015.013.029.069.039.121.021.129-.045.223-.11.314-.174.138-.097.269-.188.504-.19h0s.004,0,.005.002.002.003.002.005v.011c0,.026.037.053.142.053s.142-.027.142-.053v-.011s.001-.004.002-.005.003-.002.005-.002h0c.235.002.365.093.504.19.091.064.185.129.315.173.054.018.109.008.121-.021.003-.005.005-.01.007-.016.001-.003.004-.005.008-.005.009.002.024.009.036.015l.005.002s.005.005.004.008c-.006.019-.004.034.005.046.014.019.048.031.09.031.051,0,.126.033.163.063.033-.154-.078-.193-.153-.22l-.009-.003s-.003-.002-.004-.004-.001-.004,0-.005c.003-.006.005-.011.008-.017.005-.011.01-.022.015-.034.001-.002.001-.005.001-.007-.003-.01-.02-.028-.056-.046-.031-.014-.063-.017-.077-.011-.002,0-.004.002-.005.005l-.027.061s-.004.005-.008.004c-.011-.002-.021-.005-.026-.006h-.003c-.134-.047-.223-.108-.309-.167-.117-.08-.238-.163-.476-.21-.089-.017-.147-.003-.163.01-.003.002-.004.004-.004.005v.06s-.003.006-.006.007c-.025.004-.061.004-.103.004-.046,0-.08,0-.105-.003-.004,0-.006-.003-.006-.007v-.06s-.001-.003-.004-.005c-.016-.013-.075-.028-.163-.011-.238.046-.359.13-.477.21-.086.059-.174.12-.307.165-.002,0-.004,0-.007.002-.006.002-.014.004-.023.005-.003,0-.006,0-.008-.004l-.027-.061s-.003-.005-.007-.006c-.003-.001-.009-.002-.016-.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.895,13.91c-.028-.003-.044-.009-.044-.02,0-.027.044-.018.044-.04M7.841,14.204l.056.13M7.801,14.224c.016.038.047.102.056.129",
    style: {
      fill: "#fff"
    }
  }), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M7.857,14.36s-.006-.002-.007-.005c-.006-.018-.022-.053-.036-.084-.007-.016-.014-.031-.019-.044-.002-.004,0-.008.004-.009.003-.002.008,0,.009.004.005.012.012.028.019.044.015.033.03.067.036.086,0,.004,0,.008-.004.009t-.002-.001ZM7.896,14.341s-.005-.002-.006-.004l-.056-.13s0-.008.004-.009.008,0,.009.004l.056.13s0,.008-.004.009h-.003ZM8.895,13.917h0c-.022-.002-.051-.007-.051-.027,0-.019.016-.025.028-.029.011-.004.016-.006.016-.011,0-.004.003-.007.007-.007s.007.003.007.007c0,.016-.014.021-.025.025-.013.005-.019.008-.019.016,0,.004.01.01.038.013.004,0,.007.004.006.008,0,.002-.003.005-.007.005Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M7.751,14.273s-.005-.002-.007-.005c0-.004,0-.008.004-.009.044-.016.049-.024.046-.034,0-.003-.018,0-.027,0-.019.003-.039.006-.046-.008-.002-.003,0-.008.003-.009.003-.002.008,0,.009.003.003.005.02.003.032,0,.018-.003.037-.005.042.009.009.027-.018.039-.054.052h-.002ZM7.867,14.221c-.014,0-.026-.003-.031-.013-.009-.016.007-.027.019-.036.012-.008.019-.014.017-.021,0-.004,0-.008.004-.009.004,0,.008,0,.009.004.006.017-.01.028-.022.037-.013.009-.017.013-.015.018.002.004.011.011.056,0,.004,0,.007.002.008.005,0,.004-.002.007-.005.008-.013.003-.028.006-.04.006Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.85,13.889v.125M9.105,13.91c.027-.003.044-.009.044-.02,0-.027-.044-.018-.044-.04M10.159,14.204l-.056.13M10.198,14.224c-.016.038-.047.102-.056.129",
    style: {
      fill: "#fff"
    }
  }), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M10.143,14.36h-.002s-.006-.005-.004-.009c.006-.018.022-.053.037-.086.007-.016.014-.031.019-.043.001-.003.006-.005.009-.004.004.002.005.006.004.009-.005.012-.012.028-.019.044-.014.031-.03.067-.036.085-.003.002-.005.004-.008.004ZM10.103,14.341s-.002,0-.003,0c-.004-.002-.005-.006-.004-.009l.056-.13s.006-.005.009-.004c.004.002.005.006.004.009l-.056.13s-.003.005-.006.005ZM8.85,14.021s-.007-.003-.007-.007v-.125s.003-.007.007-.007.007.003.007.007v.125s-.003.007-.007.007ZM9.105,13.917s-.007-.003-.007-.006c0-.004.002-.007.006-.008.03-.003.038-.009.038-.013,0-.008-.006-.011-.019-.016-.011-.004-.025-.009-.025-.025,0-.004.003-.007.007-.007s.007.003.007.007c0,.005.005.008.016.011.012.004.028.01.028.029,0,.022-.038.026-.051.028h0Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M10.249,14.273h-.002c-.036-.013-.063-.025-.054-.052.006-.014.024-.012.042-.009.012.002.029.004.032,0,.002-.003.006-.004.009-.003.003.002.004.006.003.009-.008.014-.027.011-.046.008-.009,0-.026-.004-.028,0-.003.01.003.018.046.034.004,0,.005.005.004.009,0,.003-.004.005-.006.005ZM10.133,14.221c-.013,0-.027-.003-.04-.005-.004,0-.006-.005-.005-.008.001-.004.005-.006.008-.005.045.01.054.003.056,0,.003-.005-.002-.009-.015-.018-.012-.009-.028-.02-.022-.037.001-.004.005-.006.009-.004.004,0,.006.005.004.009-.002.007.005.013.017.021s.028.02.019.036c-.005.009-.017.012-.031.012Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.149,13.889v.125",
    style: {
      fill: "#fff"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "9.149 14.021 9.143 14.014 9.143 13.889 9.149 13.882 9.156 13.889 9.156 14.014 9.149 14.021"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M8.019,14.334l-.035-.124.043-.012c.011-.003.019-.004.025-.003s.01.004.015.008c.005.005.008.011.01.018.003.01.003.018,0,.025s-.009.013-.017.017c.005.002.01.004.014.007s.01.009.017.017l.019.021-.024.007-.022-.023-.016-.015s-.005-.003-.008-.003c-.002,0-.006,0-.011.002h-.004s.014.053.014.053l-.02.005ZM8.02,14.257l.015-.004c.009-.003.015-.005.017-.006s.004-.004.005-.007.001-.006,0-.011c-.001-.004-.003-.007-.005-.009-.002-.002-.005-.003-.008-.003-.002,0-.008,0-.017.004l-.016.005.009.031ZM8.133,14.301l-.057-.115.07-.035.01.02-.051.025.013.026.048-.024.01.019-.048.023.016.031.053-.026.01.019-.074.037ZM8.226,14.252l-.07-.108.029-.019c.011-.007.018-.011.022-.012.006-.002.013,0,.02.002.007.003.013.009.019.018.005.008.008.015.008.023s-.001.013-.004.018c-.003.005-.01.011-.021.018l-.011.008.026.041-.018.011ZM8.186,14.151l.02.031.01-.006c.007-.004.011-.008.013-.01.002-.003.003-.005.003-.009,0-.003-.001-.007-.003-.01-.002-.004-.005-.006-.008-.008s-.006-.002-.009,0c-.003,0-.008.003-.016.008l-.01.005ZM8.234,14.095l.017-.012.04.057.013.017s.008.006.013.007c.005,0,.009,0,.014-.004.004-.003.007-.006.008-.01s.001-.007,0-.011c-.001-.004-.006-.011-.013-.022l-.041-.058.018-.012.039.055c.01.014.016.025.019.032.003.007.003.015,0,.023s-.008.014-.017.021c-.009.006-.017.01-.025.01s-.014-.002-.021-.006c-.006-.004-.015-.014-.026-.03l-.038-.057ZM8.323,14.03l.036-.023c.01-.006.017-.01.022-.011s.01,0,.016.003.01.007.014.013c.003.005.005.011.006.016s-.001.011-.003.015c.006-.002.013,0,.019.002s.011.007.015.014c.005.008.007.016.007.024s-.003.014-.007.019c-.003.003-.011.009-.024.017l-.03.019-.071-.108ZM8.353,14.037l.016.025.012-.008.013-.009s.004-.005.005-.008c0-.003-.001-.007-.003-.01s-.004-.005-.007-.006-.005,0-.007,0-.008.004-.018.01l-.011.006ZM8.38,14.08l.019.029.017-.011c.007-.005.012-.008.013-.01.002-.002.002-.005.002-.008s-.001-.006-.003-.01-.005-.006-.008-.007c-.003,0-.006-.002-.009,0-.003,0-.008.004-.016.008l-.015.01ZM8.475,14.082l-.059-.113.019-.01.049.094.047-.024.01.019-.066.034ZM8.555,14.039l-.05-.119.02-.008.05.119-.02.008ZM8.64,13.962l.022.002c.001.015-.001.026-.006.035-.005.008-.013.014-.024.017-.013.004-.025.002-.037-.006-.013-.009-.022-.023-.028-.043-.006-.021-.006-.039-.001-.054.005-.013.015-.021.029-.025.011-.003.022-.002.032.003.007.004.014.011.019.021l-.018.012c-.003-.006-.007-.011-.012-.013s-.01-.003-.015,0c-.007.002-.013.007-.015.015s-.002.019.003.034c.005.016.01.026.017.031s.014.007.021.004c.005-.002.009-.005.012-.01,0-.004.002-.012,0-.022ZM8.779,13.978l-.023.004-.014-.027-.042.008-.003.03-.022.004.017-.134.022-.004.065.119ZM8.731,13.935l-.023-.044-.005.05.028-.006ZM8.911,13.929l.038.003c.01,0,.017.002.021.005.005.003.009.006.013.012s.006.012.008.021c.002.008.002.018.001.03-.001.011-.003.02-.006.028-.003.008-.007.014-.011.018s-.009.008-.014.01c-.006.002-.012.003-.021.002l-.039-.003.01-.126ZM8.93,13.952l-.006.083h.016c.007.002.012,0,.015,0s.006-.003.008-.005c.002-.002.004-.006.006-.012.002-.005.003-.013.004-.021.001-.009.001-.017,0-.022-.001-.005-.003-.01-.005-.013s-.006-.006-.009-.007c-.003,0-.008-.002-.017-.002h-.012ZM9.02,14.061l-.008-.125.076-.005v.021s-.055.004-.055.004l.002.028.052-.003v.021s-.051.003-.051.003l.002.034.057-.004v.021s-.075.005-.075.005ZM9.252,13.941l.02.009c-.004.014-.01.024-.018.031-.008.006-.017.009-.028.008-.014,0-.025-.007-.033-.018-.009-.013-.013-.029-.012-.05.001-.022.007-.039.018-.051.009-.01.021-.015.036-.014.012,0,.021.005.029.014.005.006.009.015.011.026l-.021.005c-.001-.007-.003-.013-.007-.016-.004-.004-.009-.006-.014-.006-.008,0-.014.003-.02.009s-.008.018-.009.033c-.001.016.001.028.005.035.004.007.01.011.018.011.006,0,.011-.002.015-.006.005-.004.008-.011.01-.02h0ZM9.3,13.929c.004-.015.009-.027.016-.035.007-.009.014-.014.023-.017.008-.003.017-.003.028,0,.015.004.025.012.032.026.006.013.007.031.002.051-.005.021-.014.036-.027.045-.011.008-.024.011-.039.007-.015-.004-.025-.012-.031-.024-.009-.014-.009-.031-.004-.052ZM9.321,13.934c-.004.014-.003.026,0,.034.004.009.01.014.018.016.008.002.016,0,.023-.006s.012-.016.016-.031.004-.026,0-.034c-.003-.008-.009-.013-.018-.015s-.016,0-.023.005c-.007.006-.012.016-.016.031ZM9.411,13.982l.02.006c-.004.016,0,.027.012.032.006.003.011.003.016,0s.008-.005.01-.009c.001-.003.002-.005.001-.008,0-.002-.002-.005-.003-.007s-.007-.007-.015-.014c-.007-.006-.012-.011-.015-.016s-.004-.01-.004-.016.001-.012.003-.017c.003-.007.007-.012.012-.016.005-.004.011-.006.017-.007.006,0,.013,0,.021.004.011.005.019.012.023.021s.003.019-.001.031l-.02-.007c.002-.007.002-.012,0-.016-.002-.004-.005-.007-.011-.009-.005-.002-.01-.003-.014-.002s-.006.003-.008.006c-.001.003-.001.006,0,.01.002.003.007.008.015.015.009.007.015.013.018.018s.005.01.005.016-.001.013-.004.02c-.004.01-.011.018-.021.022s-.021.004-.034-.002c-.024-.009-.032-.028-.023-.056h0ZM9.51,14.074l.052-.094-.027-.015.011-.019.073.041-.011.019-.027-.015-.052.093-.019-.01ZM9.647,14.159l-.019-.013.008-.03-.035-.023-.023.02-.019-.012.105-.085.019.012-.036.131ZM9.642,14.095l.014-.048-.038.032.024.016ZM9.69,14.19l.074-.106.036.026c.009.007.016.012.018.017.003.005.004.01.003.017-.001.006-.003.013-.008.02-.006.008-.012.014-.02.016-.007.002-.015.002-.024-.002.002.005.003.01.003.015s0,.013-.002.024l-.004.028-.021-.014.003-.032c.001-.011.002-.019.002-.022s-.001-.006-.002-.008c-.001-.002-.004-.005-.008-.007l-.004-.003-.031.044-.015-.013ZM9.75,14.141l.013.009c.008.006.013.009.016.01s.005,0,.008,0c.003,0,.005-.004.008-.007.002-.003.004-.007.004-.01s-.001-.006-.003-.008c-.001-.002-.006-.005-.014-.011l-.014-.01-.018.028ZM9.777,14.25l.071-.108.018.012-.071.108-.018-.012ZM9.894,14.266l.014.017c-.01.011-.02.017-.03.019s-.019,0-.029-.005c-.012-.007-.019-.017-.021-.03-.002-.016.001-.032.012-.05.011-.019.024-.031.038-.037.013-.005.026-.004.038.003.01.006.017.014.02.025.002.008.001.017-.002.028l-.021-.005c.002-.007.003-.013.001-.018s-.005-.009-.01-.012c-.007-.004-.014-.004-.022,0-.008.003-.015.012-.023.026-.008.014-.012.025-.011.034.001.008.004.014.011.018.005.003.01.003.016.002.006-.002.012-.006.019-.014ZM9.993,14.36l-.022-.008.002-.031-.04-.015-.018.024-.021-.008.084-.106.021.008-.006.136ZM9.975,14.298l.003-.05-.03.04.027.01ZM8.496,13.143l-.018.008-.017-.019-.033.015.003.026-.017.008-.013-.114.017-.008.078.084ZM8.448,13.117l-.028-.032.006.042.022-.01ZM8.505,13.14l-.034-.104.026-.008.039.066-.008-.076.026-.008.034.104-.016.005-.027-.081.01.087-.017.005-.044-.076.027.081-.016.005ZM8.605,13.109l-.026-.106.064-.016.004.018-.047.012.006.023.044-.011.004.018-.044.011.007.029.049-.012.004.018-.065.016ZM8.686,13.089l-.019-.107.037-.007c.01-.002.017-.002.021,0,.004,0,.008.004.012.008.003.004.006.01.007.016.002.008.001.016-.002.021s-.008.01-.015.013c.004.002.008.004.011.007.003.003.008.008.013.016l.014.019-.021.004-.017-.021-.012-.014s-.004-.003-.006-.003h-.013s.008.046.008.046l-.018.003ZM8.692,13.024l.013-.002c.008,0,.013-.003.015-.004.002,0,.004-.003.005-.005s.001-.005.001-.009c-.001-.003-.002-.006-.004-.008s-.004-.003-.006-.003-.007,0-.015.002l-.014.003.005.026ZM8.774,13.074l-.015-.108.018-.002.015.108-.018.002ZM8.862,13.024l.018.005c-.002.012-.005.022-.011.028-.006.006-.013.01-.023.011-.012,0-.021-.003-.029-.011-.009-.009-.015-.023-.016-.041-.002-.018.001-.033.008-.045.006-.01.016-.015.028-.016.01,0,.019.002.026.008.005.004.009.011.013.021l-.017.007c-.002-.006-.004-.01-.008-.013-.004-.003-.008-.004-.012-.004-.007,0-.012.004-.015.01-.004.006-.005.016-.003.029.001.014.004.023.009.029.005.005.01.008.017.007.005,0,.009-.003.012-.007.001-.004.002-.01.003-.018h0ZM8.979,13.058h-.02s-.009-.023-.009-.023h-.036s-.006.026-.006.026h-.019s.03-.109.03-.109h.019s.041.106.041.106ZM8.944,13.016l-.014-.04-.01.041h.024ZM9.082,13.02l.017.007c-.003.012-.008.021-.014.026-.007.005-.014.008-.024.008-.012,0-.021-.005-.028-.014-.008-.011-.012-.025-.011-.042.001-.019.005-.033.014-.043.008-.009.018-.013.03-.013.01,0,.018.004.025.011.005.005.008.012.01.022l-.018.005c-.001-.006-.003-.01-.006-.014-.003-.003-.007-.005-.012-.005-.007,0-.012.003-.016.008-.004.006-.007.015-.007.028,0,.014.001.024.005.029.004.006.009.009.016.009.005,0,.009-.002.013-.005.002-.003.004-.009.006-.017h0ZM9.114,13.062l.009-.109.066.006-.002.018-.048-.004-.002.024.045.004-.002.018-.045-.004-.003.03.05.004-.002.018-.066-.005ZM9.197,13.069l.015-.108.017.003.026.077.01-.072.017.002-.015.108-.018-.003-.026-.075-.01.07-.016-.002ZM9.306,13.087l.018-.089-.026-.005.004-.018.07.014-.004.018-.026-.005-.018.089-.018-.004ZM9.361,13.098l.028-.105.037.01c.009.003.016.005.019.008.004.003.006.007.007.012s.001.011-.001.018c-.002.008-.006.014-.011.018s-.012.006-.019.005c.003.004.005.007.007.011.002.004.003.01.005.02l.005.023-.021-.005-.007-.026-.005-.018s-.002-.004-.004-.006c-.002,0-.004-.002-.008-.003h-.004s-.012.043-.012.043l-.016-.005ZM9.394,13.042l.013.003c.008.002.013.003.015.003s.004,0,.006-.003.003-.004.004-.008c.001-.003.001-.006,0-.009-.001-.002-.002-.004-.004-.006-.001,0-.006-.002-.014-.005l-.014-.004-.006.029ZM9.524,13.148l-.019-.006v-.026s-.033-.012-.033-.012l-.015.021-.018-.006.068-.092.018.006v.115ZM9.507,13.096l.002-.042-.025.034.023.008ZM9.533,13.152l.043-.099.016.007-.036.082.041.018-.007.017-.057-.025Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCr);
export default __webpack_public_path__ + "static/media/CR.54ef8fff280384456cb15464106e4878.svg";
export { ForwardRef as ReactComponent };